/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

// utils/Property.js
function property(meta = {}) {
    return function (target, key) {
        const ctor = target.constructor;
        if (!Object.prototype.hasOwnProperty.call(ctor, 'properties')) {
            ctor.properties = {};
        }
        ctor.properties[key] = meta;
    };
}
function getProperties(object) {
    const props = {};
    let ctor = typeof object === 'function'
        ? object
        : object?.constructor;
    const chain = [];
    while (ctor && ctor !== Function.prototype) {
        chain.unshift(ctor);
        ctor = Object.getPrototypeOf(ctor);
    }
    for (const c of chain) {
        if (c.properties) {
            Object.assign(props, c.properties);
        }
    }
    return props;
}

class BaseObject {
    serialize() {
        const serializeValue = (value, meta) => {
            if (value === null || value === undefined) {
                return value;
            }
            if (meta.type === 'array' && Array.isArray(value)) {
                return value.map(entry => {
                    if (entry && typeof entry.serialize === 'function') {
                        return entry.serialize();
                    }
                    return entry;
                });
            }
            if (meta.type === 'assets_selector' && Array.isArray(value)) {
                return value.map(asset => {
                    return asset.path;
                });
            }
            if (meta.type === 'asset_selector') {
                return value?.path ?? null;
            }
            if (typeof value.serialize === 'function') {
                return value.serialize();
            }
            return value;
        };
        const props = getProperties(this);
        const serializedProps = {};
        for (const name in props) {
            serializedProps[name] = serializeValue(this[name], props[name]);
        }
        return serializedProps;
    }
}
__decorate([
    property({ type: 'string', category: 'Object' })
], BaseObject.prototype, "uuid", void 0);
__decorate([
    property({ type: 'string', category: 'Object' })
], BaseObject.prototype, "type", void 0);
__decorate([
    property({ type: 'string', category: 'Object' })
], BaseObject.prototype, "name", void 0);

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
const EPSILON = 0.000001;
let ARRAY_TYPE = (typeof Float32Array !== 'undefined') ? Float32Array : Array;
const RANDOM = Math.random;

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 4x4 Matrix
 * @module mat4
 */
/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */
function create$6() {
    let out = new ARRAY_TYPE(16);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */
function clone$6(a) {
    let out = new ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function copy$6(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */
function fromValues$6(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    let out = new ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */
function set$6(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */
function identity$3(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function transpose$2(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a03 = a[3];
        let a12 = a[6], a13 = a[7];
        let a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    }
    else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function invert$3(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function adjoint$2(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
    out[8] = (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
    return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant$2(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function multiply$6(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
function translate$1(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    }
    else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/
function scale$6(out, a, v) {
    let x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function rotate$2(out, a, rad, axis) {
    let x = axis[0], y = axis[1], z = axis[2];
    let len = Math.sqrt(x * x + y * y + z * z);
    let s, c, t;
    let a00, a01, a02, a03;
    let a10, a11, a12, a13;
    let a20, a21, a22, a23;
    let b00, b01, b02;
    let b10, b11, b12;
    let b20, b21, b22;
    if (Math.abs(len) < EPSILON) {
        return null;
    }
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateX$2(out, a, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    let a10 = a[4];
    let a11 = a[5];
    let a12 = a[6];
    let a13 = a[7];
    let a20 = a[8];
    let a21 = a[9];
    let a22 = a[10];
    let a23 = a[11];
    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateY$2(out, a, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    let a00 = a[0];
    let a01 = a[1];
    let a02 = a[2];
    let a03 = a[3];
    let a20 = a[8];
    let a21 = a[9];
    let a22 = a[10];
    let a23 = a[11];
    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateZ$2(out, a, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    let a00 = a[0];
    let a01 = a[1];
    let a02 = a[2];
    let a03 = a[3];
    let a10 = a[4];
    let a11 = a[5];
    let a12 = a[6];
    let a13 = a[7];
    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromTranslation$1(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Scaling vector
 * @returns {mat4} out
 */
function fromScaling$2(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function fromRotation$2(out, rad, axis) {
    let x = axis[0], y = axis[1], z = axis[2];
    let len = Math.sqrt(x * x + y * y + z * z);
    let s, c, t;
    if (Math.abs(len) < EPSILON) {
        return null;
    }
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromXRotation(out, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromYRotation(out, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromZRotation(out, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromRotationTranslation(out, q, v) {
    // Quaternion math
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let xy = x * y2;
    let xz = x * z2;
    let yy = y * y2;
    let yz = y * z2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {mat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */
function getTranslation(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {mat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */
function getScaling(out, mat) {
    let m11 = mat[0];
    let m12 = mat[1];
    let m13 = mat[2];
    let m21 = mat[4];
    let m22 = mat[5];
    let m23 = mat[6];
    let m31 = mat[8];
    let m32 = mat[9];
    let m33 = mat[10];
    out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {mat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */
function getRotation(out, mat) {
    // Algorithm taken from http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
    let trace = mat[0] + mat[5] + mat[10];
    let S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (mat[6] - mat[9]) / S;
        out[1] = (mat[8] - mat[2]) / S;
        out[2] = (mat[1] - mat[4]) / S;
    }
    else if ((mat[0] > mat[5]) & (mat[0] > mat[10])) {
        S = Math.sqrt(1.0 + mat[0] - mat[5] - mat[10]) * 2;
        out[3] = (mat[6] - mat[9]) / S;
        out[0] = 0.25 * S;
        out[1] = (mat[1] + mat[4]) / S;
        out[2] = (mat[8] + mat[2]) / S;
    }
    else if (mat[5] > mat[10]) {
        S = Math.sqrt(1.0 + mat[5] - mat[0] - mat[10]) * 2;
        out[3] = (mat[8] - mat[2]) / S;
        out[0] = (mat[1] + mat[4]) / S;
        out[1] = 0.25 * S;
        out[2] = (mat[6] + mat[9]) / S;
    }
    else {
        S = Math.sqrt(1.0 + mat[10] - mat[0] - mat[5]) * 2;
        out[3] = (mat[1] - mat[4]) / S;
        out[0] = (mat[8] + mat[2]) / S;
        out[1] = (mat[6] + mat[9]) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @returns {mat4} out
 */
function fromRotationTranslationScale(out, q, v, s) {
    // Quaternion math
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let xy = x * y2;
    let xz = x * z2;
    let yy = y * y2;
    let yz = y * z2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    let sx = s[0];
    let sy = s[1];
    let sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @param {vec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */
function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
    // Quaternion math
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let xy = x * y2;
    let xz = x * z2;
    let yy = y * y2;
    let yz = y * z2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    let sx = s[0];
    let sy = s[1];
    let sz = s[2];
    let ox = o[0];
    let oy = o[1];
    let oz = o[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0] + ox - (out[0] * ox + out[4] * oy + out[8] * oz);
    out[13] = v[1] + oy - (out[1] * ox + out[5] * oy + out[9] * oz);
    out[14] = v[2] + oz - (out[2] * ox + out[6] * oy + out[10] * oz);
    out[15] = 1;
    return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */
function fromQuat$1(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */
function frustum(out, left, right, bottom, top, near, far) {
    let rl = 1 / (right - left);
    let tb = 1 / (top - bottom);
    let nf = 1 / (near - far);
    out[0] = (near * 2) * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = (near * 2) * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (far * near * 2) * nf;
    out[15] = 0;
    return out;
}
/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspective(out, fovy, aspect, near, far) {
    let f = 1.0 / Math.tan(fovy / 2);
    let nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (2 * far * near) * nf;
    out[15] = 0;
    return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspectiveFromFieldOfView(out, fov, near, far) {
    let upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    let downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    let leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    let rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    let xScale = 2.0 / (leftTan + rightTan);
    let yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = ((upTan - downTan) * yScale * 0.5);
    out[10] = far / (near - far);
    out[11] = -1.0;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = (far * near) / (near - far);
    out[15] = 0.0;
    return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function ortho(out, left, right, bottom, top, near, far) {
    let lr = 1 / (left - right);
    let bt = 1 / (bottom - top);
    let nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
function lookAt(out, eye, center, up) {
    let x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    let eyex = eye[0];
    let eyey = eye[1];
    let eyez = eye[2];
    let upx = up[0];
    let upy = up[1];
    let upz = up[2];
    let centerx = center[0];
    let centery = center[1];
    let centerz = center[2];
    if (Math.abs(eyex - centerx) < EPSILON &&
        Math.abs(eyey - centery) < EPSILON &&
        Math.abs(eyez - centerz) < EPSILON) {
        return identity$3(out);
    }
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    }
    else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    }
    else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
function targetTo(out, eye, target, up) {
    let eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    let z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    let len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    let x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {mat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str$6(a) {
    return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' +
        a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' +
        a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' +
        a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {mat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob$2(a) {
    return (Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2) + Math.pow(a[9], 2) + Math.pow(a[10], 2) + Math.pow(a[11], 2) + Math.pow(a[12], 2) + Math.pow(a[13], 2) + Math.pow(a[14], 2) + Math.pow(a[15], 2)));
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function add$6(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function subtract$5(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */
function multiplyScalar$2(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */
function multiplyScalarAndAdd$2(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    out[4] = a[4] + (b[4] * scale);
    out[5] = a[5] + (b[5] * scale);
    out[6] = a[6] + (b[6] * scale);
    out[7] = a[7] + (b[7] * scale);
    out[8] = a[8] + (b[8] * scale);
    out[9] = a[9] + (b[9] * scale);
    out[10] = a[10] + (b[10] * scale);
    out[11] = a[11] + (b[11] * scale);
    out[12] = a[12] + (b[12] * scale);
    out[13] = a[13] + (b[13] * scale);
    out[14] = a[14] + (b[14] * scale);
    out[15] = a[15] + (b[15] * scale);
    return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals$6(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] &&
        a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] &&
        a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] &&
        a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals$6(a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    let a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    let a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    let b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    let b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    let b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
        Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
        Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
        Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
        Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
        Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
        Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
        Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) &&
        Math.abs(a9 - b9) <= EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) &&
        Math.abs(a10 - b10) <= EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) &&
        Math.abs(a11 - b11) <= EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) &&
        Math.abs(a12 - b12) <= EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) &&
        Math.abs(a13 - b13) <= EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) &&
        Math.abs(a14 - b14) <= EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) &&
        Math.abs(a15 - b15) <= EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15)));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */
const mul$6 = multiply$6;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */
const sub$5 = subtract$5;

var mat4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$6,
  clone: clone$6,
  copy: copy$6,
  fromValues: fromValues$6,
  set: set$6,
  identity: identity$3,
  transpose: transpose$2,
  invert: invert$3,
  adjoint: adjoint$2,
  determinant: determinant$2,
  multiply: multiply$6,
  translate: translate$1,
  scale: scale$6,
  rotate: rotate$2,
  rotateX: rotateX$2,
  rotateY: rotateY$2,
  rotateZ: rotateZ$2,
  fromTranslation: fromTranslation$1,
  fromScaling: fromScaling$2,
  fromRotation: fromRotation$2,
  fromXRotation: fromXRotation,
  fromYRotation: fromYRotation,
  fromZRotation: fromZRotation,
  fromRotationTranslation: fromRotationTranslation,
  getTranslation: getTranslation,
  getScaling: getScaling,
  getRotation: getRotation,
  fromRotationTranslationScale: fromRotationTranslationScale,
  fromRotationTranslationScaleOrigin: fromRotationTranslationScaleOrigin,
  fromQuat: fromQuat$1,
  frustum: frustum,
  perspective: perspective,
  perspectiveFromFieldOfView: perspectiveFromFieldOfView,
  ortho: ortho,
  lookAt: lookAt,
  targetTo: targetTo,
  str: str$6,
  frob: frob$2,
  add: add$6,
  subtract: subtract$5,
  multiplyScalar: multiplyScalar$2,
  multiplyScalarAndAdd: multiplyScalarAndAdd$2,
  exactEquals: exactEquals$6,
  equals: equals$6,
  mul: mul$6,
  sub: sub$5
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 3 Dimensional Vector
 * @module vec3
 */
/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */
function create$5() {
    let out = new ARRAY_TYPE(3);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */
function clone$5(a) {
    var out = new ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */
function length$3(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */
function fromValues$5(x, y, z) {
    let out = new ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */
function copy$5(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */
function set$5(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function add$5(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function subtract$4(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function multiply$5(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function divide$2(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to ceil
 * @returns {vec3} out
 */
function ceil$2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to floor
 * @returns {vec3} out
 */
function floor$2(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function min$2(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function max$2(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to round
 * @returns {vec3} out
 */
function round$2(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */
function scale$5(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */
function scaleAndAdd$2(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */
function distance$2(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance$2(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength$3(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */
function negate$2(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */
function inverse$2(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */
function normalize$3(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let len = x * x + y * y + z * z;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot$3(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function cross$1(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2];
    let bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function lerp$3(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function hermite(out, a, b, c, d, t) {
    let factorTimes2 = t * t;
    let factor1 = factorTimes2 * (2 * t - 3) + 1;
    let factor2 = factorTimes2 * (t - 2) + t;
    let factor3 = factorTimes2 * (t - 1);
    let factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function bezier(out, a, b, c, d, t) {
    let inverseFactor = 1 - t;
    let inverseFactorTimesTwo = inverseFactor * inverseFactor;
    let factorTimes2 = t * t;
    let factor1 = inverseFactorTimesTwo * inverseFactor;
    let factor2 = 3 * t * inverseFactorTimesTwo;
    let factor3 = 3 * factorTimes2 * inverseFactor;
    let factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */
function random$2(out, scale) {
    scale = scale || 1.0;
    let r = RANDOM() * 2.0 * Math.PI;
    let z = (RANDOM() * 2.0) - 1.0;
    let zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */
function transformMat4$2(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    let w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */
function transformMat3$1(out, a, m) {
    let x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
/**
 * Transforms the vec3 with a quat
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec3} out
 */
function transformQuat$1(out, a, q) {
    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
    let x = a[0], y = a[1], z = a[2];
    let qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    // calculate quat * vec
    let ix = qw * x + qy * z - qz * y;
    let iy = qw * y + qz * x - qx * z;
    let iz = qw * z + qx * y - qy * x;
    let iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateX$1(out, a, b, c) {
    let p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(c) - p[2] * Math.sin(c);
    r[2] = p[1] * Math.sin(c) + p[2] * Math.cos(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateY$1(out, a, b, c) {
    let p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(c) + p[0] * Math.cos(c);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(c) - p[0] * Math.sin(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateZ$1(out, a, b, c) {
    let p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(c) - p[1] * Math.sin(c);
    r[1] = p[0] * Math.sin(c) + p[1] * Math.cos(c);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */
function angle(a, b) {
    let tempA = fromValues$5(a[0], a[1], a[2]);
    let tempB = fromValues$5(b[0], b[1], b[2]);
    normalize$3(tempA, tempA);
    normalize$3(tempB, tempB);
    let cosine = dot$3(tempA, tempB);
    if (cosine > 1.0) {
        return 0;
    }
    else if (cosine < -1.0) {
        return Math.PI;
    }
    else {
        return Math.acos(cosine);
    }
}
/**
 * Returns a string representation of a vector
 *
 * @param {vec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$5(a) {
    return 'vec3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')';
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$5(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$5(a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2];
    let b0 = b[0], b1 = b[1], b2 = b[2];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
        Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */
const sub$4 = subtract$4;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */
const mul$5 = multiply$5;
/**
 * Alias for {@link vec3.divide}
 * @function
 */
const div$2 = divide$2;
/**
 * Alias for {@link vec3.distance}
 * @function
 */
const dist$2 = distance$2;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */
const sqrDist$2 = squaredDistance$2;
/**
 * Alias for {@link vec3.length}
 * @function
 */
const len$3 = length$3;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */
const sqrLen$3 = squaredLength$3;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach$2 = (function () {
    let vec = create$5();
    return function (a, stride, offset, count, fn, arg) {
        let i, l;
        if (!stride) {
            stride = 3;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min((count * stride) + offset, a.length);
        }
        else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
})();

var vec3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$5,
  clone: clone$5,
  length: length$3,
  fromValues: fromValues$5,
  copy: copy$5,
  set: set$5,
  add: add$5,
  subtract: subtract$4,
  multiply: multiply$5,
  divide: divide$2,
  ceil: ceil$2,
  floor: floor$2,
  min: min$2,
  max: max$2,
  round: round$2,
  scale: scale$5,
  scaleAndAdd: scaleAndAdd$2,
  distance: distance$2,
  squaredDistance: squaredDistance$2,
  squaredLength: squaredLength$3,
  negate: negate$2,
  inverse: inverse$2,
  normalize: normalize$3,
  dot: dot$3,
  cross: cross$1,
  lerp: lerp$3,
  hermite: hermite,
  bezier: bezier,
  random: random$2,
  transformMat4: transformMat4$2,
  transformMat3: transformMat3$1,
  transformQuat: transformQuat$1,
  rotateX: rotateX$1,
  rotateY: rotateY$1,
  rotateZ: rotateZ$1,
  angle: angle,
  str: str$5,
  exactEquals: exactEquals$5,
  equals: equals$5,
  sub: sub$4,
  mul: mul$5,
  div: div$2,
  dist: dist$2,
  sqrDist: sqrDist$2,
  len: len$3,
  sqrLen: sqrLen$3,
  forEach: forEach$2
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 3x3 Matrix
 * @module mat3
 */
/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */
function create$4() {
    let out = new ARRAY_TYPE(9);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {mat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */
function fromMat4(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {mat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */
function clone$4(a) {
    let out = new ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function copy$4(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */
function fromValues$4(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    let out = new ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */
function set$4(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */
function identity$2(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function transpose$1(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        let a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    }
    else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function invert$2(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b01 = a22 * a11 - a12 * a21;
    let b11 = -a22 * a10 + a12 * a20;
    let b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    let det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function adjoint$1(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = (a11 * a22 - a12 * a21);
    out[1] = (a02 * a21 - a01 * a22);
    out[2] = (a01 * a12 - a02 * a11);
    out[3] = (a12 * a20 - a10 * a22);
    out[4] = (a00 * a22 - a02 * a20);
    out[5] = (a02 * a10 - a00 * a12);
    out[6] = (a10 * a21 - a11 * a20);
    out[7] = (a01 * a20 - a00 * a21);
    out[8] = (a00 * a11 - a01 * a10);
    return out;
}
/**
 * Calculates the determinant of a mat3
 *
 * @param {mat3} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant$1(a) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function multiply$4(out, a, b) {
    let a00 = a[0], a01 = a[1], a02 = a[2];
    let a10 = a[3], a11 = a[4], a12 = a[5];
    let a20 = a[6], a21 = a[7], a22 = a[8];
    let b00 = b[0], b01 = b[1], b02 = b[2];
    let b10 = b[3], b11 = b[4], b12 = b[5];
    let b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to translate
 * @param {vec2} v vector to translate by
 * @returns {mat3} out
 */
function translate(out, a, v) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
function rotate$1(out, a, rad) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/
function scale$4(out, a, v) {
    let x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Translation vector
 * @returns {mat3} out
 */
function fromTranslation(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
function fromRotation$1(out, rad) {
    let s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat3} out
 */
function fromScaling$1(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat2d} a the matrix to copy
 * @returns {mat3} out
 **/
function fromMat2d(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
/**
* Calculates a 3x3 matrix from the given quaternion
*
* @param {mat3} out mat3 receiving operation result
* @param {quat} q Quaternion to create matrix from
*
* @returns {mat3} out
*/
function fromQuat(out, q) {
    let x = q[0], y = q[1], z = q[2], w = q[3];
    let x2 = x + x;
    let y2 = y + y;
    let z2 = z + z;
    let xx = x * x2;
    let yx = y * x2;
    let yy = y * y2;
    let zx = z * x2;
    let zy = z * y2;
    let zz = z * z2;
    let wx = w * x2;
    let wy = w * y2;
    let wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
/**
* Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
*
* @param {mat3} out mat3 receiving operation result
* @param {mat4} a Mat4 to derive the normal matrix from
*
* @returns {mat3} out
*/
function normalFromMat4(out, a) {
    let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */
function projection(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
/**
 * Returns a string representation of a mat3
 *
 * @param {mat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str$4(a) {
    return 'mat3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' +
        a[3] + ', ' + a[4] + ', ' + a[5] + ', ' +
        a[6] + ', ' + a[7] + ', ' + a[8] + ')';
}
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {mat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob$1(a) {
    return (Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2)));
}
/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function add$4(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function subtract$3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */
function multiplyScalar$1(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */
function multiplyScalarAndAdd$1(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    out[4] = a[4] + (b[4] * scale);
    out[5] = a[5] + (b[5] * scale);
    out[6] = a[6] + (b[6] * scale);
    out[7] = a[7] + (b[7] * scale);
    out[8] = a[8] + (b[8] * scale);
    return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals$4(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] &&
        a[3] === b[3] && a[4] === b[4] && a[5] === b[5] &&
        a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals$4(a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
        Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
        Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
        Math.abs(a4 - b4) <= EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
        Math.abs(a5 - b5) <= EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
        Math.abs(a6 - b6) <= EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
        Math.abs(a7 - b7) <= EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
        Math.abs(a8 - b8) <= EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)));
}
/**
 * Alias for {@link mat3.multiply}
 * @function
 */
const mul$4 = multiply$4;
/**
 * Alias for {@link mat3.subtract}
 * @function
 */
const sub$3 = subtract$3;

var mat3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$4,
  fromMat4: fromMat4,
  clone: clone$4,
  copy: copy$4,
  fromValues: fromValues$4,
  set: set$4,
  identity: identity$2,
  transpose: transpose$1,
  invert: invert$2,
  adjoint: adjoint$1,
  determinant: determinant$1,
  multiply: multiply$4,
  translate: translate,
  rotate: rotate$1,
  scale: scale$4,
  fromTranslation: fromTranslation,
  fromRotation: fromRotation$1,
  fromScaling: fromScaling$1,
  fromMat2d: fromMat2d,
  fromQuat: fromQuat,
  normalFromMat4: normalFromMat4,
  projection: projection,
  str: str$4,
  frob: frob$1,
  add: add$4,
  subtract: subtract$3,
  multiplyScalar: multiplyScalar$1,
  multiplyScalarAndAdd: multiplyScalarAndAdd$1,
  exactEquals: exactEquals$4,
  equals: equals$4,
  mul: mul$4,
  sub: sub$3
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 4 Dimensional Vector
 * @module vec4
 */
/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */
function create$3() {
    let out = new ARRAY_TYPE(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    return out;
}
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {vec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */
function clone$3(a) {
    let out = new ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */
function fromValues$3(x, y, z, w) {
    let out = new ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the source vector
 * @returns {vec4} out
 */
function copy$3(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */
function set$3(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function add$3(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function subtract$2(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function multiply$3(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function divide$1(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to ceil
 * @returns {vec4} out
 */
function ceil$1(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to floor
 * @returns {vec4} out
 */
function floor$1(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function min$1(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function max$1(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to round
 * @returns {vec4} out
 */
function round$1(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */
function scale$3(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */
function scaleAndAdd$1(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    return out;
}
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} distance between a and b
 */
function distance$1(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    let w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance$1(a, b) {
    let x = b[0] - a[0];
    let y = b[1] - a[1];
    let z = b[2] - a[2];
    let w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
/**
 * Calculates the length of a vec4
 *
 * @param {vec4} a vector to calculate length of
 * @returns {Number} length of a
 */
function length$2(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
/**
 * Calculates the squared length of a vec4
 *
 * @param {vec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength$2(a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    return x * x + y * y + z * z + w * w;
}
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to negate
 * @returns {vec4} out
 */
function negate$1(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to invert
 * @returns {vec4} out
 */
function inverse$1(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to normalize
 * @returns {vec4} out
 */
function normalize$2(out, a) {
    let x = a[0];
    let y = a[1];
    let z = a[2];
    let w = a[3];
    let len = x * x + y * y + z * z + w * w;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        out[0] = x * len;
        out[1] = y * len;
        out[2] = z * len;
        out[3] = w * len;
    }
    return out;
}
/**
 * Calculates the dot product of two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot$2(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec4} out
 */
function lerp$2(out, a, b, t) {
    let ax = a[0];
    let ay = a[1];
    let az = a[2];
    let aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */
function random$1(out, vectorScale) {
    vectorScale = vectorScale || 1.0;
    //TODO: This is a pretty awful way of doing this. Find something better.
    out[0] = RANDOM();
    out[1] = RANDOM();
    out[2] = RANDOM();
    out[3] = RANDOM();
    normalize$2(out, out);
    scale$3(out, out, vectorScale);
    return out;
}
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */
function transformMat4$1(out, a, m) {
    let x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec4} out
 */
function transformQuat(out, a, q) {
    let x = a[0], y = a[1], z = a[2];
    let qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    // calculate quat * vec
    let ix = qw * x + qy * z - qz * y;
    let iy = qw * y + qz * x - qx * z;
    let iz = qw * z + qx * y - qy * x;
    let iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {vec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$3(a) {
    return 'vec4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$3(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$3(a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
        Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
        Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)));
}
/**
 * Alias for {@link vec4.subtract}
 * @function
 */
const sub$2 = subtract$2;
/**
 * Alias for {@link vec4.multiply}
 * @function
 */
const mul$3 = multiply$3;
/**
 * Alias for {@link vec4.divide}
 * @function
 */
const div$1 = divide$1;
/**
 * Alias for {@link vec4.distance}
 * @function
 */
const dist$1 = distance$1;
/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */
const sqrDist$1 = squaredDistance$1;
/**
 * Alias for {@link vec4.length}
 * @function
 */
const len$2 = length$2;
/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */
const sqrLen$2 = squaredLength$2;
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach$1 = (function () {
    let vec = create$3();
    return function (a, stride, offset, count, fn, arg) {
        let i, l;
        if (!stride) {
            stride = 4;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min((count * stride) + offset, a.length);
        }
        else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
})();

var vec4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$3,
  clone: clone$3,
  fromValues: fromValues$3,
  copy: copy$3,
  set: set$3,
  add: add$3,
  subtract: subtract$2,
  multiply: multiply$3,
  divide: divide$1,
  ceil: ceil$1,
  floor: floor$1,
  min: min$1,
  max: max$1,
  round: round$1,
  scale: scale$3,
  scaleAndAdd: scaleAndAdd$1,
  distance: distance$1,
  squaredDistance: squaredDistance$1,
  length: length$2,
  squaredLength: squaredLength$2,
  negate: negate$1,
  inverse: inverse$1,
  normalize: normalize$2,
  dot: dot$2,
  lerp: lerp$2,
  random: random$1,
  transformMat4: transformMat4$1,
  transformQuat: transformQuat,
  str: str$3,
  exactEquals: exactEquals$3,
  equals: equals$3,
  sub: sub$2,
  mul: mul$3,
  div: div$1,
  dist: dist$1,
  sqrDist: sqrDist$1,
  len: len$2,
  sqrLen: sqrLen$2,
  forEach: forEach$1
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * Quaternion
 * @module quat
 */
/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */
function create$2() {
    let out = new ARRAY_TYPE(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */
function identity$1(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {vec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/
function setAxisAngle(out, axis, rad) {
    rad = rad * 0.5;
    let s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {quat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */
function getAxisAngle(out_axis, q) {
    let rad = Math.acos(q[3]) * 2.0;
    let s = Math.sin(rad / 2.0);
    if (s != 0.0) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    }
    else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 */
function multiply$2(out, a, b) {
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateX(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateY(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateZ(out, a, rad) {
    rad *= 0.5;
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate W component of
 * @returns {quat} out
 */
function calculateW(out, a) {
    let x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 */
function slerp(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    let ax = a[0], ay = a[1], az = a[2], aw = a[3];
    let bx = b[0], by = b[1], bz = b[2], bw = b[3];
    let omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if ((1.0 - cosom) > 0.000001) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    }
    else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate inverse of
 * @returns {quat} out
 */
function invert$1(out, a) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    let invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate conjugate of
 * @returns {quat} out
 */
function conjugate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {mat3} m rotation matrix
 * @returns {quat} out
 * @function
 */
function fromMat3(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    let fTrace = m[0] + m[4] + m[8];
    let fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    }
    else {
        // |w| <= 1/2
        let i = 0;
        if (m[4] > m[0])
            i = 1;
        if (m[8] > m[i * 3 + i])
            i = 2;
        let j = (i + 1) % 3;
        let k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
/**
 * Creates a quaternion from the given euler angle x, y, z.
 *
 * @param {quat} out the receiving quaternion
 * @param {x} Angle to rotate around X axis in degrees.
 * @param {y} Angle to rotate around Y axis in degrees.
 * @param {z} Angle to rotate around Z axis in degrees.
 * @returns {quat} out
 * @function
 */
function fromEuler(out, x, y, z) {
    let halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    let sx = Math.sin(x);
    let cx = Math.cos(x);
    let sy = Math.sin(y);
    let cy = Math.cos(y);
    let sz = Math.sin(z);
    let cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
/**
 * Returns a string representation of a quatenion
 *
 * @param {quat} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$2(a) {
    return 'quat(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {quat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */
const clone$2 = clone$3;
/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */
const fromValues$2 = fromValues$3;
/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the source quaternion
 * @returns {quat} out
 * @function
 */
const copy$2 = copy$3;
/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */
const set$2 = set$3;
/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 * @function
 */
const add$2 = add$3;
/**
 * Alias for {@link quat.multiply}
 * @function
 */
const mul$2 = multiply$2;
/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {quat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */
const scale$2 = scale$3;
/**
 * Calculates the dot product of two quat's
 *
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */
const dot$1 = dot$2;
/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 * @function
 */
const lerp$1 = lerp$2;
/**
 * Calculates the length of a quat
 *
 * @param {quat} a vector to calculate length of
 * @returns {Number} length of a
 */
const length$1 = length$2;
/**
 * Alias for {@link quat.length}
 * @function
 */
const len$1 = length$1;
/**
 * Calculates the squared length of a quat
 *
 * @param {quat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */
const squaredLength$1 = squaredLength$2;
/**
 * Alias for {@link quat.squaredLength}
 * @function
 */
const sqrLen$1 = squaredLength$1;
/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */
const normalize$1 = normalize$2;
/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {quat} a The first quaternion.
 * @param {quat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
const exactEquals$2 = exactEquals$3;
/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {quat} a The first vector.
 * @param {quat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
const equals$2 = equals$3;
/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {vec3} a the initial vector
 * @param {vec3} b the destination vector
 * @returns {quat} out
 */
const rotationTo = (function () {
    let tmpvec3 = create$5();
    let xUnitVec3 = fromValues$5(1, 0, 0);
    let yUnitVec3 = fromValues$5(0, 1, 0);
    return function (out, a, b) {
        let dot = dot$3(a, b);
        if (dot < -0.999999) {
            cross$1(tmpvec3, xUnitVec3, a);
            if (len$3(tmpvec3) < 0.000001)
                cross$1(tmpvec3, yUnitVec3, a);
            normalize$3(tmpvec3, tmpvec3);
            setAxisAngle(out, tmpvec3, Math.PI);
            return out;
        }
        else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        }
        else {
            cross$1(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return normalize$1(out, out);
        }
    };
})();
/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {quat} c the third operand
 * @param {quat} d the fourth operand
 * @param {Number} t interpolation amount
 * @returns {quat} out
 */
const sqlerp = (function () {
    let temp1 = create$2();
    let temp2 = create$2();
    return function (out, a, b, c, d, t) {
        slerp(temp1, a, d, t);
        slerp(temp2, b, c, t);
        slerp(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}());
/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {vec3} view  the vector representing the viewing direction
 * @param {vec3} right the vector representing the local "right" direction
 * @param {vec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */
const setAxes = (function () {
    let matr = create$4();
    return function (out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return normalize$1(out, fromMat3(out, matr));
    };
})();

var quat = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$2,
  identity: identity$1,
  setAxisAngle: setAxisAngle,
  getAxisAngle: getAxisAngle,
  multiply: multiply$2,
  rotateX: rotateX,
  rotateY: rotateY,
  rotateZ: rotateZ,
  calculateW: calculateW,
  slerp: slerp,
  invert: invert$1,
  conjugate: conjugate,
  fromMat3: fromMat3,
  fromEuler: fromEuler,
  str: str$2,
  clone: clone$2,
  fromValues: fromValues$2,
  copy: copy$2,
  set: set$2,
  add: add$2,
  mul: mul$2,
  scale: scale$2,
  dot: dot$1,
  lerp: lerp$1,
  length: length$1,
  len: len$1,
  squaredLength: squaredLength$1,
  sqrLen: sqrLen$1,
  normalize: normalize$1,
  exactEquals: exactEquals$2,
  equals: equals$2,
  rotationTo: rotationTo,
  sqlerp: sqlerp,
  setAxes: setAxes
});

// http://www.broofa.com/Tools/Math.uuid.htm
var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
var uuid = new Array(36);
var rnd = 0, r;
function generateUUID() {
    for (var i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid[i] = '-';
        }
        else if (i === 14) {
            uuid[i] = '4';
        }
        else {
            if (rnd <= 0x02)
                rnd = 0x2000000 + (Math.random() * 0x1000000) | 0;
            r = rnd & 0xf;
            rnd = rnd >> 4;
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
        }
    }
    return uuid.join('');
}

class Vector3 {
    constructor(x = 0, y = 0, z = 0, onChange = null) {
        this._v = new Float32Array([x, y, z]);
        this._onChange = onChange;
    }
    get 0() { return this._v[0]; }
    set 0(v) { if (this._v[0] !== v) {
        this._v[0] = v;
        this._onChange?.();
    } }
    get 1() { return this._v[1]; }
    set 1(v) { if (this._v[1] !== v) {
        this._v[1] = v;
        this._onChange?.();
    } }
    get 2() { return this._v[2]; }
    set 2(v) { if (this._v[2] !== v) {
        this._v[2] = v;
        this._onChange?.();
    } }
    get length() { return 3; }
    copy(v, defaults = [0, 0, 0]) {
        this[0] = v?.[0] ?? defaults[0];
        this[1] = v?.[1] ?? defaults[1];
        this[2] = v?.[2] ?? defaults[2];
        return this;
    }
    toString() {
        return this._v.toString();
    }
    toArray() {
        return Array.from(this._v);
    }
    [Symbol.iterator]() {
        return this._v[Symbol.iterator]();
    }
    serialize() {
        return [
            this[0],
            this[1],
            this[2]
        ];
    }
}

class Quaternion {
    constructor(x = 0, y = 0, z = 0, w = 1, onChange = null) {
        this._v = new Float32Array([x, y, z, w]);
        this._onChange = onChange;
    }
    get 0() { return this._v[0]; }
    set 0(v) { if (this._v[0] !== v) {
        this._v[0] = v;
        this._onChange?.();
    } }
    get 1() { return this._v[1]; }
    set 1(v) { if (this._v[1] !== v) {
        this._v[1] = v;
        this._onChange?.();
    } }
    get 2() { return this._v[2]; }
    set 2(v) { if (this._v[2] !== v) {
        this._v[2] = v;
        this._onChange?.();
    } }
    get 3() { return this._v[3]; }
    set 3(v) { if (this._v[3] !== v) {
        this._v[3] = v;
        this._onChange?.();
    } }
    get length() { return 4; }
    copy(v, defaults = [0, 0, 0, 1]) {
        this[0] = v?.[0] ?? defaults[0];
        this[1] = v?.[1] ?? defaults[1];
        this[2] = v?.[2] ?? defaults[2];
        this[3] = v?.[3] ?? defaults[3];
        return this;
    }
    toString() {
        return this._v.toString();
    }
    toArray() {
        return Array.from(this._v);
    }
    [Symbol.iterator]() {
        return this._v[Symbol.iterator]();
    }
    serialize() {
        return [
            this[0],
            this[1],
            this[2],
            this[3]
        ];
    }
}

function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
}
function quatToEulerXYZ(out, q, tempMat4) {
    fromQuat$1(tempMat4, q);
    // glMatrix mat4 is column-major
    const m11 = tempMat4[0], m12 = tempMat4[4], m13 = tempMat4[8];
    const m22 = tempMat4[5], m23 = tempMat4[9];
    const m32 = tempMat4[6], m33 = tempMat4[10];
    out[1] = Math.asin(clamp(m13, -1, 1));
    if (Math.abs(m13) < 0.9999999) {
        out[0] = Math.atan2(-m23, m33);
        out[2] = Math.atan2(-m12, m11);
    }
    else {
        out[0] = Math.atan2(m32, m22);
        out[2] = 0;
    }
    return out;
}
function quatFromEulerXYZ(out, x, y, z, qx, qy, qz) {
    setAxisAngle(qx, [1, 0, 0], x);
    setAxisAngle(qy, [0, 1, 0], y);
    setAxisAngle(qz, [0, 0, 1], z);
    multiply$2(out, qx, qy);
    multiply$2(out, out, qz);
    normalize$1(out, out);
    return out;
}
function defineObservable(instance, name, ObservableClass, defaults, onChange, nullable = false) {
    const key = `_${name}`;
    Object.defineProperty(instance, name, {
        get() {
            return this[key];
        },
        set(v) {
            if (v == null && nullable) {
                this[key] = null;
                this[onChange]();
                return;
            }
            if (!this[key]) {
                this[key] = new ObservableClass(...(defaults.map((d, i) => v?.[i] ?? d)), () => this[onChange]());
            }
            else {
                this[key].copy(v, defaults);
            }
            this[onChange]();
        },
        enumerable: true,
        configurable: true,
    });
}
function logs() {
    requestAnimationFrame(logs);
}
logs();
class Object3d extends BaseObject {
    constructor() {
        super();
        this.type = 'Object3D';
        this.uuid = generateUUID();
        this._quatToEulerMat4 = create$6();
        this._constructing = true;
        this._syncingRotation = false;
        this._qx = create$2();
        this._qy = create$2();
        this._qz = create$2();
        this._normalMatrix = create$6();
        this.matrix = create$6();
        this.worldMatrix = create$6();
        this.inverseWorldMatrix = create$6();
        this.worldMatrixRevision = 0;
        this._invLookatMat4 = create$6();
        this._rotationMat4 = create$6();
        this._lookAtMat4 = create$6();
        this.up = fromValues$5(0, 1, 0);
        this.name = '';
        defineObservable(this, 'position', Vector3, [0, 0, 0], '_transformChanged');
        defineObservable(this, 'rotation', Vector3, [0, 0, 0], '_rotationChanged');
        defineObservable(this, 'scale', Vector3, [1, 1, 1], '_transformChanged');
        defineObservable(this, 'quaternion', Quaternion, [0, 0, 0, 1], '_quaternionChanged');
        defineObservable(this, 'lookAt', Vector3, [0, 0, 0], '_transformChanged', true); //nullable=true
        this.position = fromValues$5(0, 0, 0);
        this.rotation = fromValues$5(0, 0, 0);
        this.scale = fromValues$5(1, 1, 1);
        this.quaternion = create$2();
        this.lookAt = null;
        this._constructing = false;
        this._rotationChanged();
        this.matrixNeedsUpdate = true;
        this.worldMatrixNeedsUpdate = true;
    }
    _rotationChanged() {
        // if (window.skipObject3dWatch) {
        // return;
        // }
        if (this._constructing || this._syncingRotation || !this._quaternion)
            return;
        this._syncingRotation = true;
        quatFromEulerXYZ(this._quaternion, this._rotation[0], this._rotation[1], this._rotation[2], this._qx, this._qy, this._qz);
        this._syncingRotation = false;
        this.matrixNeedsUpdate = true;
        this.worldMatrixNeedsUpdate = true;
    }
    _quaternionChanged() {
        if (this._constructing || this._syncingRotation || !this._rotation)
            return;
        this._syncingRotation = true;
        normalize$1(this._quaternion, this._quaternion);
        quatToEulerXYZ(this._rotation, this._quaternion, this._quatToEulerMat4);
        this._syncingRotation = false;
        this.matrixNeedsUpdate = true;
        this.worldMatrixNeedsUpdate = true;
    }
    _transformChanged() {
        this.matrixNeedsUpdate = true;
        this.worldMatrixNeedsUpdate = true;
    }
    traverse(callback) {
        callback(this);
        this.children?.forEach(child => {
            child.traverse(callback);
        });
    }
    traverseVisible(callback) {
        if (this.visible === false)
            return;
        callback(this);
        this.children?.forEach(child => {
            child.traverseVisible(callback);
        });
    }
    // Note the fucntion name here 'updateMatrices' NOT 'updateWorldMatrix'
    // this is the method that checks if matrices needs update or not
    updateMatrices(force = false) {
        if (this.matrixNeedsUpdate) {
            this.updateMatrix();
            this.worldMatrixNeedsUpdate = true;
        }
        const worldDirty = force || this.worldMatrixNeedsUpdate;
        if (worldDirty) {
            this.updateWorldMatrix();
        }
        for (const child of this.children ?? []) {
            child.updateMatrices(worldDirty);
        }
    }
    updateMatrix() {
        identity$3(this.matrix);
        identity$3(this._rotationMat4);
        if (this.lookAt !== null) {
            lookAt(this.matrix, this.position, this.lookAt, this.up);
            invert$3(this.matrix, this.matrix);
            copy$6(this._rotationMat4, this.matrix);
            this._rotationMat4[12] = 0;
            this._rotationMat4[13] = 0;
            this._rotationMat4[14] = 0;
            scale$6(this.matrix, this.matrix, this.scale);
            this.matrixNeedsUpdate = false;
            return;
        }
        fromQuat$1(this._rotationMat4, this.quaternion);
        fromRotationTranslation(this.matrix, this.quaternion, this.position);
        scale$6(this.matrix, this.matrix, this.scale);
        this.matrixNeedsUpdate = false;
    }
    updateWorldMatrix() {
        if (this.parent) {
            multiply$6(this.worldMatrix, this.parent.worldMatrix, this.matrix);
        }
        else {
            copy$6(this.worldMatrix, this.matrix);
        }
        invert$3(this.inverseWorldMatrix, this.worldMatrix);
        copy$6(this._normalMatrix, this._rotationMat4);
        let n = this.parent;
        while (n) {
            multiply$6(this._normalMatrix, n._rotationMat4, this._normalMatrix);
            n = n.parent;
        }
        this.worldMatrixNeedsUpdate = false;
        this.worldMatrixRevision++;
    }
}
__decorate([
    property({ type: 'string', category: 'Object' })
], Object3d.prototype, "uuid", void 0);
__decorate([
    property({ type: 'string', category: 'Object' })
], Object3d.prototype, "type", void 0);
__decorate([
    property({ type: 'string', category: 'Object' })
], Object3d.prototype, "name", void 0);
__decorate([
    property({ type: 'vec3', category: 'Transform' })
], Object3d.prototype, "position", void 0);
__decorate([
    property({ type: 'vec3', category: 'Transform', step: 0.1 })
], Object3d.prototype, "rotation", void 0);
__decorate([
    property({ type: 'vec3', category: 'Transform' })
], Object3d.prototype, "scale", void 0);
__decorate([
    property({ type: 'vec3', category: 'Transform', nullable: true })
], Object3d.prototype, "lookAt", void 0);

let bindedBuffer$1 = null;
let isUsingBufferOrphaning = false;
class ArrayBuffer$2 {
    constructor(gl, data, size, element, type, name) {
        this.gl = gl;
        this.type = type || gl.FLOAT;
        this._buffer = gl.createBuffer();
        this._element = element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER';
        this._target = gl[element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER'];
        this.name = name;
        this.update(data, size);
    }
    update(data, size) {
        // if (this.hasCalledSubUpdate) {
        // 	console.warn('cannot call update() on an attribute after calling subUpdate()')
        // 	return;
        // }
        this.data = data;
        this.size = size;
        this.length = this.data.length;
        this.gl.bindBuffer(this._target, this._buffer);
        // any attribute starting with "instance" will is considered and instance attribute
        if (/^instance/.test(this.name)) {
            // Instance attributes are re-uploaded every frame (visible-instance
            // lists). bufferData reallocates the whole buffer each time, which
            // on a 390-draw scene meant ~300 reallocations/frame and caused
            // visible hitching whenever the camera moved. Reallocate only when
            // the buffer has to grow, otherwise upload in place.
            if (isUsingBufferOrphaning !== window.useBufferOrphaning) {
                console.log('BUFFER_ORPHANNING: ' + window.useBufferOrphaning);
                isUsingBufferOrphaning = window.useBufferOrphaning;
            }
            if (window.useBufferOrphaning) {
                const byteLength = this.data.byteLength ?? this.data.length * 4;
                if (!this._capacity || byteLength > this._capacity) {
                    this._capacity = Math.max(256, 2 ** Math.ceil(Math.log2(Math.max(1, byteLength))));
                }
                this.gl.bufferData(this._target, this._capacity, this.gl.STREAM_DRAW);
                this.gl.bufferSubData(this._target, 0, this.data);
            }
            else {
                const byteLength = this.data.byteLength ?? this.data.length * 4;
                if (!this._capacity || byteLength > this._capacity) {
                    this._capacity = byteLength;
                    this.gl.bufferData(this._target, this.data, this.gl.STREAM_DRAW);
                }
                else {
                    this.gl.bufferSubData(this._target, 0, this.data);
                }
            }
        }
        else {
            this.gl.bufferData(this._target, this.data, this.gl.STATIC_DRAW);
        }
        this.gl.bindBuffer(this._target, null);
    }
    subUpdate(data, size, offset) {
        // this.hasCalledSubUpdate = true
        if (bindedBuffer$1 != this) {
            bindedBuffer$1 = this;
            this.gl.bindBuffer(this._target, this._buffer);
        }
        this.gl.bindBuffer(this._target, this._buffer);
        let byteOffset = offset * size * Float32Array.BYTES_PER_ELEMENT;
        this.gl.bufferSubData(this.gl.ARRAY_BUFFER, byteOffset, data, 0);
    }
    bind() {
        if (bindedBuffer$1 != this) {
            bindedBuffer$1 = this;
            this.gl.bindBuffer(this._target, this._buffer);
        }
    }
}

const UNIFORM_TYPES$1 = {};
UNIFORM_TYPES$1[5126 /*FLOAT       */] = '1f';
UNIFORM_TYPES$1[35664 /*FLOAT_VEC2  */] = '2f';
UNIFORM_TYPES$1[35665 /*FLOAT_VEC3  */] = '3f';
UNIFORM_TYPES$1[35666 /*FLOAT_VEC4  */] = '4f';
UNIFORM_TYPES$1[35670 /*BOOL        */] = '1i';
UNIFORM_TYPES$1[5124 /*INT         */] = '1i';
UNIFORM_TYPES$1[35678 /*SAMPLER_2D  */] = '1i';
UNIFORM_TYPES$1[35679 /*SAMPLER_3D */] = '1i';
UNIFORM_TYPES$1[35680 /*SAMPLER_CUBE*/] = '1i';
UNIFORM_TYPES$1[36289 /*SAMPLER_2D_ARRAY*/] = '1i';
UNIFORM_TYPES$1[35671 /*BOOL_VEC2   */] = '2i';
UNIFORM_TYPES$1[35667 /*INT_VEC2    */] = '2i';
UNIFORM_TYPES$1[35672 /*BOOL_VEC3   */] = '3i';
UNIFORM_TYPES$1[35668 /*INT_VEC3    */] = '3i';
UNIFORM_TYPES$1[35673 /*BOOL_VEC4   */] = '4i';
UNIFORM_TYPES$1[35669 /*INT_VEC4    */] = '4i';
UNIFORM_TYPES$1[35674 /*FLOAT_MAT2  */] = 'Matrix2f';
UNIFORM_TYPES$1[35675 /*FLOAT_MAT3  */] = 'Matrix3f';
UNIFORM_TYPES$1[35676 /*FLOAT_MAT4  */] = 'Matrix4f';

var vertexShader = "precision highp float;\n\nattribute vec2 uv;\nattribute vec3 position;\n\nuniform mat4 uMVMatrix;\nuniform mat4 uPMatrix;\n\nvarying vec2 vUv;\n\nvoid main(void) {\nvUv = uv;\ngl_Position = uPMatrix * uMVMatrix * vec4(position, 1.0);\n}";

var defaultFragmentShader = "precision highp float;\n\nuniform float alpha;\nvarying vec2 vUv;\n\nvoid main(void) {\ngl_FragColor = vec4( vec3(1., 1., 1.), alpha);\n}";

var Common = "// UBO for View matrices\n#include \"/Engine/shaders/CommonViewUniformBuffer\"\n\n// UBO for OBject/Primitive matrices\n#include \"/Engine/shaders/CommonPrimitiveUniformBuffer\"";

var CommonViewUniformBuffer = "UBO_START(View, 1)\nVMatrix: mat4x4f\nPMatrix: mat4x4f\n\nPrevPMatrix: mat4x4f\nPrevVMatrix: mat4x4f\n\nVPMatrix: mat4x4f\nInvVMatrix: mat4x4f\nInvPMatrix: mat4x4f\nNormalViewMatrix: mat3x3f\nCameraPosition: vec3f\nScreenSize: vec2f\nUBO_END";

var CommonPrimitiveUniformBuffer = "UBO_START(Primitive, 2)\nMMatrix: mat4x4f\nPrevMMatrix: mat4x4f\nInvMMatrix: mat4x4f\nMVMatrix: mat4x4f\nMVPMatrix: mat4x4f\nNormalMatrix: mat3x3f\nUBO_END";

const settings$1 = {};
function addLineNumbers(string, lineNumber) {
    var lines = string.split('\n');
    let nLines = [];
    for (var i = 0; i < lines.length; i++) {
        if (lineNumber && (i < lineNumber - 20 || i > lineNumber + 20))
            continue;
        lines[i] = (i + 1) + ': ' + lines[i];
        nLines.push(lines[i]);
    }
    return nLines.join('\n');
}
function compile(gl, shader, code) {
    let source = code.trim();
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error('Shader cannot compile: \n' + (gl.getShaderInfoLog(shader) || ""));
        if (gl.getShaderInfoLog(shader)) {
            let lineErr = Number(gl.getShaderInfoLog(shader).match(/ERROR\:\s0\:([^:]+)\:/)[1]);
            console.warn(addLineNumbers(source, lineErr));
        }
        else {
            console.log("shader issue", source);
        }
        return false;
    }
    return true;
}
var ShaderCompiler = {
    compile,
    settings: settings$1
};

// Special engine includes
// The /Engine/ prefix is used to differentiate Engine shader from regular ones 
const ENGINE_INCLUDES = {
    '/Engine/shaders/Common': Common,
    '/Engine/shaders/CommonViewUniformBuffer': CommonViewUniformBuffer,
    '/Engine/shaders/CommonPrimitiveUniformBuffer': CommonPrimitiveUniformBuffer,
};
function resolveIncludes(code, seen = new Set()) {
    const includeRE = /#include\s+"([^"]+)"/g;
    return code.replace(includeRE, (_, path) => {
        // prevent infinite loops / circular includes
        if (seen.has(path)) {
            console.warn(`[SHADER] Circular include detected: ${path}`);
            return `// ⚠ circular include: ${path}`;
        }
        const chunk = ENGINE_INCLUDES[path];
        if (!chunk) {
            console.warn(`[SHADER] Missing include: ${path}`);
            return `// ⚠ missing include: ${path}`;
        }
        seen.add(path);
        // recursively resolve any nested includes inside this chunk
        const resolved = resolveIncludes(chunk, seen);
        seen.delete(path);
        return resolved;
    });
}
/**
 * This function handles '#pragma unroll' directive without
 * the need for unroll end direction or replacing iterator variable
 */
function unrollLoops(source) {
    let src = String(source);
    if (!/#pragma\s+unroll/.test(src))
        return src;
    // Collect #define NAME VALUE
    const defines = {};
    src.replace(/#define\s+([_A-Za-z]\w*)\s+(\d+)/g, (_, name, value) => {
        defines[name] = value;
    });
    // Matches: #pragma unroll for (int i = X; i < Y; i++) {
    const re = /#pragma\s+unroll\s+for\s*\(\s*int\s+([_A-Za-z]\w*)\s*=\s*(\d+)\s*;\s*[_A-Za-z]\w*\s*<\s*([_A-Za-z]\w*)\s*;\s*[_A-Za-z]\w*\+\+\s*\)\s*\{/g;
    let m;
    while ((m = re.exec(src)) !== null) {
        const [match, iterator, startRaw, endRaw] = m;
        const matchIndex = m.index;
        // Find the matching closing brace of the loop body
        const loopStart = matchIndex + match.length;
        let depth = 1;
        let i = loopStart;
        while (i < src.length && depth > 0) {
            const ch = src[i++];
            if (ch === '{')
                depth++;
            else if (ch === '}')
                depth--;
        }
        if (depth !== 0) {
            // Unbalanced braces; bail out safely.
            break;
        }
        const loopEnd = i - 1; // index of the closing '}'
        // IMPORTANT: slice from the current, updated src
        const loopContent = src.slice(loopStart, loopEnd);
        // Resolve defines, then numeric parse
        const start = parseInt(defines[startRaw] ?? startRaw, 10);
        const end = parseInt(defines[endRaw] ?? endRaw, 10);
        let out = '';
        for (let k = start; k < end; k++) {
            // note that we use brackers to create scope and avoid variable conflicts
            out += `{\n` +
                loopContent
                    .replace(new RegExp(`\\[\\s*${iterator}\\s*\\]`, 'g'), `[ ${k} ]`)
                    .replace(new RegExp(`\\b${iterator}\\b`, 'g'), String(k)) +
                `\n}`;
        }
        // Splice replacement into the evolving buffer
        src = src.slice(0, matchIndex) + out + src.slice(loopEnd + 1);
        // Move regex cursor past what we just inserted
        re.lastIndex = matchIndex + out.length;
    }
    return src;
}
function ensureGroup(groups, g) {
    if (!groups.has(g)) {
        groups.set(g, {
            ubos: new Set(),
            textures: new Set(),
            samplers: new Set(),
            _bindingCounter: 0,
        });
    }
    return groups.get(g);
}
function handleUBO(processed) {
    const groups = new Map();
    // =====================================================================
    // GLOBAL UNIFORM STRUCT 
    // =====================================================================
    const globalUniforms = [];
    // Collect and remove GLOBAL_UNIFORM(...) occurrences
    processed = processed.replace(/GLOBAL_UNIFORM\((\w+)\s*,\s*(.*?)\)/g, (_, name, type) => {
        globalUniforms.push({ name, type });
        return ""; // remove macro call from shader text
    });
    // If no global uniforms, skip the whole feature
    if (globalUniforms.length > 0) {
        const lines = processed.split("\n");
        let insertIndex = 0;
        // Insert after #version / #extension / precision / #include
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            if (line.startsWith("#version") ||
                line.startsWith("#extension") ||
                line.startsWith("precision") ||
                line.startsWith("#include")) {
                insertIndex = i + 1;
            }
        }
        const toGLSLType = (type) => {
            switch (type) {
                case "f32": return "float";
                case "i32": return "int";
                case "u32": return "uint";
                case "vec2f": return "vec2";
                case "vec3f": return "vec3";
                case "vec4f": return "vec4";
                case "mat3x3f": return "mat3";
                case "mat4x4f": return "mat4";
                // allow already-GLSL types too
                case "float":
                case "int":
                case "uint":
                case "vec2":
                case "vec3":
                case "vec4":
                case "mat3":
                case "mat4":
                    return type;
                default:
                    throw new Error(`Unsupported GLOBAL_UNIFORM type: ${type}`);
            }
        };
        const getStd140Layout = (type) => {
            switch (type) {
                case "float":
                case "int":
                case "uint":
                    return { align: 4, stride: 4 };
                case "vec2":
                    return { align: 8, stride: 8 };
                case "vec3":
                    return { align: 16, stride: 16 };
                case "vec4":
                    return { align: 16, stride: 16 };
                case "mat3":
                    return { align: 16, stride: 48 };
                case "mat4":
                    return { align: 16, stride: 64 };
                default:
                    throw new Error(`Unsupported std140 GLSL type: ${type}`);
            }
        };
        const alignTo = (value, align) => {
            return Math.ceil(value / align) * align;
        };
        const makePad = (bytes, index) => {
            switch (bytes) {
                case 4: return `float _pad${index};`;
                case 8: return `vec2 _pad${index};`;
                case 12: return `vec3 _pad${index};`;
                default: return null;
            }
        };
        let structLines = [];
        let currentOffset = 0;
        let padIndex = 0;
        for (const { name, type } of globalUniforms) {
            const glslType = toGLSLType(type);
            const { align, stride } = getStd140Layout(glslType);
            const alignedOffset = alignTo(currentOffset, align);
            if (alignedOffset !== currentOffset) {
                const pad = makePad(alignedOffset - currentOffset, padIndex++);
                if (pad) {
                    structLines.push(pad);
                }
            }
            currentOffset = alignedOffset;
            structLines.push(`${glslType} ${name};`);
            currentOffset += stride;
        }
        const finalOffset = alignTo(currentOffset, 16);
        if (finalOffset !== currentOffset) {
            const pad = makePad(finalOffset - currentOffset, padIndex++);
            if (pad) {
                structLines.push(pad);
            }
        }
        const g0 = ensureGroup(groups, 0);
        const binding = g0._bindingCounter++;
        // Important: this is the GLSL uniform block name.
        // It is used later with gl.getUniformBlockIndex(program, "GlobalUniforms")
        g0.ubos.add("GlobalUniforms");
        if (!g0.uboBindings) {
            g0.uboBindings = {};
        }
        g0.uboBindings.GlobalUniforms = binding;
        const injected = [
            ``,
            `// ---- GLOBAL UNIFORMS ----`,
            `layout(std140) uniform GlobalUniforms {`,
            `    ${structLines.join("\n    ")}`,
            `};`,
            ``
        ].join("\n");
        lines.splice(insertIndex, 0, injected);
        processed = lines.join("\n");
    }
    // =====================================================================
    // UBO_START / UBO_END MACROS
    // =====================================================================
    const UBO_RE = /UBO_START\((\w+)(?:\s*,\s*(\d+))?\)([\s\S]*?)UBO_END/g;
    processed = processed.replace(UBO_RE, (_, name, groupIndexRaw, body) => {
        const groupIndex = groupIndexRaw ? parseInt(groupIndexRaw, 10) : 0;
        const g = ensureGroup(groups, groupIndex);
        g.ubos.add(name);
        const fields = body.split('\n')
            .map(l => l.trim())
            .filter(l => l && !l.startsWith('//'))
            .map(l => l.replace(/;+$/, ''))
            .map(l => {
            const [field, type] = l.split(':').map(s => s.trim());
            return { field, type };
        });
        let structLines = fields.map(({ field, type }) => `${field} : ${type},`);
        let currentOffset = 0;
        for (const f of fields) {
            let align = 0, stride = 0;
            switch (f.type) {
                case 'f32':
                case 'i32':
                case 'u32':
                    align = 4;
                    stride = 4;
                    break;
                case 'vec2f':
                    align = 8;
                    stride = 8;
                    break;
                case 'vec3f':
                    align = 16;
                    stride = 16;
                    break;
                case 'vec4f':
                    align = 16;
                    stride = 16;
                    break;
                case 'mat3x3f':
                    align = 16;
                    stride = 48;
                    break;
                case 'mat4x4f':
                    align = 16;
                    stride = 64;
                    break;
            }
            currentOffset = Math.ceil(currentOffset / align) * align;
            currentOffset += stride;
        }
        if (currentOffset % 16 !== 0) {
            structLines.push(`_pad${g._bindingCounter} : vec4f,`);
        }
        g._bindingCounter++;
        return '';
        // return `
        // 	struct ${structName} {
        // 		${structLines.join('\n				')}
        // 	};
        // 	@group(${groupIndex}) @binding(${binding}) var<uniform> ${name} : ${structName};
        // `;
    });
    // =====================================================================
    // TEXTURE2D / SAMPLER MACROS
    // =====================================================================
    processed = processed.replace(/TEXTURE2D\s*\(\s*(\w+)\s*\)/g, (_, name) => {
        const g = ensureGroup(groups, 0);
        g.textures.add(name);
        const binding = g._bindingCounter++;
        return `@group(0) @binding(${binding}) var ${name} : texture_2d<f32>;`;
    });
    processed = processed.replace(/SAMPLER\s*\(\s*(\w+)\s*\)/g, (_, name) => {
        const g = ensureGroup(groups, 0);
        g.samplers.add(name);
        const binding = g._bindingCounter++;
        return `@group(0) @binding(${binding}) var ${name} : sampler;`;
    });
    return processed;
}
function ShaderPreprocessor(code, options = {}) {
    let defines = { ...(options.defines || {}) };
    /* Webgl2: make sure version is always defined first */
    let version = '';
    code = code.replace(/\#version[^\n\r]+/, (a, b, c) => {
        version = a;
        return '';
    });
    var definesStr = '';
    for (var d in defines) {
        if (defines[d] !== null && defines[d] !== void 0) {
            definesStr += '#define ' + d + ' ' + defines[d] + '\n';
        }
    }
    code = version + '\n' + definesStr + '\n' + code;
    code = resolveIncludes(code);
    code = unrollLoops(code);
    code = handleUBO(code);
    return code;
}

const Constants = {
    LightTypes: {
        SpotLight: 0,
        RectLight: 1,
        AreaLight: 1,
        DirectionalLight: 2,
        PointLight: 3,
        AmbientLight: 4,
    },
    ShadowModes: {
        sharp: 0,
        linear: 1,
        pcf: 2,
        pcss: 3,
    },
    CullMode: {
        None: 0,
        Front: 1,
        Back: 2,
    },
    FrontFace: {
        CCW: 0,
        CW: 1,
    },
    PrimitiveTopology: {
        PointList: 0,
        LineList: 1,
        LineStrip: 2,
        TriangleList: 3,
        TriangleStrip: 4,
    },
    BlendFactor: {
        Zero: 0,
        One: 1,
        SrcColor: 2,
        OneMinusSrcColor: 3,
        DstColor: 4,
        OneMinusDstColor: 5,
        SrcAlpha: 6,
        OneMinusSrcAlpha: 7,
        DstAlpha: 8,
        OneMinusDstAlpha: 9,
        ConstantColor: 10,
        OneMinusConstantColor: 11,
        ConstantAlpha: 12,
        OneMinusConstantAlpha: 13,
    },
    BlendOperation: {
        Add: 0,
        Subtract: 1,
        ReverseSubtract: 2,
        Min: 3,
        Max: 4,
    },
    ColorWriteMask: {
        None: 0,
        R: 1 << 0,
        G: 1 << 1,
        B: 1 << 2,
        A: 1 << 3,
        RGB: (1 << 0) | (1 << 1) | (1 << 2),
        RGBA: (1 << 0) | (1 << 1) | (1 << 2) | (1 << 3),
    },
    CompareFunction: {
        Never: 0,
        Less: 1,
        Equal: 2,
        LessEqual: 3,
        Greater: 4,
        NotEqual: 5,
        GreaterEqual: 6,
        Always: 7,
    },
    StencilOperation: {
        Keep: 0,
        Zero: 1,
        Replace: 2,
        IncrementClamp: 3,
        DecrementClamp: 4,
        Invert: 5,
        IncrementWrap: 6,
        DecrementWrap: 7,
    },
    FilterMode: {
        Nearest: 0,
        Linear: 1,
        MipmapNearest: 2,
        MipmapLinear: 3,
    },
    AddressMode: {
        ClampToEdge: 0,
        Repeat: 1,
        MirrorRepeat: 2,
    },
    DataType: {
        Int8: 0,
        Uint8: 1,
        Int16: 2,
        Uint16: 3,
        Int32: 4,
        Uint32: 5,
        Float16: 6,
        Float32: 7,
    },
    VertexFormat: {
        Float32: 0,
        Float32x2: 1,
        Float32x3: 2,
        Float32x4: 3,
        Uint8x2: 4,
        Uint8x4: 5,
        Sint8x2: 6,
        Sint8x4: 7,
        Uint16x2: 8,
        Uint16x4: 9,
        Sint16x2: 10,
        Sint16x4: 11,
    },
    TextureFormat: {
        R8Unorm: 0,
        RG8Unorm: 1,
        RGBA8Unorm: 2,
        RGBA8UnormSRGB: 3,
        R16Float: 4,
        RG16Float: 5,
        RGBA16Float: 6,
        R32Float: 7,
        RG32Float: 8,
        RGBA32Float: 9,
        Depth16Unorm: 10,
        Depth24Plus: 11,
        Depth24PlusStencil8: 12,
        Depth32Float: 13,
    },
};
Object.freeze(Constants);
Object.values(Constants).forEach(Object.freeze);

const IS_SAFARI$1 = /Safari/g.test(navigator.userAgent) && !/Chrome/g.test(navigator.userAgent);
const TEXTURE_2D$1 = 35678;
const TEXTURE_3D$1 = 35679;
const TEXTURE_CUBE_MAP$1 = 35680;
const SAMPLER_2D_ARRAY$1 = 36289;
// let angle_instanced_array;
let currentState$1 = {
    attributes: [],
    uniforms: {},
    depthTest: null,
    cullFace: null,
    blend: false,
    program: null,
    geometry: null
};
window.__drawCalls = 0;
function cacheUniformValue(uniform, value) {
    if (!Array.isArray(value) &&
        !(ArrayBuffer.isView(value) && value.length !== undefined)) {
        uniform.oldValue = cloneUniformValue(value);
        return;
    }
    let cached = uniform.oldValue;
    if (Array.isArray(value)) {
        if (!Array.isArray(cached) || cached.length !== value.length) {
            cached = new Array(value.length);
            uniform.oldValue = cached;
        }
    }
    else if (!cached ||
        cached.constructor !== value.constructor ||
        cached.length !== value.length) {
        cached = new value.constructor(value.length);
        uniform.oldValue = cached;
    }
    for (let i = 0; i < value.length; i++) {
        cached[i] = value[i];
    }
}
function sameUniformValue(a, b) {
    if (a === b)
        return true;
    if (!a || !b)
        return false;
    const al = a.length;
    const bl = b.length;
    if (al === undefined || bl === undefined || al !== bl) {
        return false;
    }
    for (let i = 0; i < al; i++) {
        if (a[i] !== b[i])
            return false;
    }
    return true;
}
function cloneUniformValue(v) {
    if (!v || v.length === undefined)
        return v;
    return v.slice ? v.slice() : new v.constructor(v);
}
function isTextureUniform(type) {
    return (type === TEXTURE_2D$1 ||
        type === TEXTURE_CUBE_MAP$1 ||
        type === TEXTURE_3D$1 ||
        type === SAMPLER_2D_ARRAY$1);
}
function reflectUniformBlocks(glsl) {
    const blocks = [];
    const blockRE = /layout\s*\(\s*std140\s*\)\s*uniform\s+(\w+)\s*\{([\s\S]*?)\}\s*;?/g;
    let m;
    while ((m = blockRE.exec(glsl))) {
        const [, blockName, body] = m;
        const fields = [];
        let offset = 0;
        const lines = body
            .split('\n')
            .map(l => l.trim())
            .filter(Boolean)
            .filter(l => !l.startsWith('//'));
        for (const line of lines) {
            const clean = line.replace(/;.*/, '').trim();
            if (!clean)
                continue;
            const parts = clean.split(/\s+/);
            if (parts.length < 2)
                continue;
            const type = parts[0];
            const field = parts[1];
            const layout = getLayoutGLSL(type);
            if (!layout)
                continue;
            offset = alignTo(offset, layout.align);
            fields.push({
                field,
                type,
                offset,
                size: layout.size,
                stride: layout.stride,
            });
            offset += layout.stride;
        }
        blocks.push({
            blockName,
            type: 'ubo',
            layout: {
                fields,
                totalSize: alignTo(offset, 16),
            },
        });
    }
    return blocks;
}
function getLayoutGLSL(type) {
    switch (type) {
        case 'float':
        case 'int':
        case 'uint':
        case 'bool':
            return { align: 4, size: 4, stride: 4 };
        case 'vec2':
        case 'ivec2':
        case 'uvec2':
        case 'bvec2':
            return { align: 8, size: 8, stride: 8 };
        case 'vec3':
        case 'ivec3':
        case 'uvec3':
        case 'bvec3':
            return { align: 16, size: 12, stride: 16 };
        case 'vec4':
        case 'ivec4':
        case 'uvec4':
        case 'bvec4':
            return { align: 16, size: 16, stride: 16 };
        case 'mat3':
            return { align: 16, size: 48, stride: 48 };
        case 'mat4':
            return { align: 16, size: 64, stride: 64 };
        default:
            return null;
    }
}
function alignTo(v, a) {
    return Math.ceil(v / a) * a;
}
class Program$1 {
    get twoSided() {
        return this.cullFace === Constants.CullMode.None;
    }
    set twoSided(value) {
        this.cullFace = value ? Constants.CullMode.None : Constants.CullMode.Back;
    }
    get backSided() {
        return this.cullFace === Constants.CullMode.Front;
    }
    set backSided(value) {
        this.cullFace = value ? Constants.CullMode.Front : Constants.CullMode.Back;
    }
    constructor(gl, options = {}) {
        if (options.name) {
            this.name = options.name;
        }
        if (options.id) {
            this.id = options.id;
        }
        this._uuid = generateUUID();
        this.uuid = this._uuid;
        if (!gl) {
            return;
        }
        options = Object.assign({}, {
            vertexShader: vertexShader,
            fragmentShader: defaultFragmentShader,
            defines: {},
            extentions: {},
            type: gl.TRIANGLES,
            uniforms: {},
            transformFeedbackVaryings: null
        }, options);
        this.options = options;
        this._vertexShaderSource = options.vertexShader;
        this._fragmentShaderSource = options.fragmentShader;
        this.name = options.name;
        this.gl = gl;
        this._program = gl.createProgram(this.name);
        this.vertexShader = gl.createShader(gl.VERTEX_SHADER);
        this.fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.attachShader(this._program, this.vertexShader);
        gl.attachShader(this._program, this.fragmentShader);
        if (options.transformFeedbackVaryings) {
            this.transformFeedback = gl.createTransformFeedback();
            gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.transformFeedback);
            gl.transformFeedbackVaryings(this._program, options.transformFeedbackVaryings, gl.SEPARATE_ATTRIBS);
        }
        this.type = options.type;
        this.attributes = {};
        this.defines = options.defines;
        this._lastDefines = {};
        this.extentions = options.extentions;
        this._textureUnit = 0;
        this.depthTest = options.depthTest !== void 0 ? options.depthTest : true;
        if (options.twoSided === true) {
            this.cullFace = Constants.CullMode.None;
        }
        else if (options.backSided === true) {
            this.cullFace = Constants.CullMode.Front;
        }
        else {
            this.cullFace = options.cullFace !== void 0 ? options.cullFace : Constants.CullMode.Back;
        }
        this.wireframe = options.wireframe !== void 0 ? options.wireframe : false;
        this.lines = options.lines !== void 0 ? options.lines : false;
        this.blend = options.blend !== void 0 ? options.blend : false;
        this.blendEquation = options.blendEquation !== void 0 ? options.blendEquation : this.gl.FUNC_ADD;
        this.blendEquationSeparate = options.blendEquationSeparate !== void 0 ? options.blendEquationSeparate : null;
        this.blendSrc = options.blendSrc !== void 0 ? options.blendSrc : this.gl.SRC_ALPHA;
        this.blendDst = options.blendDst !== void 0 ? options.blendDst : this.gl.ONE_MINUS_SRC_ALPHA;
        this.blendSrcRGB = options.blendSrcRGB !== void 0 ? options.blendSrcRGB : this.gl.SRC_ALPHA;
        this.blendDstRGB = options.blendDstRGB !== void 0 ? options.blendDstRGB : this.gl.ONE_MINUS_SRC_ALPHA;
        this.blendSrcAlpha = options.blendSrcAlpha !== void 0 ? options.blendSrcAlpha : this.gl.ONE;
        this.blendDstAlpha = options.blendDstAlpha !== void 0 ? options.blendDstAlpha : this.gl.ONE_MINUS_SRC_ALPHA;
        this.uniforms = {};
        this.defaultUniforms = options.uniforms;
        this._vertexArrayCache = new Map();
        this.compile();
    }
    clearVertexArrayCache() {
        for (const vertexArray of this._vertexArrayCache.values()) {
            this.gl.deleteVertexArray(vertexArray);
        }
        this._vertexArrayCache.clear();
    }
    compile(force) {
        if (!this.gl) {
            return;
        }
        if (this.isCompiling) {
            return;
        }
        this.isCompiling = true;
        this.clearVertexArrayCache();
        // resolve includes + preprocess
        const vsPre = ShaderPreprocessor(this._vertexShaderSource, { defines: this.defines });
        const fsPre = ShaderPreprocessor(this._fragmentShaderSource, { defines: this.defines });
        // Extract uniform block name from shader
        const vsBlocks = reflectUniformBlocks(vsPre);
        const fsBlocks = reflectUniformBlocks(fsPre);
        const uniformBlocks = [...vsBlocks];
        for (const b of fsBlocks) {
            if (!uniformBlocks.some(x => x.blockName === b.blockName)) {
                uniformBlocks.push(b);
            }
        }
        this.uniformBlocks = uniformBlocks;
        let binding = 0;
        for (const block of this.uniformBlocks) {
            block.binding = binding++;
        }
        if (binding > 0) {
            console.log("FOUND UNIFORM BLOCK", this.uniformBlocks);
        }
        //fix: this forces Safari to update ACTIVE_UNIFORMS after first compile()
        if (IS_SAFARI$1 || force) {
            this.gl.detachShader(this._program, this.vertexShader);
            this.gl.detachShader(this._program, this.fragmentShader);
            this.vertexShader = this.gl.createShader(this.gl.VERTEX_SHADER);
            this.fragmentShader = this.gl.createShader(this.gl.FRAGMENT_SHADER);
            this.gl.attachShader(this._program, this.vertexShader);
            this.gl.attachShader(this._program, this.fragmentShader);
        }
        if (!(ShaderCompiler.compile(this.gl, this.vertexShader, vsPre) &&
            ShaderCompiler.compile(this.gl, this.fragmentShader, fsPre))) {
            console.warn('compile error');
            return false;
        }
        this.gl.linkProgram(this._program);
        if (!this.gl.getProgramParameter(this._program, this.gl.LINK_STATUS)) {
            console.error("Cannot link program: \n" + this.gl.getProgramInfoLog(this._program) || "");
            // console.warn("VERTEX_SHADER:\n"+addLineNumbers(this._vertexShaderSource)
            //             +"\n\nFRAGMENT_SHADER:\n"+addLineNumbers(this._fragmentShaderSource));
        }
        this._bindUniformBlocks();
        // this._createUniformBlockBuffers();
        this.gl.useProgram(this._program);
        this._retrieveUniformsFromShader();
    }
    //connect uniforms block to the program
    _bindUniformBlocks() {
        const gl = this.gl;
        if (!this.uniformBlocks)
            return;
        for (const block of this.uniformBlocks) {
            const blockIndex = gl.getUniformBlockIndex(this._program, block.blockName);
            if (blockIndex === gl.INVALID_INDEX || blockIndex === 0xFFFFFFFF) {
                continue;
            }
            gl.uniformBlockBinding(this._program, blockIndex, block.binding);
        }
    }
    // bind uniform BUFFER to the current program before drawing(as we do for uniforms basically)
    _bindUniformBlockBuffers() {
        const gl = this.gl;
        if (!this.uniformBlockBuffers)
            return;
        for (const name in this.uniformBlockBuffers) {
            const ubo = this.uniformBlockBuffers[name];
            gl.bindBufferBase(gl.UNIFORM_BUFFER, ubo.binding, ubo.buffer);
        }
    }
    _createUniformBlockBuffers() {
        const gl = this.gl;
        if (!this.uniformBlocks)
            return;
        this.uniformBlockBuffers = this.uniformBlockBuffers || {};
        for (const block of this.uniformBlocks) {
            if (this.uniformBlockBuffers[block.blockName])
                continue;
            const buffer = gl.createBuffer();
            gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
            gl.bufferData(gl.UNIFORM_BUFFER, block.layout.totalSize, gl.DYNAMIC_DRAW);
            gl.bindBufferBase(gl.UNIFORM_BUFFER, block.binding, buffer);
            gl.bindBuffer(gl.UNIFORM_BUFFER, null);
            this.uniformBlockBuffers[block.blockName] = {
                buffer,
                binding: block.binding,
                layout: block.layout,
                data: new ArrayBuffer(block.layout.totalSize),
            };
        }
    }
    _retrieveUniformsFromShader() {
        /**
         * When re-compiling, we dont wanna loose current uniform values
         * another appoch would be to set uniforms on Program instead of tagrte uniform.value:
         * program.uniform[uniformName]
         *   instead of
         *  program.uniforms[uniformName].value
         */
        this._savedUniforms = {};
        for (let k in this.uniforms) {
            this._savedUniforms[k] = {
                value: this.uniforms[k].value
            };
        }
        this.uniforms = {};
        this._textureUnit = 0;
        var numUniforms = this.gl.getProgramParameter(this._program, this.gl.ACTIVE_UNIFORMS);
        for (let i = 0; i < numUniforms; ++i) {
            var uniform = this.gl.getActiveUniform(this._program, i);
            if (uniform === null) {
                this.gl.getError();
                continue;
            }
            let name = uniform.name;
            let isArray = false; //is uniform array  ?(ex: 3fv, 4fv...)
            // tltr; we want 'myUniform[0]' to become 'myUniform'
            // if array uniform, replace the retrieved name as it includes the first index acces
            if (/\[.*\]/.test(name)) {
                isArray = true;
                name = name.replace(/\[.*\]/, '');
            }
            if (this.uniforms[name] !== void 0) {
                this.uniforms[name].location = this.gl.getUniformLocation(this._program, name);
                this.uniforms[name].type = uniform.type;
            }
            else {
                this.uniforms[name] = {
                    isArray: isArray,
                    location: this.gl.getUniformLocation(this._program, name),
                    type: uniform.type,
                    value: null,
                    oldValue: null,
                    size: uniform.size
                };
                //set texture unit
                if (uniform.type === TEXTURE_2D$1 || uniform.type === TEXTURE_CUBE_MAP$1 || uniform.type == TEXTURE_3D$1 || uniform.type == SAMPLER_2D_ARRAY$1) {
                    this.uniforms[name].unit = this._textureUnit;
                    this._textureUnit++;
                }
            }
        }
        //merge user defined uniforms
        for (let u in this._savedUniforms) {
            if (this.uniforms[u] !== void 0) {
                if (this._savedUniforms[u].value !== void 0
                    && this._savedUniforms[u].value !== null) {
                    this.uniforms[u].value = this._savedUniforms[u].value;
                }
            }
        }
        /**
         * Restore unfiroms values set on Program creation by user
         */
        for (let u in this.defaultUniforms) {
            if (this.uniforms[u] !== void 0
                && this.defaultUniforms[u] !== void 0
                && this.defaultUniforms[u] !== null) {
                this.uniforms[u].value = this.defaultUniforms[u];
            }
        }
        var numAttributes = this.gl.getProgramParameter(this._program, this.gl.ACTIVE_ATTRIBUTES);
        for (let i = 0; i < numAttributes; ++i) {
            var attribute = this.gl.getActiveAttrib(this._program, i);
            if (attribute === null) {
                this.gl.getError();
                continue;
            }
            this.attributes[attribute.name] = {
                location: this.gl.getAttribLocation(this._program, attribute.name),
                type: attribute.type
            };
            //the attribute is only enabled when the buffer is binded
            //(so it's enabled by the Program that will use the buffer)
            //this way we make sure that any enabled attribute has some data not to trigger an error
            //see http://www.mjbshaw.com/2013/03/webgl-fixing-invalidoperation.html
            // this.gl.enableVertexAttribArray( this.attributes[attribute.name].location );
        }
        this.isCompiling = false;
        // Reset uniform upload cache after shader relink / uniform recreation
        for (let k in this.uniforms) {
            this.uniforms[k].oldValue = null;
            this.uniforms[k].oldUnit = null;
        }
        this._uniformKeys = Object.keys(this.uniforms);
    }
    dispose() {
        this.clearVertexArrayCache();
    }
    use() {
        if (!this.gl) {
            return;
        }
        this.gl.useProgram(this._program);
    }
    attribPointer(geometry) {
        if (!this.gl) {
            console.warn('Program.attribPointer error: missing gl');
            return;
        }
        for (var attr in this.attributes) {
            if (geometry.attributes[attr] !== void 0) {
                // Instanced mat4
                if (attr == 'instanceMatrix') {
                    for (let i = 0; i < 4; ++i) {
                        const loc = this.attributes[attr].location + i;
                        this.gl.enableVertexAttribArray(loc);
                        this.gl.vertexAttribDivisor(loc, 1);
                        geometry.attributes[attr].bind(); //bindin the same buffer, but we use different offset/stride
                        this.gl.vertexAttribPointer(loc, // location
                        4, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                        this.gl.FLOAT, // geometry.attributes[attr].type, // type of data in buffer
                        false, // normalize
                        16 * 4, // bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                        i * 4 * 4 // offset in buffer |  4 floats per row, 4 bytes per float
                        );
                    }
                }
                // Instanced vec3
                else if (attr == 'instanceColor' || attr == 'instancePosition' || attr == 'instanceRotation' || attr == 'instanceScale' || attr == 'instanceTilePosition' || attr == 'instanceTileScale' || attr == 'instanceLightmapTileInfos') {
                    const loc = this.attributes[attr].location;
                    this.gl.enableVertexAttribArray(loc);
                    this.gl.vertexAttribDivisor(loc, 1);
                    geometry.attributes[attr].bind();
                    this.gl.vertexAttribPointer(loc, // location
                    3, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                    this.gl.FLOAT, // geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    3 * 4, // bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                    0 // offset in buffer |  4 floats per row, 4 bytes per float
                    );
                }
                // Instanced vec2
                else if (attr == 'instanceUv' || attr == 'instanceLightmapTileOffset') {
                    const loc = this.attributes[attr].location;
                    this.gl.enableVertexAttribArray(loc);
                    this.gl.vertexAttribDivisor(loc, 1);
                    geometry.attributes[attr].bind();
                    this.gl.vertexAttribPointer(loc, // location
                    2, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                    this.gl.FLOAT, // geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    2 * 4, // bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                    0. // offset in buffer |  4 floats per row, 4 bytes per float
                    );
                }
                // Instanced Float
                else if (attr == 'instanceShadowVisibility' || attr == 'instanceCardAtlasInfos' || attr == 'probeIndex' ||
                    attr == 'instanceClusterIndex' || attr == 'instanceFaceAtlasStartIndex' || attr == 'instanceTileLevel' ||
                    attr == 'instanceTileIndex' || attr == 'instanceIndex2' || attr == 'instanceLightmapTileSize' ||
                    attr == 'instanceFoliageTileIndex' || attr == 'instanceFoliageIndex' ||
                    attr == 'instanceMatrixIndex') {
                    const loc = this.attributes[attr].location;
                    // const bytesPerMatrix = 4 ;
                    geometry.attributes[attr].bind();
                    this.gl.enableVertexAttribArray(loc);
                    this.gl?.vertexAttribDivisor(loc, 1);
                    const offset = 0; // 4 bytes per float
                    this.gl.vertexAttribPointer(loc, // location
                    1, // size (num values to pull from buffer per iteration)
                    geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    1 * 4, // bytesPerMatrix   // stride, num bytes to advance to get to next set of values
                    offset);
                }
                // NO Instanced
                else {
                    const { location, stride, offset } = this.attributes[attr];
                    const { size, type } = geometry.attributes[attr];
                    this.gl?.vertexAttribDivisor(location, 0);
                    this.gl.enableVertexAttribArray(location);
                    geometry.attributes[attr].bind();
                    if (offset && stride) {
                        this.gl.vertexAttribPointer(location, size, type, false /*normalized*/, stride, offset);
                    }
                    else {
                        this.gl.vertexAttribPointer(location, size, type, false /*normalized*/, 0, 0);
                    }
                }
            }
        }
    }
    clone() {
        return;
    }
    //overrides: applied on Scene, passed by Mesh
    // same as overrideMaterial but just for GL states
    draw(geometry, options, debug) {
        const usetransformFeedback = options?.usetransformFeedback;
        const overrides = options?.overrides;
        if (!this.gl) {
            return;
        }
        let definesL = Object.keys(this.defines);
        let lastDefinesL = Object.keys(this._lastDefines);
        let needsCompile = definesL.length != lastDefinesL.length;
        for (var d in this.defines) {
            if (this.defines[d] !== this._lastDefines[d]) {
                needsCompile = true;
            }
        }
        if (needsCompile) {
            this._lastDefines = {};
            for (var d in this.defines) {
                this._lastDefines[d] = this.defines[d];
            }
            this.compile();
        }
        if (needsCompile || this._program !== currentState$1.program) {
            this.gl.useProgram(this._program);
            currentState$1.program = this._program;
        }
        this._bindUniformBlockBuffers();
        // this.attribPointer(geometry);
        let vertexArray = this._vertexArrayCache.get(geometry);
        if (!vertexArray) {
            vertexArray = this.gl.createVertexArray();
            this.gl.bindVertexArray(vertexArray);
            this.attribPointer(geometry);
            this._vertexArrayCache.set(geometry, vertexArray);
        }
        else {
            this.gl.bindVertexArray(vertexArray);
        }
        let _depthTest = overrides?.depthTest != void 0 ? overrides.depthTest : this.depthTest;
        if (_depthTest !== currentState$1.depthTest) {
            this.gl[_depthTest ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
            currentState$1.depthTest = _depthTest;
        }
        const cullFace = (overrides?.cullFace !== void 0
            ? overrides.cullFace
            : this.cullFace);
        if (cullFace === Constants.CullMode.None) {
            if (currentState$1.cullFace !== Constants.CullMode.None) {
                this.gl.disable(this.gl.CULL_FACE);
                currentState$1.cullFace = Constants.CullMode.None;
            }
        }
        else {
            if (currentState$1.cullFace === Constants.CullMode.None ||
                currentState$1.cullFace === null ||
                currentState$1.cullFace === void 0) {
                this.gl.enable(this.gl.CULL_FACE);
            }
            if (currentState$1.cullFace !== cullFace) {
                this.gl.cullFace(cullFace === Constants.CullMode.Front
                    ? this.gl.FRONT
                    : this.gl.BACK);
                currentState$1.cullFace = cullFace;
            }
        }
        if (overrides?.blend || this.blend) {
            // this.gl.disable(this.gl.DEPTH_TEST);
            // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
            // if (_depthTest) {
            //   if (overrides?.depthFunc) {
            //     this.gl.depthFunc( overrides.depthFunc );
            //   }
            //   else {
            //     this.gl.depthFunc( this.gl.LESS );
            //   }
            // }
            const depthFunc = overrides?.depthFunc || this.gl.LESS;
            if (currentState$1.depthFunc !== depthFunc) {
                this.gl.depthFunc(depthFunc);
                currentState$1.depthFunc = depthFunc;
            }
            if (overrides?.blendEquation) {
                this.gl.blendEquationSeparate(this.blendEquation, overrides?.blendEquation);
                currentState$1.blendEquation = null;
            }
            else if (overrides?.blendEquationRGB) {
                this.gl.blendEquationSeparate(overrides?.blendEquationRGB, this.blendEquation);
                currentState$1.blendEquation = null;
            }
            else if (overrides?.blendEquationSeparate) {
                this.gl.blendEquationSeparate(overrides.blendEquationSeparate.rgb, overrides.blendEquationSeparate.alpha);
                currentState$1.blendEquation = null;
            }
            else {
                if (this.blendEquationSeparate) {
                    this.gl.blendEquationSeparate(this.blendEquationSeparate.rgb, this.blendEquationSeparate.alpha);
                }
                else {
                    if (currentState$1.blendEquation !== (overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation)) {
                        this.gl.blendEquation((overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation));
                        currentState$1.blendEquation = (overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation);
                    }
                }
            }
            const blendSrcRGB = (overrides?.blendSrcRGB !== void 0 ? overrides?.blendSrcRGB : this.blendSrcRGB);
            const blendDstRGB = (overrides?.blendDstRGB !== void 0 ? overrides?.blendDstRGB : this.blendDstRGB);
            const blendSrcAlpha = (overrides?.blendSrcAlpha !== void 0 ? overrides?.blendSrcAlpha : this.blendSrcAlpha);
            const blendDstAlpha = (overrides?.blendDstAlpha !== void 0 ? overrides?.blendDstAlpha : this.blendDstAlpha);
            if (currentState$1.blendSrcRGB !== blendSrcRGB ||
                currentState$1.blendDstRGB !== blendDstRGB ||
                currentState$1.blendSrcAlpha !== blendSrcAlpha ||
                currentState$1.blendDstAlpha !== blendDstAlpha) {
                currentState$1.blendSrcRGB = blendSrcRGB;
                currentState$1.blendDstRGB = blendDstRGB;
                currentState$1.blendSrcAlpha = blendSrcAlpha;
                currentState$1.blendDstAlpha = blendDstAlpha;
                this.gl.blendFuncSeparate(blendSrcRGB, blendDstRGB, blendSrcAlpha, blendDstAlpha);
            }
            // this.gl.blendFunc(this.blendSrc,this.blendDst);
            if (!currentState$1.blend) {
                this.gl.enable(this.gl.BLEND);
                currentState$1.blend = true;
            }
        }
        else {
            if (currentState$1.blend) {
                this.gl.disable(this.gl.BLEND);
                currentState$1.blend = false;
            }
            // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
            if (overrides?.depthFunc) {
                this.gl.depthFunc(overrides.depthFunc);
            }
            else {
                this.gl.depthFunc(this.gl.LESS);
            }
        }
        // var keys = Object.keys(this.uniforms);
        // for (var i=0,l=keys.length; i<l; i++) {
        //   let uniformName = keys[i];
        //   if ( 
        //       this.uniforms[ uniformName ].value !== null && 
        //       this.uniforms[ uniformName ].value !== void 0
        //     ){
        //       switch (this.uniforms[ uniformName ].type) {
        //         case this.gl.FLOAT_MAT2:
        //         case this.gl.FLOAT_MAT3:
        //         case this.gl.FLOAT_MAT4:
        //             if (this.uniforms[ uniformName ].value &&  this.uniforms[ uniformName ].value.length > 0) {
        //               this.gl['uniform' + UNIFORM_TYPE[this.uniforms[ uniformName ].type]+'v'](this.uniforms[ uniformName ].location, false, this.uniforms[ uniformName ].value);
        //             }
        //         break;
        //         default:
        //           //texture unfirom
        //           if (this.uniforms[ uniformName ].type === TEXTURE_2D ||
        //               this.uniforms[ uniformName ].type === TEXTURE_CUBE_MAP || 
        //               this.uniforms[ uniformName ].type === TEXTURE_3D ||
        //               this.uniforms[ uniformName ].type === SAMPLER_2D_ARRAY 
        //           ){
        //               this.uniforms[ uniformName ].value.bind( this.uniforms[ uniformName ].unit );
        //               this.gl['uniform' + UNIFORM_TYPE[this.uniforms[ uniformName ].type] ](this.uniforms[ uniformName ].location, this.uniforms[ uniformName ].unit);
        //           }
        //           else {
        //             let type = UNIFORM_TYPE[this.uniforms[ keys[i] ].type];
        //             //add 'v' to the uniformType if the unifor is an array: ex "3f" => "3fv"
        //             if (this.uniforms[ uniformName ].isArray) {
        //               type += 'v';
        //             }
        //             let v = this.uniforms[ uniformName ].value;
        //             switch (type) {
        //               case '2f':
        //                 this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1]);
        //                 break;
        //               case '3f':  
        //                 this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2]);
        //               break;
        //               case '4f':
        //                 this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2], v[3]);
        //                 break;
        //               default:
        //                 this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v);
        //                 break;
        //             }
        //           }
        //           break;
        //       }
        //   }
        // }
        const keys = this._uniformKeys;
        for (var i = 0, l = keys.length; i < l; i++) {
            const uniformName = keys[i];
            const uniform = this.uniforms[uniformName];
            const v = uniform.value;
            if (v === null || v === void 0)
                continue;
            // if (v === null || v === void 0) {
            //   if (uniform.unit !== void 0) {
            //     console.warn('RT_ACTIVE_SAMPLER_WITHOUT_TEXTURE', uniformName);
            //   }
            //   continue;
            // }
            const isTexture = isTextureUniform(uniform.type);
            // if (window.skipSameUniforms) {
            // Cache: skip GPU call if value did not change.
            if (isTexture) {
                if (!v.bind) ;
                else {
                    v.bind(uniform.unit);
                    if (uniform.oldUnit !== uniform.unit) {
                        this.gl['uniform' + UNIFORM_TYPES$1[uniform.type]](uniform.location, uniform.unit);
                        uniform.oldUnit = uniform.unit;
                    }
                }
                uniform.oldValue = v;
                continue;
            }
            else {
                if (sameUniformValue(uniform.oldValue, v)) {
                    continue;
                }
            }
            // }
            switch (uniform.type) {
                case this.gl.FLOAT_MAT2:
                case this.gl.FLOAT_MAT3:
                case this.gl.FLOAT_MAT4:
                case this.gl.FLOAT_MAT2x3:
                case this.gl.FLOAT_MAT2x4:
                case this.gl.FLOAT_MAT3x2:
                case this.gl.FLOAT_MAT3x4:
                case this.gl.FLOAT_MAT4x2:
                case this.gl.FLOAT_MAT4x3:
                    if (v && v.length > 0) {
                        this.gl['uniform' + UNIFORM_TYPES$1[uniform.type] + 'v'](uniform.location, false, v);
                    }
                    break;
                default:
                    if (isTexture) {
                        v.bind(uniform.unit);
                        this.gl['uniform' + UNIFORM_TYPES$1[uniform.type]](uniform.location, uniform.unit);
                        uniform.oldUnit = uniform.unit;
                    }
                    else {
                        let type = UNIFORM_TYPES$1[uniform.type];
                        if (uniform.isArray) {
                            type += 'v';
                        }
                        switch (type) {
                            case '2f':
                                this.gl['uniform' + type](uniform.location, v[0], v[1]);
                                break;
                            case '3f':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2]);
                                break;
                            case '4f':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2], v[3]);
                                break;
                            case '2i':
                                this.gl['uniform' + type](uniform.location, v[0], v[1]);
                                break;
                            case '3i':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2]);
                                break;
                            case '4i':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2], v[3]);
                                break;
                            case '2ui':
                                this.gl['uniform' + type](uniform.location, v[0], v[1]);
                                break;
                            case '3ui':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2]);
                                break;
                            case '4ui':
                                this.gl['uniform' + type](uniform.location, v[0], v[1], v[2], v[3]);
                                break;
                            default:
                                this.gl['uniform' + type](uniform.location, v);
                                break;
                        }
                    }
                    break;
            }
            // if (window.skipSameUniforms) {
            // uniform.oldValue = cloneUniformValue(v);
            // }
            cacheUniformValue(uniform, v);
        }
        let meshType = overrides?.type != void 0 ? overrides.type : this.type;
        // angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );
        let isInstancing = false;
        let numInstances = 1;
        for (let k in geometry.attributes) {
            // TODO: this is because of virtual geometry instance selection that relies on a instanceIndex attribute, but without instancing
            // the fix is simply to rename this atteibute on cluster to something like "indexInstance".
            // a better fix would be to find a betetr way to detect instancing
            if (/^instance/.test(k) && k !== 'instanceIndex') {
                isInstancing = true;
                numInstances = Math.max(1, geometry.attributes[k].length / geometry.attributes[k].size);
                geometry.attributes[k];
                break;
                // console.log('numInstances',numInstances); 
            }
        }
        // MULTI DRAW
        if (geometry.indirectBuffer && geometry.drawCommands) {
            if (!this.multiDrawExtention) {
                this.multiDrawExtention = this.gl.getExtension("WEBGL_multi_draw");
                if (!this.multiDrawExtention) {
                    console.error("WEBGL_multi_draw extension not available!");
                }
            }
            // Convert drawCommands buffer to separate arrays
            const drawCount = geometry.drawCommands.length / 5;
            const firsts = new Int32Array(drawCount);
            const counts = new Int32Array(drawCount);
            const instanceCounts = new Int32Array(drawCount);
            const baseInstances = new Int32Array(drawCount);
            for (let i = 0, j = 0; i < drawCount; i++, j += 5) {
                counts[i] = geometry.drawCommands[j]; // vertexCount
                instanceCounts[i] = geometry.drawCommands[j + 1]; // instanceCount
                firsts[i] = geometry.drawCommands[j + 2]; // firstVertex
                baseInstances[i] = geometry.drawCommands[j + 4]; // baseInstance
            }
            this.multiDrawExtention.multiDrawArraysInstancedWEBGL(this.gl.TRIANGLES, firsts, 0, // First vertices
            counts, 0, // Vertex counts
            instanceCounts, 0, // Instance counts
            drawCount);
        }
        // TRANSFORM FEEDBACKS
        else if (usetransformFeedback) {
            this.gl.enable(this.gl.RASTERIZER_DISCARD);
            this.gl.bindTransformFeedback(this.gl.TRANSFORM_FEEDBACK, this.transformFeedback);
            this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, overrides.transformFeedBackBuffer);
            this.gl.beginTransformFeedback(this.gl.POINTS);
            this.gl.drawArrays(this.gl.POINTS, 0, geometry.length);
            this.gl.endTransformFeedback();
            this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, null);
            this.gl.disable(this.gl.RASTERIZER_DISCARD);
        }
        // INSTANCING
        else if (isInstancing) {
            let indices = geometry.indexBuffer || geometry.attributes['index'];
            if (indices) {
                let indicesType = this.gl.UNSIGNED_SHORT;
                if (indices.data instanceof Uint32Array) {
                    indicesType = this.gl.UNSIGNED_INT;
                }
                indices.bind();
                this.gl.drawElementsInstanced(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), indices.length, indicesType, 0, // offset
                numInstances // num instances
                );
            }
            else {
                this.gl.drawArraysInstanced(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), 0, // offset
                geometry.length, // num vertices per instance
                numInstances);
            }
        }
        // NO INSTANCING
        else {
            let indices = geometry.indexBuffer || geometry.attributes['index'];
            if ((meshType !== this.gl.POINTS)
                && indices) {
                let indicesType = this.gl.UNSIGNED_SHORT;
                if (indices.data instanceof Uint32Array) {
                    indicesType = this.gl.UNSIGNED_INT;
                }
                indices.bind();
                this.gl.drawElements(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), indices.length, indicesType, 0);
            }
            else {
                this.gl.drawArrays(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), 0, geometry.length);
            }
        }
    }
    setUniformHandle(uniform, value, forceUpload = false) {
        uniform.value = value;
    }
    setUniformHandleWitName(uniform, name, value, forceUpload = false) {
        if (this.uniforms[name]) {
            this.uniforms[name].value = value;
        }
    }
    setUniform(name, value) {
        if (this.uniforms[name]) {
            this.uniforms[name].value = value;
        }
    }
    setUniformsFrom(uniformValues) {
        if (!uniformValues) {
            return;
        }
        const uniforms = this.uniforms;
        const uniformKeys = this._uniformKeys;
        for (let i = 0; i < uniformKeys.length; i++) {
            const uniformName = uniformKeys[i];
            if (Object.prototype.hasOwnProperty.call(uniformValues, uniformName)) {
                uniforms[uniformName].value =
                    uniformValues[uniformName];
            }
        }
    }
    setUniformBuffer(blockName, buffer) {
        const block = this.uniformBlocks?.find(b => b.blockName === blockName);
        if (!block) {
            console.warn(`Uniform block "${blockName}" not found on program`, this.name || this.uuid);
            return;
        }
        this.uniformBlockBuffers = this.uniformBlockBuffers || {};
        const glBuffer = buffer.buffer || buffer;
        this.uniformBlockBuffers[blockName] = {
            buffer: glBuffer,
            binding: block.binding,
            layout: block.layout,
            external: true,
        };
    }
    setDefine(name, value) {
        if (value == null) {
            delete this.defines[name];
        }
        else {
            this.defines[name] = value;
        }
    }
}

/*
 * compute filtering enum, return one of the following :
 *  NEAREST
 *  LINEAR
 *  NEAREST_MIPMAP_NEAREST
 *  LINEAR_MIPMAP_NEAREST
 *  NEAREST_MIPMAP_LINEAR
 *  LINEAR_MIPMAP_LINEAR
 */
function getFilter(smooth, mipmap, miplinear) {
    return 0x2600 | (+smooth) | (+mipmap << 8) | (+(mipmap && miplinear) << 1);
}

function isPowerOf2(value) {
    return (value & (value - 1)) == 0;
}

/**
 * Low-level GPU interface used by the renderer.
 * Abstracts the underlying graphics backend (WebGL, WebGPU).
 */
class BaseGraphicsDevice {
    /**
     * Creates and initializes a graphics device bound to a presentation surface.
     * @param {HTMLCanvasElement} canvas - The canvas used as the rendering surface.
     * @param {Object} [options] - Backend and device configuration options
     */
    constructor(canvas, options = {}) { }
    /**
     * Defines the color used when clearing color buffers.
     * @param {number} r - Red component in the range [0, 1].
     * @param {number} g - Green component in the range [0, 1].
     * @param {number} b - Blue component in the range [0, 1].
     * @param {number} a - Alpha component in the range [0, 1].
     */
    clearColor(r, g, b, a) { }
    /**
     * Clears the currently bound render targets.
     * @param {boolean} color - Whether the color buffer should be cleared.
     * @param {boolean} depth - Whether the depth buffer should be cleared.
     * @param {boolean} stencil - Whether the stencil buffer should be cleared.
     */
    clear(color, depth, stencil) { }
    /**
     * Resizes the presentation surface and updates all dependent GPU resources,
     * including swapchain attachments and depth buffers.
     * @param {number} w - New width in pixels.
     * @param {number} h - New height in pixels.
     */
    resize(w, h) { }
    /**
     * Begins a render pass targeting the specified framebuffer.
     * @param {FrameBuffer|null} frameBuffer - The render target for this pass. If null, the default backbuffer is used.
     * @param {Object} [options] - Render pass configuration, such as clear values and load/store operations.
     */
    beginPass(frameBuffer, options = {}) { }
    /**
     * Ends the current render pass and finalizes the recorded GPU commands.
     * @param {FrameBuffer|null} frameBuffer - The render target that was active during the pass.
     */
    endPass(frameBuffer) { }
    createBuffer() { }
    updateBuffer() { }
    createUniform() { }
    updateUniform() { }
    createProgram() { }
}

const UNIFORM_TYPES = {};
UNIFORM_TYPES[5126 /*FLOAT       */] = '1f';
UNIFORM_TYPES[35664 /*FLOAT_VEC2  */] = '2f';
UNIFORM_TYPES[35665 /*FLOAT_VEC3  */] = '3f';
UNIFORM_TYPES[35666 /*FLOAT_VEC4  */] = '4f';
UNIFORM_TYPES[35670 /*BOOL        */] = '1i';
UNIFORM_TYPES[5124 /*INT         */] = '1i';
UNIFORM_TYPES[35678 /*SAMPLER_2D  */] = '1i';
UNIFORM_TYPES[35679 /*SAMPLER_3D */] = '1i';
UNIFORM_TYPES[35680 /*SAMPLER_CUBE*/] = '1i';
UNIFORM_TYPES[36289 /*SAMPLER_2D_ARRAY*/] = '1i';
UNIFORM_TYPES[35671 /*BOOL_VEC2   */] = '2i';
UNIFORM_TYPES[35667 /*INT_VEC2    */] = '2i';
UNIFORM_TYPES[35672 /*BOOL_VEC3   */] = '3i';
UNIFORM_TYPES[35668 /*INT_VEC3    */] = '3i';
UNIFORM_TYPES[35673 /*BOOL_VEC4   */] = '4i';
UNIFORM_TYPES[35669 /*INT_VEC4    */] = '4i';
UNIFORM_TYPES[35674 /*FLOAT_MAT2  */] = 'Matrix2f';
UNIFORM_TYPES[35675 /*FLOAT_MAT3  */] = 'Matrix3f';
UNIFORM_TYPES[35676 /*FLOAT_MAT4  */] = 'Matrix4f';

const IS_SAFARI = /Safari/g.test(navigator.userAgent) && !/Chrome/g.test(navigator.userAgent);
const TEXTURE_2D = 35678;
const TEXTURE_3D = 35679;
const TEXTURE_CUBE_MAP = 35680;
const SAMPLER_2D_ARRAY = 36289;
// let angle_instanced_array;
let currentState = {
    attributes: [],
    uniforms: {},
    depthTest: null,
    blend: false,
    program: null,
    geometry: null
};
class Program {
    constructor(gl, options = {}) {
        if (options.name) {
            this.name = options.name;
        }
        if (options.id) {
            this.id = options.id;
        }
        this._uuid = generateUUID();
        this.uuid = this._uuid;
        if (!gl) {
            return;
        }
        options = Object.assign({}, {
            vertexShader: vertexShader,
            fragmentShader: defaultFragmentShader,
            defines: {},
            extentions: {},
            type: gl.TRIANGLES,
            uniforms: {},
            transformFeedbackVaryings: null
        }, options);
        this.options = options;
        this._vertexShaderSource = options.vertexShader;
        this._fragmentShaderSource = options.fragmentShader;
        this.name = options.name;
        this.gl = gl;
        this._program = gl.createProgram(this.name);
        this.vertexShader = gl.createShader(gl.VERTEX_SHADER);
        this.fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.attachShader(this._program, this.vertexShader);
        gl.attachShader(this._program, this.fragmentShader);
        if (options.transformFeedbackVaryings) {
            this.transformFeedback = gl.createTransformFeedback();
            gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.transformFeedback);
            gl.transformFeedbackVaryings(this._program, options.transformFeedbackVaryings, gl.SEPARATE_ATTRIBS);
        }
        this.type = options.type;
        this.attributes = {};
        this.defines = options.defines;
        this._lastDefines = {};
        this.extentions = options.extentions;
        this._textureUnit = 0;
        this.depthTest = options.depthTest !== void 0 ? options.depthTest : true;
        this.blend = options.blend !== void 0 ? options.blend : false;
        this.blendEquation = options.blendEquation !== void 0 ? options.blendEquation : this.gl.FUNC_ADD;
        this.blendEquationSeparate = options.blendEquationSeparate !== void 0 ? options.blendEquationSeparate : null;
        this.blendSrc = options.blendSrc !== void 0 ? options.blendSrc : this.gl.SRC_ALPHA;
        this.blendDst = options.blendDst !== void 0 ? options.blendDst : this.gl.ONE_MINUS_SRC_ALPHA;
        this.blendSrcRGB = options.blendSrcRGB !== void 0 ? options.blendSrcRGB : this.gl.SRC_ALPHA;
        this.blendDstRGB = options.blendDstRGB !== void 0 ? options.blendDstRGB : this.gl.ONE_MINUS_SRC_ALPHA;
        this.blendSrcAlpha = options.blendSrcAlpha !== void 0 ? options.blendSrcAlpha : this.gl.ONE;
        this.blendDstAlpha = options.blendDstAlpha !== void 0 ? options.blendDstAlpha : this.gl.ONE_MINUS_SRC_ALPHA;
        this.wireframe = options.wireframe !== void 0 ? options.wireframe : false;
        this.lines = options.lines !== void 0 ? options.lines : false;
        this.uniforms = {};
        this.defaultUniforms = options.uniforms;
        this.compile();
    }
    compile(force) {
        if (!this.gl) {
            return;
        }
        if (this.isCompiling) {
            return;
        }
        this.isCompiling = true;
        //fix: this forces Safari to update ACTIVE_UNIFORMS after first compile()
        if (IS_SAFARI || force) {
            this.gl.detachShader(this._program, this.vertexShader);
            this.gl.detachShader(this._program, this.fragmentShader);
            this.vertexShader = this.gl.createShader(this.gl.VERTEX_SHADER);
            this.fragmentShader = this.gl.createShader(this.gl.FRAGMENT_SHADER);
            this.gl.attachShader(this._program, this.vertexShader);
            this.gl.attachShader(this._program, this.fragmentShader);
        }
        if (!(ShaderCompiler.compile(this.gl, this.vertexShader, this._vertexShaderSource, this.defines) &&
            ShaderCompiler.compile(this.gl, this.fragmentShader, this._fragmentShaderSource, this.defines))) {
            console.warn('compile error');
            return false;
        }
        this.gl.linkProgram(this._program);
        if (!this.gl.getProgramParameter(this._program, this.gl.LINK_STATUS)) {
            console.error("Cannot link program: \n" + this.gl.getProgramInfoLog(this._program) || "");
            // console.warn("VERTEX_SHADER:\n"+addLineNumbers(this._vertexShaderSource)
            //             +"\n\nFRAGMENT_SHADER:\n"+addLineNumbers(this._fragmentShaderSource));
        }
        this.gl.useProgram(this._program);
        this._retrieveUniformsFromShader();
    }
    _retrieveUniformsFromShader() {
        /**
         * When re-compiling, we dont wanna loose current uniform values
         * another appoch would be to set uniforms on Program instead of tagrte uniform.value:
         * program.uniform[uniformName]
         *   instead of
         *  program.uniforms[uniformName].value
         */
        this._savedUniforms = {};
        for (let k in this.uniforms) {
            this._savedUniforms[k] = {
                value: this.uniforms[k].value
            };
        }
        this.uniforms = {};
        this._textureUnit = 0;
        var numUniforms = this.gl.getProgramParameter(this._program, this.gl.ACTIVE_UNIFORMS);
        for (let i = 0; i < numUniforms; ++i) {
            var uniform = this.gl.getActiveUniform(this._program, i);
            if (uniform === null) {
                this.gl.getError();
                continue;
            }
            let name = uniform.name;
            let isArray = false; //is uniform array  ?(ex: 3fv, 4fv...)
            // tltr; we want 'myUniform[0]' to become 'myUniform'
            // if array uniform, replace the retrieved name as it includes the first index acces
            if (/\[.*\]/.test(name)) {
                isArray = true;
                name = name.replace(/\[.*\]/, '');
            }
            if (this.uniforms[name] !== void 0) {
                this.uniforms[name].location = this.gl.getUniformLocation(this._program, name);
                this.uniforms[name].type = uniform.type;
            }
            else {
                this.uniforms[name] = {
                    isArray: isArray,
                    location: this.gl.getUniformLocation(this._program, name),
                    type: uniform.type,
                    value: null,
                    oldValue: null,
                    size: uniform.size
                };
                //set texture unit
                if (uniform.type === TEXTURE_2D || uniform.type === TEXTURE_CUBE_MAP || uniform.type == TEXTURE_3D || uniform.type == SAMPLER_2D_ARRAY) {
                    this.uniforms[name].unit = this._textureUnit;
                    this._textureUnit++;
                }
            }
        }
        //merge user defined uniforms
        for (let u in this._savedUniforms) {
            if (this.uniforms[u] !== void 0) {
                if (this._savedUniforms[u].value !== void 0
                    && this._savedUniforms[u].value !== null) {
                    this.uniforms[u].value = this._savedUniforms[u].value;
                }
            }
        }
        /**
         * Restore unfiroms values set on Program creation by user
         */
        for (let u in this.defaultUniforms) {
            if (this.uniforms[u] !== void 0
                && this.defaultUniforms[u] !== void 0
                && this.defaultUniforms[u] !== null) {
                this.uniforms[u].value = this.defaultUniforms[u];
            }
        }
        var numAttributes = this.gl.getProgramParameter(this._program, this.gl.ACTIVE_ATTRIBUTES);
        for (let i = 0; i < numAttributes; ++i) {
            var attribute = this.gl.getActiveAttrib(this._program, i);
            if (attribute === null) {
                this.gl.getError();
                continue;
            }
            this.attributes[attribute.name] = {
                location: this.gl.getAttribLocation(this._program, attribute.name),
                type: attribute.type
            };
            //the attribute is only enabled when the buffer is binded
            //(so it's enabled by the Program that will use the buffer)
            //this way we make sure that any enabled attribute has some data not to trigger an error
            //see http://www.mjbshaw.com/2013/03/webgl-fixing-invalidoperation.html
            // this.gl.enableVertexAttribArray( this.attributes[attribute.name].location );
        }
        this.isCompiling = false;
    }
    dispose() {
    }
    use() {
        if (!this.gl) {
            return;
        }
        this.gl.useProgram(this._program);
    }
    attribPointer(geometry) {
        if (!this.gl) {
            console.warn('Program.attribPointer error: missing gl');
            return;
        }
        // angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );
        for (var attr in this.attributes) {
            if (geometry.attributes[attr] !== void 0) {
                if (attr == 'instanceMatrix') {
                    // const bytesPerMatrix = 16 * 4;
                    // for (let i = 0; i < 4; ++i) {
                    //   const loc = this.attributes[attr].location + i;
                    //   geometry.attributes[attr].bind();
                    //   this.gl.enableVertexAttribArray(loc);
                    //   this.gl?.vertexAttribDivisor(loc, 1);
                    //   const offset = i * 16;  // 4 floats per row, 4 bytes per float
                    //   this.gl.vertexAttribPointer(
                    //     loc,                // location
                    //     4,                  // size (num values to pull from buffer per iteration)
                    //     geometry.attributes[attr].type,         // type of data in buffer
                    //     false,              // normalize
                    //     bytesPerMatrix,     // stride, num bytes to advance to get to next set of values
                    //     offset              // offset in buffer
                    //   );
                    // }
                    // in webgl, we cannot pass matrix as single 16 floats array, instead we pass it a 4 rows of 4 floats
                    // so  matrix row here is a vec4 attribute, and in the shader, it groups those 4 rows into a mat4
                    // const bytesPerMatrix = (16) * 4;//4 bits * 4 flat = 1 row
                    for (let i = 0; i < 4; ++i) {
                        const loc = this.attributes[attr].location + i;
                        this.gl.enableVertexAttribArray(loc);
                        this.gl.vertexAttribDivisor(loc, 1);
                        geometry.attributes[attr].bind(); //bindin the same buffer, but we use different offset/stride
                        this.gl.vertexAttribPointer(loc, // location
                        4, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                        this.gl.FLOAT, //geometry.attributes[attr].type, // type of data in buffer
                        false, // normalize
                        16 * 4, //bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                        i * 4 * 4 // offset in buffer |  4 floats per row, 4 bytes per float
                        );
                    }
                    // console.log('attribPointer', Object.keys(this.attributes))
                }
                // else if (attr == 'instanceCardAtlasInfos0' || attr == 'instanceCardAtlasInfos1' || attr == 'instanceCardAtlasInfos2' || attr == 'instanceCardAtlasInfos3' || attr == 'instanceCardAtlasInfos4' || attr == 'instanceCardAtlasInfos5' ) {
                //   const loc = this.attributes[attr].location;
                //   this.gl.enableVertexAttribArray(loc);
                //   this.gl.vertexAttribDivisor(loc, 1);
                //   geometry.attributes[attr].bind();
                //   this.gl.vertexAttribPointer(
                //     loc, // location
                //     4, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                //     this.gl.FLOAT,//geometry.attributes[attr].type, // type of data in buffer
                //     false, // normalize
                //     4 * 4,//bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                //     0 // offset in buffer |  4 floats per row, 4 bytes per float
                //   );
                // }
                else if (attr == 'instanceColor' || attr == 'instancePosition' || attr == 'instanceRotation' || attr == 'instanceScale' || attr == 'instanceTilePosition' || attr == 'instanceTileScale' || attr == 'instanceLightmapTileInfos') {
                    const loc = this.attributes[attr].location;
                    // console.log('  -'+attr, "vertexAttribPointer: instanced vec3",loc )
                    this.gl.enableVertexAttribArray(loc);
                    this.gl.vertexAttribDivisor(loc, 1);
                    geometry.attributes[attr].bind();
                    this.gl.vertexAttribPointer(loc, // location
                    3, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                    this.gl.FLOAT, //geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    3 * 4, //bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                    0 // offset in buffer |  4 floats per row, 4 bytes per float
                    );
                }
                else if (attr == 'instanceUv' || attr == 'instanceLightmapTileOffset') {
                    const loc = this.attributes[attr].location;
                    // console.log('  -'+attr, "vertexAttribPointer: instanced vec2",loc )
                    this.gl.enableVertexAttribArray(loc);
                    this.gl.vertexAttribDivisor(loc, 1);
                    geometry.attributes[attr].bind();
                    this.gl.vertexAttribPointer(loc, // location
                    2, // size (num values to pull from buffer per iteration) : 4 float = 1 row
                    this.gl.FLOAT, //geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    2 * 4, //bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
                    0 // offset in buffer |  4 floats per row, 4 bytes per float
                    );
                }
                else if (
                // TODO: need to pass this as a settign to the program. maybe setting instances attribute, and their types
                attr == 'instanceShadowVisibility' || attr == 'instanceCardAtlasInfos' || attr == 'probeIndex' ||
                    attr == 'instanceClusterIndex' || attr == 'instanceFaceAtlasStartIndex' || attr == 'instanceTileLevel' ||
                    attr == 'instanceTileIndex' || attr == 'instanceIndex2' || attr == 'instanceLightmapTileSize' ||
                    attr == 'instanceFoliageTileIndex' || attr == 'instanceFoliageIndex' ||
                    attr == 'instanceMatrixIndex') {
                    const loc = this.attributes[attr].location;
                    // console.log('  -'+attr, "vertexAttribPointer: instanced float",loc )
                    // const bytesPerMatrix = 4 ;
                    geometry.attributes[attr].bind();
                    this.gl.enableVertexAttribArray(loc);
                    this.gl?.vertexAttribDivisor(loc, 1);
                    const offset = 0; // 4 bytes per float
                    this.gl.vertexAttribPointer(loc, // location
                    1, // size (num values to pull from buffer per iteration)
                    geometry.attributes[attr].type, // type of data in buffer
                    false, // normalize
                    1 * 4 /*bytesPerMatrix*/, // stride, num bytes to advance to get to next set of values
                    offset);
                }
                else {
                    const { location, stride, offset } = this.attributes[attr];
                    const { size, type } = geometry.attributes[attr];
                    // if (   !currentState.attributes[ location ]
                    //     || currentState.attributes[ location ].buffer != geometry.attributes[attr]
                    // || !settings.compareAttributes
                    // ){
                    // if ( currentState.attributes[ location ]
                    //      && currentState.attributes[ location ].divisor  ) {
                    this.gl?.vertexAttribDivisor(location, 0);
                    // }
                    // if (!currentState.attributes[ location ]
                    // || !settings.compareAttributes
                    // ) {
                    this.gl.enableVertexAttribArray(location);
                    // }
                    geometry.attributes[attr].bind();
                    if (offset && stride) {
                        this.gl.vertexAttribPointer(location, size, type, false /*normalized*/, stride, offset);
                    }
                    else {
                        this.gl.vertexAttribPointer(location, size, type, false /*normalized*/, 0, 0);
                    }
                    // currentState.attributes[ location ] = {divisor: false, name: attr, buffer: geometry.attributes[attr]}
                    // }
                }
            }
        }
    }
    clone() {
        return;
    }
    //overrides: applied on Scene, passed by Mesh
    // same as overrideMaterial but just for GL states
    draw(geometry, options) {
        const usetransformFeedback = options?.usetransformFeedback;
        const overrides = options?.overrides;
        if (!this.gl) {
            return;
        }
        let definesL = Object.keys(this.defines);
        let lastDefinesL = Object.keys(this._lastDefines);
        let needsCompile = definesL.length != lastDefinesL.length;
        for (var d in this.defines) {
            if (this.defines[d] !== this._lastDefines[d]) {
                needsCompile = true;
            }
        }
        if (needsCompile) {
            this._lastDefines = {};
            for (var d in this.defines) {
                this._lastDefines[d] = this.defines[d];
            }
            this.compile();
        }
        if (needsCompile || this._program !== currentState.program) {
            this.gl.useProgram(this._program);
            currentState.program = this._program;
        }
        //!!! WARNING  THIS OPTIM BREAKS SKY ADN OTHER THINGS ON WINDOWS !!!
        // if (geometry !== _lastUsedGeometry) {
        //TODO: check if geometry has changed
        this.attribPointer(geometry);
        // }
        let _depthTest = overrides?.depthTest != void 0 ? overrides.depthTest : this.depthTest;
        if (_depthTest !== currentState.depthTest) {
            this.gl[_depthTest ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
            currentState.depthTest = _depthTest;
        }
        if (overrides?.blend || this.blend) {
            console.log('WEBGL_PROGRAM');
            // this.gl.disable(this.gl.DEPTH_TEST);
            // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
            if (_depthTest) {
                if (overrides?.depthFunc) {
                    this.gl.depthFunc(overrides.depthFunc);
                }
                else {
                    this.gl.depthFunc(this.gl.LESS);
                }
            }
            if (overrides?.blendEquation) {
                this.gl.blendEquationSeparate(this.blendEquation, overrides?.blendEquation);
                currentState.blendEquation = null;
            }
            else if (overrides?.blendEquationRGB) {
                this.gl.blendEquationSeparate(overrides?.blendEquationRGB, this.blendEquation);
                currentState.blendEquation = null;
            }
            else if (overrides?.blendEquationSeparate) {
                this.gl.blendEquationSeparate(overrides.blendEquationSeparate.rgb, overrides.blendEquationSeparate.alpha);
                currentState.blendEquation = null;
            }
            else {
                if (this.blendEquationSeparate) {
                    this.gl.blendEquationSeparate(this.blendEquationSeparate.rgb, this.blendEquationSeparate.alpha);
                }
                else {
                    if (currentState.blendEquation !== (overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation)) {
                        this.gl.blendEquation((overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation));
                        currentState.blendEquation = (overrides?.blendEquation || overrides?.blendEquationRGB || this.blendEquation);
                    }
                }
            }
            const blendSrcRGB = (overrides?.blendSrcRGB !== void 0 ? overrides?.blendSrcRGB : this.blendSrcRGB);
            const blendDstRGB = (overrides?.blendDstRGB !== void 0 ? overrides?.blendDstRGB : this.blendDstRGB);
            const blendSrcAlpha = (overrides?.blendSrcAlpha !== void 0 ? overrides?.blendSrcAlpha : this.blendSrcAlpha);
            const blendDstAlpha = (overrides?.blendDstAlpha !== void 0 ? overrides?.blendDstAlpha : this.blendDstAlpha);
            if (currentState.blendSrcRGB !== blendSrcRGB ||
                currentState.blendDstRGB !== blendDstRGB ||
                currentState.blendSrcAlpha !== blendSrcAlpha ||
                currentState.blendDstAlpha !== blendDstAlpha) {
                currentState.blendSrcRGB = blendSrcRGB;
                currentState.blendDstRGB = blendDstRGB;
                currentState.blendSrcAlpha = blendSrcAlpha;
                currentState.blendDstAlpha = blendDstAlpha;
                this.gl.blendFuncSeparate(blendSrcRGB, blendDstRGB, blendSrcAlpha, blendDstAlpha);
            }
            // this.gl.blendFunc(this.blendSrc,this.blendDst);
            if (!currentState.blend) {
                this.gl.enable(this.gl.BLEND);
                currentState.blend = true;
            }
        }
        else {
            if (currentState.blend) {
                this.gl.disable(this.gl.BLEND);
                currentState.blend = false;
            }
            // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
            if (overrides?.depthFunc) {
                this.gl.depthFunc(overrides.depthFunc);
            }
            else {
                this.gl.depthFunc(this.gl.LESS);
            }
        }
        var keys = Object.keys(this.uniforms);
        for (var i = 0, l = keys.length; i < l; i++) {
            let uniformName = keys[i];
            if (this.uniforms[uniformName].value !== null
                && this.uniforms[uniformName].value !== void 0) {
                switch (this.uniforms[uniformName].type) {
                    case this.gl.FLOAT_MAT2:
                    case this.gl.FLOAT_MAT3:
                    case this.gl.FLOAT_MAT4:
                        // if (settings.compareUniforms) {
                        // if (this.uniforms[ uniformName ].oldValue !== null && !isNewProgram) {
                        //   needChange = false
                        //   let array1 = this.uniforms[ uniformName ].value;
                        //   let array2 = this.uniforms[ uniformName ].oldValue;
                        //   if (array1.length !== array2.length) {
                        //     needChange = true
                        //   }
                        //   else {
                        //     for (var j = 0; j < array1.length; j++) {
                        //       if (array1[j] !== array2[j]) {
                        //         needChange = true
                        //         break
                        //       }
                        //     }
                        //   }
                        // }
                        // else {
                        //   needChange = true 
                        // }
                        // }
                        {
                            if (this.uniforms[uniformName].value && this.uniforms[uniformName].value.length > 0) {
                                this.gl['uniform' + UNIFORM_TYPES[this.uniforms[uniformName].type] + 'v'](this.uniforms[uniformName].location, false, this.uniforms[uniformName].value);
                                this.uniforms[uniformName].oldValue = this.uniforms[uniformName].value;
                                currentState.uniforms[uniformName] = this.uniforms[uniformName].value;
                            }
                        }
                        break;
                    default:
                        //texture unfirom
                        if (this.uniforms[uniformName].type === TEXTURE_2D ||
                            this.uniforms[uniformName].type === TEXTURE_CUBE_MAP ||
                            this.uniforms[uniformName].type === TEXTURE_3D ||
                            this.uniforms[uniformName].type === SAMPLER_2D_ARRAY) {
                            // let needChange = true;
                            // if (settings.compareUniforms) {
                            // if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] != void 0 &&
                            //     currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== null && 
                            //     !isNewProgram) {
                            //     needChange = false;
                            //   if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== this.uniforms[ uniformName ].value) {
                            //     needChange = true
                            //   }
                            //   currentBindedSamplers[ this.uniforms[ uniformName ].unit ] = this.uniforms[ uniformName ].value
                            // }
                            // else {
                            //   needChange = true;
                            // }
                            // }
                            // if (needChange) {
                            this.uniforms[uniformName].value.bind(this.uniforms[uniformName].unit);
                            this.gl['uniform' + UNIFORM_TYPES[this.uniforms[uniformName].type]](this.uniforms[uniformName].location, this.uniforms[uniformName].unit);
                            // }
                        }
                        else {
                            let type = UNIFORM_TYPES[this.uniforms[keys[i]].type];
                            //add 'v' to the uniformType if the unifor is an array: ex "3f" => "3fv"
                            if (this.uniforms[uniformName].isArray) {
                                type += 'v';
                            }
                            // if (settings.compareUniforms) {
                            // if (currentBindedUniforms[ uniformName ] != void 0 &&
                            //     currentBindedUniforms[ uniformName ] !== null && 
                            //     !isNewProgram) {
                            //       needChange = false;
                            //     if ( typeof currentBindedUniforms[ uniformName ] == 'number') {
                            //       if (currentBindedUniforms[ uniformName ] !== this.uniforms[ uniformName ].value) {
                            //         needChange = true
                            //       }
                            //     }
                            //     else if (currentBindedUniforms[ uniformName ].length) {
                            //       needChange = false
                            //       let array1 = this.uniforms[ uniformName ].value;
                            //       let array2 = currentBindedUniforms[ uniformName ];
                            //       if (array1.length !== array2.length) {
                            //         needChange = true
                            //       }
                            //       else {
                            //         for (var j = 0; j < array1.length; j++) {
                            //           if (array1[j] !== array2[j]) {
                            //             needChange = true
                            //             break
                            //           }
                            //         }
                            //       }
                            //     }
                            //     else {
                            //       needChange = true    
                            //     }
                            //     currentBindedUniforms[ uniformName ] = this.uniforms[ uniformName ].value
                            // }
                            // else {
                            //   needChange = true;
                            // }
                            // }
                            {
                                let v = this.uniforms[uniformName].value;
                                switch (type) {
                                    case '2f':
                                        // console.log('BIND VEC2 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                                        this.gl['uniform' + type](this.uniforms[uniformName].location, v[0], v[1]);
                                        break;
                                    case '3f':
                                        // console.log('BIND VEC3 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                                        this.gl['uniform' + type](this.uniforms[uniformName].location, v[0], v[1], v[2]);
                                        break;
                                    case '4f':
                                        // console.log('BIND VEC4 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                                        this.gl['uniform' + type](this.uniforms[uniformName].location, v[0], v[1], v[2], v[3]);
                                        break;
                                    default:
                                        this.gl['uniform' + type](this.uniforms[uniformName].location, v);
                                        break;
                                }
                            }
                        }
                        break;
                }
            }
        }
        let meshType = overrides?.type != void 0 ? overrides.type : this.type;
        // angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );
        let isInstancing = false;
        let numInstances = 1;
        for (let k in geometry.attributes) {
            // TODO: this is because of virtual geometry instance selection that relies on a instanceIndex attribute, but without instancing
            // the fix is simply to rename this atteibute on cluster to something like "indexInstance".
            // a better fix would be to find a betetr way to detect instancing
            if (/^instance/.test(k) && k !== 'instanceIndex') {
                isInstancing = true;
                numInstances = Math.max(1, geometry.attributes[k].length / geometry.attributes[k].size);
                geometry.attributes[k];
                // console.log('numInstances',numInstances); 
            }
        }
        if (geometry.indirectBuffer && geometry.drawCommands) {
            if (!this.multiDrawExtention) {
                this.multiDrawExtention = this.gl.getExtension("WEBGL_multi_draw");
                if (!this.multiDrawExtention) {
                    console.error("WEBGL_multi_draw extension not available!");
                }
            }
            // Convert drawCommands buffer to separate arrays
            const drawCount = geometry.drawCommands.length / 5;
            const firsts = new Int32Array(drawCount);
            const counts = new Int32Array(drawCount);
            const instanceCounts = new Int32Array(drawCount);
            const baseInstances = new Int32Array(drawCount);
            for (let i = 0, j = 0; i < drawCount; i++, j += 5) {
                counts[i] = geometry.drawCommands[j]; // vertexCount
                instanceCounts[i] = geometry.drawCommands[j + 1]; // instanceCount
                firsts[i] = geometry.drawCommands[j + 2]; // firstVertex
                baseInstances[i] = geometry.drawCommands[j + 4]; // baseInstance
            }
            // this.gl.bindBuffer(this.gl.DRAW_INDIRECT_BUFFER, geometry.indirectBuffer);
            this.multiDrawExtention.multiDrawArraysInstancedWEBGL(this.gl.TRIANGLES, firsts, 0, // First vertices
            counts, 0, // Vertex counts
            instanceCounts, 0, // Instance counts
            drawCount);
        }
        else if (usetransformFeedback) {
            // console.log('TRANSFORM_FEEDBACK TRANSFORM_FEEDBACK TRANSFORM_FEEDBACK ', geometry.length, overrides, usetransformFeedback )
            this.gl.enable(this.gl.RASTERIZER_DISCARD);
            this.gl.bindTransformFeedback(this.gl.TRANSFORM_FEEDBACK, this.transformFeedback);
            this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, overrides.transformFeedBackBuffer);
            this.gl.beginTransformFeedback(this.gl.POINTS);
            this.gl.drawArrays(this.gl.POINTS, 0, geometry.length);
            this.gl.endTransformFeedback();
            this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, null);
            this.gl.disable(this.gl.RASTERIZER_DISCARD);
        }
        else if (isInstancing) {
            // geometry.attributes['instanceFoliageIndex'] !== void 0 && instanceAttributeName !== 'instanceFoliageIndex' && console.log('instanceAttributeName', instanceAttributeName, numInstances);
            let indices = geometry.indexBuffer || geometry.attributes['index'];
            if (indices) {
                let indicesType = this.gl.UNSIGNED_SHORT;
                if (indices.data instanceof Uint32Array) {
                    indicesType = this.gl.UNSIGNED_INT;
                }
                // else if (indices instanceof Uint8Array) {
                //   indicesType = this.gl.UNSIGNED_BYTE;
                // }
                indices.bind();
                this.gl.drawElementsInstanced(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), indices.length, indicesType, 0, // offset
                numInstances // num instances
                );
            }
            else {
                this.gl.drawArraysInstanced(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), 0, // offset
                geometry.length, // num vertices per instance
                numInstances);
            }
        }
        else {
            let indices = geometry.indexBuffer || geometry.attributes['index'];
            if ((meshType !== this.gl.POINTS)
                && indices) {
                let indicesType = this.gl.UNSIGNED_SHORT;
                if (indices.data instanceof Uint32Array) {
                    indicesType = this.gl.UNSIGNED_INT;
                }
                // else if (indices instanceof Uint8Array) {
                //   indicesType = this.gl.UNSIGNED_BYTE;
                // }
                indices.bind();
                this.gl.drawElements(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), indices.length, indicesType, 0);
            }
            else {
                this.gl.drawArrays(this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP : meshType), 0, geometry.length);
            }
        }
    }
    setUniform(name, value) {
        if (this.uniforms[name]) {
            this.uniforms[name].value = value;
        }
    }
    setUniformsFrom(uniformValues) {
        if (!uniformValues) {
            return;
        }
        const uniforms = this.uniforms;
        const uniformKeys = this._uniformKeys;
        for (let i = 0; i < uniformKeys.length; i++) {
            const uniformName = uniformKeys[i];
            if (Object.prototype.hasOwnProperty.call(uniformValues, uniformName)) {
                uniforms[uniformName].value = uniformValues[uniformName];
            }
        }
    }
    setDefine(name, value) {
        if (value == null) {
            delete this.defines[name];
        }
        else {
            this.defines[name] = value;
        }
    }
}

/*
 * Minimal KTX2 container reader.
 *
 * KTX2 is two things at once, and the distinction decides how much machinery a
 * runtime needs:
 *
 *   1. A container holding GPU-ready block-compressed levels (BC7, BC5, ASTC...).
 *      Nothing to decode — hand each level straight to compressedTexImage2D.
 *   2. A container holding Basis Universal payloads (ETC1S or UASTC), which must
 *      be transcoded to a device format first, which needs the Basis WASM.
 *
 * This reads the container and reports which case it is. Case 1 needs no WASM, no
 * worker and no CPU work beyond parsing a header, and it covers the hardware this
 * project actually targets: BC7/BC5 exist on the RTX 3090 and on the Surface Pro
 * 4's Intel HD 520. Case 2 is detected and reported so a transcoder can be added
 * later without changing callers.
 *
 * Spec: https://registry.khronos.org/KTX/specs/2.0/ktxspec.v2.html
 * Only the parts needed to upload a 2D texture are implemented — no cubemaps,
 * array layers or DFD interpretation beyond what format selection requires.
 */
const IDENTIFIER = [0xAB, 0x4B, 0x54, 0x58, 0x20, 0x32, 0x30, 0xBB, 0x0D, 0x0A, 0x1A, 0x0A];
/* supercompressionScheme values from the spec */
const Supercompression = {
    NONE: 0,
    BASIS_LZ: 1,
    ZSTD: 2,
    ZLIB: 3,
};
/*
 * VkFormat values we can map to a WebGL compressed internal format. KTX2 stores a
 * Vulkan format enum; WebGL wants an extension enum, so this is the bridge.
 * vkFormat 0 means "Basis payload, format decided at transcode time".
 */
const VK_FORMAT = {
    // BC -- desktop and Intel integrated GPUs
    131: 'BC1_RGB_UNORM', 132: 'BC1_RGB_SRGB',
    133: 'BC1_RGBA_UNORM', 134: 'BC1_RGBA_SRGB',
    137: 'BC3_UNORM', 138: 'BC3_SRGB',
    139: 'BC4_UNORM',
    141: 'BC5_UNORM',
    143: 'BC6H_UFLOAT',
    145: 'BC7_UNORM', 146: 'BC7_SRGB',
    // ETC2 / EAC -- mobile
    147: 'ETC2_R8G8B8_UNORM', 148: 'ETC2_R8G8B8_SRGB',
    151: 'ETC2_R8G8B8A8_UNORM', 152: 'ETC2_R8G8B8A8_SRGB',
    153: 'EAC_R11_UNORM',
    155: 'EAC_R11G11_UNORM',
    // ASTC -- mobile. Note 157 is ASTC_4x4_UNORM_BLOCK, NOT ETC2.
    157: 'ASTC_4x4_UNORM', 158: 'ASTC_4x4_SRGB',
    165: 'ASTC_6x6_UNORM', 166: 'ASTC_6x6_SRGB',
};
/*
 * Bytes per 4x4 block (or per block of the format's own size) — needed because
 * compressedTexImage2D takes an exact byte range per level.
 */
const BLOCK_BYTES = {
    BC1_RGB_UNORM: 8, BC1_RGB_SRGB: 8, BC1_RGBA_UNORM: 8, BC1_RGBA_SRGB: 8,
    BC3_UNORM: 16, BC3_SRGB: 16,
    BC4_UNORM: 8, BC5_UNORM: 16,
    BC6H_UFLOAT: 16, BC7_UNORM: 16, BC7_SRGB: 16,
    ETC2_R8G8B8_UNORM: 8, ETC2_R8G8B8_SRGB: 8,
    ETC2_R8G8B8A8_UNORM: 16, ETC2_R8G8B8A8_SRGB: 16,
    EAC_R11_UNORM: 8, EAC_R11G11_UNORM: 16,
    ASTC_4x4_UNORM: 16, ASTC_4x4_SRGB: 16,
    ASTC_6x6_UNORM: 16, ASTC_6x6_SRGB: 16,
};
/*
 * Map a container format name to the WebGL enum, given the extension objects the
 * device actually exposes. Returns null when this device cannot sample it, which
 * callers must treat as "fall back to the uncompressed source".
 */
function webglInternalFormat(gl, formatName) {
    const s3tc = gl.getExtension('WEBGL_compressed_texture_s3tc');
    const s3tcSRGB = gl.getExtension('WEBGL_compressed_texture_s3tc_srgb');
    const bptc = gl.getExtension('EXT_texture_compression_bptc');
    const rgtc = gl.getExtension('EXT_texture_compression_rgtc');
    const astc = gl.getExtension('WEBGL_compressed_texture_astc');
    const etc = gl.getExtension('WEBGL_compressed_texture_etc');
    switch (formatName) {
        case 'BC1_RGB_UNORM': return s3tc?.COMPRESSED_RGB_S3TC_DXT1_EXT ?? null;
        case 'BC1_RGBA_UNORM': return s3tc?.COMPRESSED_RGBA_S3TC_DXT1_EXT ?? null;
        case 'BC1_RGB_SRGB': return s3tcSRGB?.COMPRESSED_SRGB_S3TC_DXT1_EXT ?? null;
        case 'BC1_RGBA_SRGB': return s3tcSRGB?.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT ?? null;
        case 'BC3_UNORM': return s3tc?.COMPRESSED_RGBA_S3TC_DXT5_EXT ?? null;
        case 'BC3_SRGB': return s3tcSRGB?.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT ?? null;
        case 'BC4_UNORM': return rgtc?.COMPRESSED_RED_RGTC1_EXT ?? null;
        case 'BC5_UNORM': return rgtc?.COMPRESSED_RED_GREEN_RGTC2_EXT ?? null;
        case 'BC6H_UFLOAT': return bptc?.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT ?? null;
        case 'BC7_UNORM': return bptc?.COMPRESSED_RGBA_BPTC_UNORM_EXT ?? null;
        case 'BC7_SRGB': return bptc?.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT ?? null;
        case 'ETC2_R8G8B8_UNORM': return etc?.COMPRESSED_RGB8_ETC2 ?? null;
        case 'ETC2_R8G8B8A8_UNORM': return etc?.COMPRESSED_RGBA8_ETC2_EAC ?? null;
        case 'EAC_R11G11_UNORM': return etc?.COMPRESSED_RG11_EAC ?? null;
        case 'ASTC_4x4_UNORM': return astc?.COMPRESSED_RGBA_ASTC_4x4_KHR ?? null;
        case 'ASTC_4x4_SRGB': return astc?.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR ?? null;
        case 'ASTC_6x6_UNORM': return astc?.COMPRESSED_RGBA_ASTC_6x6_KHR ?? null;
        default: return null;
    }
}
function blockBytes(formatName) {
    return BLOCK_BYTES[formatName] ?? 16;
}
/*
 * Parse a KTX2 buffer and upload every level to the currently bound texture.
 *
 * Shared by Texture and WebGLTexture, which duplicate rather than share their
 * upload logic; keeping the KTX2 specifics here stops that duplication doubling.
 * The caller owns binding the texture beforehand and applying filtering
 * afterwards, because those two classes track filter state differently.
 *
 * Returns null — without throwing — when the file cannot be used on this device: a
 * Basis payload we have no transcoder for, a format the GPU cannot sample, a
 * malformed file, or a driver rejection. Callers must treat null as "fall back to
 * the uncompressed source", because a device without block compression still has to
 * render.
 *
 * On success returns {formatName, width, height, levels, bytes}.
 */
function uploadKTX2(gl, target, buffer) {
    let ktx;
    try {
        ktx = parseKTX2(buffer);
    }
    catch (error) {
        console.warn('uploadKTX2: not a usable KTX2 file', error);
        return null;
    }
    if (ktx.needsTranscode) {
        console.warn('uploadKTX2: KTX2 holds a Basis payload (vkFormat 0 / BasisLZ) which needs ' +
            'the Basis transcoder. Re-encode with an explicit GPU format, e.g. ' +
            'ktx create --format BC7_UNORM_BLOCK');
        return null;
    }
    const internalFormat = ktx.formatName ? webglInternalFormat(gl, ktx.formatName) : null;
    if (internalFormat == null) {
        console.warn(`uploadKTX2: this device cannot sample ${ktx.formatName ?? 'vkFormat ' + ktx.vkFormat}`);
        return null;
    }
    /*
     * UNPACK_FLIP_Y_WEBGL cannot apply to block-compressed data — the driver would
     * have to decode it to flip it — so orientation is an encode-time concern and
     * this must be off.
     */
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
    while (gl.getError() !== gl.NO_ERROR) { /* drain unrelated errors */ }
    let bytes = 0;
    for (const level of ktx.levels) {
        gl.compressedTexImage2D(target, level.level, internalFormat, level.width, level.height, 0, level.data);
        bytes += level.data.byteLength;
    }
    const error = gl.getError();
    if (error) {
        console.warn(`uploadKTX2: driver rejected ${ktx.formatName} upload (gl error ${error})`);
        return null;
    }
    return {
        formatName: ktx.formatName,
        width: ktx.width,
        height: ktx.height,
        levels: ktx.levels.length,
        bytes,
    };
}
/*
 * Parse a KTX2 file.
 *
 * Returns:
 *   {
 *     width, height, levelCount, faceCount, layerCount,
 *     vkFormat, formatName,          // null formatName => Basis, needs transcode
 *     supercompression,              // Supercompression.*
 *     needsTranscode,                // true for Basis payloads
 *     levels: [{ level, width, height, data: Uint8Array }]  // level 0 first
 *   }
 *
 * Throws on a malformed identifier so a truncated download fails loudly rather
 * than producing a black texture.
 */
function parseKTX2(buffer) {
    const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    for (let i = 0; i < IDENTIFIER.length; i++) {
        if (bytes[i] !== IDENTIFIER[i]) {
            throw new Error('parseKTX2: not a KTX2 file (bad identifier)');
        }
    }
    const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    let offset = IDENTIFIER.length;
    const u32 = () => { const v = view.getUint32(offset, true); offset += 4; return v; };
    const u64 = () => {
        // Level byte offsets are 64-bit. Textures are far below 2^53 bytes, so
        // reading as two 32-bit halves is exact here and avoids BigInt.
        const lo = view.getUint32(offset, true);
        const hi = view.getUint32(offset + 4, true);
        offset += 8;
        return hi * 0x100000000 + lo;
    };
    const vkFormat = u32();
    /* typeSize            */ u32();
    const pixelWidth = u32();
    const pixelHeight = u32();
    /* pixelDepth         */ u32();
    const layerCount = u32();
    const faceCount = u32();
    const levelCount = u32();
    const supercompression = u32();
    /* Index — offsets we do not need, but must consume in order. */
    /* dfdByteOffset */ u32(); /* dfdByteLength */
    u32();
    /* kvdByteOffset */ u32(); /* kvdByteLength */
    u32();
    /* sgdByteOffset */ u64(); /* sgdByteLength */
    u64();
    const formatName = VK_FORMAT[vkFormat] ?? null;
    const needsTranscode = vkFormat === 0 ||
        supercompression === Supercompression.BASIS_LZ;
    const effectiveLevels = Math.max(1, levelCount);
    const levels = [];
    for (let i = 0; i < effectiveLevels; i++) {
        const byteOffset = u64();
        const byteLength = u64();
        /* uncompressedByteLength */ u64();
        levels.push({
            level: i,
            width: Math.max(1, pixelWidth >> i),
            height: Math.max(1, pixelHeight >> i),
            data: bytes.subarray(byteOffset, byteOffset + byteLength),
        });
    }
    return {
        width: pixelWidth,
        height: pixelHeight,
        levelCount: effectiveLevels,
        faceCount: Math.max(1, faceCount),
        layerCount,
        vkFormat,
        formatName,
        supercompression,
        needsTranscode,
        levels,
    };
}

class WebGLTexture {
    constructor(gl, options = {}) {
        if (!gl) {
            return;
        }
        this.options = Object.assign({}, {
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE,
            width: 1,
            height: 1,
            linear: true,
            mipmap: false,
            miplinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            anisotropy: 0,
            flipY: true,
            dataFlipY: false,
            repeat: [1, 1],
            data: null,
            isHeightmap: false,
            target: gl.TEXTURE_2D,
        }, options);
        this._uid = generateUUID(); //debug purpose
        this.uuid = this._uid;
        this.gl = gl;
        this.width = this.options.width;
        this.height = this.options.height;
        this.format = this.options.format;
        this.type = this.options.type;
        this.flipY = this.options.flipY;
        this._data = this.options.data; // || null
        this.repeat = this.options.repeat;
        this._anisotropy = this.options.anisotropy;
        this.target = this.options.target;
        if (this.type == gl.FLOAT) {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_float_linear');
        }
        if (this.type == "HALF_FLOAT") {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_half_float_linear');
        }
        this._texture = this.gl.createTexture();
        gl.bindTexture(this.target, this._texture);
        //1x1 pixel default texture
        if (this.type == this.gl.FLOAT && this._data) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
        }
        this.wrapS = this.options.wrapS;
        this.wrapT = this.options.wrapT;
        this.gl.bindTexture(this.target, this._texture);
        this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.wrapS);
        this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.wrapT);
        //nPOT texture cannot mipmap
        this.setFilter(this.options.linear, this.options.mipmap, this.options.mipmapLinear);
        //unbind texture
        gl.bindTexture(this.target, null);
        Object.defineProperty(this, 'anisotropy', {
            set: (value) => {
                this._anisotropy = value;
                this.updateAnisotropyFilter();
            },
            get: () => {
                return this._anisotropy;
            }
        });
    }
    updateAnisotropyFilter() {
        let gl = this.gl;
        if (!gl || this._anisotropy == 0) {
            return;
        }
        var ext = (gl.getExtension('EXT_texture_filter_anisotropic') ||
            gl.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
            gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic'));
        if (ext) {
            if (this._anisotropy > 0) {
                gl.bindTexture(this.target, this._texture);
                var max = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                gl.texParameterf(this.target, ext.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this._anisotropy, max));
            }
        }
        console.log('ANISOTROPY');
    }
    bindData(data, width, height) {
        if (width)
            this.width = width;
        if (height)
            this.height = height;
        this._data = data;
        if (this.type == this.gl.FLOAT && this._data) {
            this.gl.bindTexture(this.target, this._texture);
            // this.gl.pixelStorei( this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
            this.gl.bindTexture(this.target, null);
        }
    }
    /*
     * Upload a KTX2 file's block-compressed levels directly.
     *
     * This is the counterpart to bindImage(), and the reason it exists: bindImage
     * uploads gl.RGBA, so an RGBA8 texture costs width*height*4 in VRAM plus a third
     * again for mips, no matter how small its download was. Block formats stay
     * compressed in memory — BC7 is 4:1 and BC1 8:1 against RGBA8 — so this is the
     * only path that reduces the allocation rather than the transfer.
     *
     * No transcoding happens here. The container must already hold GPU-ready blocks
     * (BC7/BC5/BC1/ASTC/ETC2), which is what `ktx create --format ...` produces.
     * Basis payloads (ETC1S/UASTC, vkFormat 0) are reported via needsTranscode and
     * rejected, because handling them requires the Basis WASM transcoder.
     *
     * Mip levels come from the file rather than generateMipmap(), which cannot
     * operate on compressed textures.
     *
     * Returns true on success. Returns false — without throwing and without
     * touching the texture — when the file needs transcoding or the device lacks the
     * format, so the caller can fall back to the uncompressed source. A device
     * without block compression must still render.
     */
    bindCompressed(buffer) {
        if (!this.gl) {
            return false;
        }
        this.gl.bindTexture(this.target, this._texture);
        const result = uploadKTX2(this.gl, this.target, buffer);
        if (!result) {
            this.gl.bindTexture(this.target, null);
            return false;
        }
        this.width = result.width;
        this.height = result.height;
        this.compressedFormat = result.formatName;
        this.compressedLevels = result.levels;
        this.compressedBytes = result.bytes;
        const hasMips = result.levels > 1;
        this.setFilter(this.options.linear, hasMips, this.options.mipmapLinear);
        /*
         * Without a chain down to 1x1, sampling a level that was never uploaded renders
         * black. Clamp to what the file actually provided.
         */
        if (hasMips) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_BASE_LEVEL, 0);
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MAX_LEVEL, result.levels - 1);
        }
        this.gl.bindTexture(this.target, null);
        return true;
    }
    bindImage(img) {
        if (!this.gl) {
            return;
        }
        // console.log('[WEBGL_TEXTURE BIND_IMAGE]', {target: this.target, options: this.options});
        this.img = img;
        this.image = img;
        this.width = img.width;
        this.height = img.height;
        var isPOT = isPowerOf2(img.width) && isPowerOf2(img.height);
        this.gl.bindTexture(this.target, this._texture);
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
        if (this.options.type == this.gl.FLOAT) {
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.gl.RGBA, this.options.type, img);
        }
        else {
            this.gl.texImage2D(this.target, 0, this.gl.RGBA, this.gl.RGBA, this.options.type, img);
        }
        if (isPOT) {
            //nPOT texture cannot mipmap
            this.setFilter(this.options.linear, this.options.mipmap, this.options.mipmapLinear);
            this.gl.generateMipmap(this.target);
        }
        else {
            this.setFilter(this.options.linear, false, false);
            this.wrapS = this.gl.CLAMP_TO_EDGE;
            this.wrapT = this.gl.CLAMP_TO_EDGE;
        }
        this.gl.bindTexture(this.target, null);
    }
    bind(unit) {
        if (!this.gl) {
            return;
        }
        //unit is sent by the Program and defined by the unfirom order in the shaders; 
        if (unit !== void 0) {
            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        }
        this.gl.bindTexture(this.target, this._texture);
    }
    delete() {
        if (this.gl) {
            this.gl.deleteTexture(this._texture);
        }
        this._texture = null;
        this.gl = null;
    }
    setFilter(smooth, mipmap, miplinear) {
        if (!this.gl) {
            return;
        }
        var gl = this.gl;
        var filter = getFilter(!!smooth, !!mipmap, !!miplinear);
        gl.bindTexture(this.target, this._texture);
        gl.texParameteri(this.target, gl.TEXTURE_MAG_FILTER, getFilter(!!smooth, false, false));
        gl.texParameteri(this.target, gl.TEXTURE_MIN_FILTER, filter);
    }
}

const MAX_FRAME_BUFFERS = 1000;
const MAX_PROGRAMS = 1000;
const MAX_ARRAY_BUFFERS = 1000;
// Singleton use to track gl objects and delete them when the 'beforeunload' event is triggered.
// this is to fix a  bug on Edge on windows 11 that keeps any allocated gl objects between page reloads of a given browser tab resulting in crashes
var MemoryManager = {
    buffers: [],
    textures: [],
    frameBuffers: [],
    programs: [],
    trackProgram(program) {
        this.programs.push(program);
    },
    trackBuffer(buffer) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_ARRAY_BUFFERS} ArrayBuffers.`);
            return;
        }
        this.buffers.push(buffer);
    },
    trackFrameBuffer(frameBuffer) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_FRAME_BUFFERS} FrameBuffers.`);
            return;
        }
        this.frameBuffers.push(frameBuffer);
    },
    trackTexture(texture) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_PROGRAMS} Textures.`);
            return;
        }
        this.textures.push(texture);
    },
    untrackProgram(program) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_PROGRAMS} Programs.`);
            return;
        }
        for (let i = this.programs.length - 1; i >= 0; i--) {
            if (this.programs[i] === program) {
                this.programs.splice(i, 1);
                break;
            }
        }
    },
    /*
     * These compared the ARRAY against the item (this.buffers === buffer)
     * instead of the element (this.buffers[i] === buffer), so the splice never
     * ran and the tracking arrays only ever grew — every "untrack" was a no-op
     * and nothing could ever be reported as released.
     */
    untrackBuffer(buffer) {
        for (let i = this.buffers.length - 1; i >= 0; i--) {
            if (this.buffers[i] === buffer) {
                this.buffers.splice(i, 1);
                break;
            }
        }
    },
    untrackTexture(texture) {
        for (let i = this.textures.length - 1; i >= 0; i--) {
            if (this.textures[i] === texture) {
                this.textures.splice(i, 1);
                break;
            }
        }
    },
    untrackFrameBuffer(frameBuffer) {
        for (let i = this.frameBuffers.length - 1; i >= 0; i--) {
            if (this.frameBuffers[i] === frameBuffer) {
                this.frameBuffers.splice(i, 1);
                break;
            }
        }
    },
    destroy(gl) {
        this.textures.forEach(texture => {
            gl.deleteTexture(texture);
        });
        this.buffers.forEach(buffer => {
            gl.deleteBuffer(buffer);
        });
        this.frameBuffers.forEach(frameBuffer => {
            gl.deleteFramebuffer(frameBuffer);
        });
        // this.programs.forEach(program => {
        //     gl.deleteProgram(program);
        // });
        this.textures = [];
        this.buffers = [];
        this.frameBuffers = [];
        this.programs = [];
    }
};

class DepthTexture {
    constructor(gl, options) {
        let supportsDepthTexture = gl.getExtension("WEBGL_depth_texture");
        if (!supportsDepthTexture) {
            throw ("FrameBuffer useDepthTexture:true => Cannot render depth to texture, the browser doesnt support WEBKIT_WEBGL_depth_texture extension");
        }
        options = Object.assign({}, {
            width: 1,
            height: 1,
            type: gl.UNSIGNED_SHORT
        }, options);
        this.gl = gl;
        this.width = options.width;
        this.height = options.height;
        this.type = options.type;
        var floatTextures = gl.getExtension('OES_texture_float');
        gl.getExtension('OES_texture_float_linear');
        if (!floatTextures && this.type == gl.FLOAT) {
            throw ('trying to create a DepthTexture of gl.FLOAT type but there\s no floating point texture support');
        }
        this._texture = this.gl.createTexture();
        MemoryManager.trackTexture(this._texture);
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.type, null);
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
    bind(unit) {
        if (unit !== void 0) {
            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        }
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
    }
    delete() {
        this.gl.deleteTexture(this._texture);
        MemoryManager.untrackTexture(this._texture);
        this._texture = null;
        this.gl = null;
    }
    resize(w, h) {
        this.width = w;
        this.height = h;
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.type, null);
        gl.bindTexture(gl.TEXTURE_2D, null);
    }
}

const extensions$1 = {};
function getType$1(gl, type) {
    if (type === gl.FLOAT) {
        extensions$1.EXT_color_buffer_float ??= gl.getExtension('EXT_color_buffer_float');
        if (!extensions$1.EXT_color_buffer_float) {
            console.warn('gl.FLOAT not supported, using gl.HALF_FLOAT');
            type = gl.HALF_FLOAT;
        }
    }
    if (type === gl.HALF_FLOAT) {
        extensions$1.EXT_color_buffer_half_float ??= gl.getExtension('EXT_color_buffer_half_float');
        if (!extensions$1.EXT_color_buffer_half_float) {
            console.warn('gl.HALF_FLOAT not supported, using gl.UNSIGNED_BYTE');
            type = gl.UNSIGNED_BYTE;
        }
    }
    return type;
}
class FrameBuffer$1 {
    constructor(gl, options = {}) {
        this.options = Object.assign({}, {
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE,
            linear: true,
            mipmap: false,
            mipmapLinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            depthTexture: null,
            skipViewport: false,
            numRenderTargets: 1,
            renderTargets: [],
            depthOnly: false,
        }, options);
        this.gl = gl;
        this.type = getType$1(gl, this.options.type);
        this.skipViewport = this.options.skipViewport;
        this.width = this.options.width;
        this.height = this.options.height;
        this.format = this.options.format;
        this.linear = this.options.linear;
        this.mipmap = this.options.mipmap;
        this.mipmapLinear = this.options.mipmapLinear;
        this.renderTargets = [];
        if (this.options.numRenderTargets > 1) {
            for (let i = 0; i < this.options.numRenderTargets; i++) {
                this.renderTargets.push({
                    type: this.type,
                });
            }
        }
        if (this.options.renderTargets.length > 0) {
            for (let i = 0; i < this.options.renderTargets.length; i++) {
                this.renderTargets.push({
                    type: getType$1(gl, this.options.renderTargets[i].type),
                });
            }
        }
        if (this.options.depthOnly) {
            this.fbo = gl.createFramebuffer();
            this.fbo.name = this.name;
            MemoryManager.trackFrameBuffer(this.fbo);
            gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo);
            this.depthTexture = gl.createTexture();
            MemoryManager.trackTexture(this.depthTexture);
            gl.bindTexture(gl.TEXTURE_2D, this.depthTexture);
            {
                gl.texImage2D(gl.TEXTURE_2D, 0, gl.DEPTH_COMPONENT24, this.width, this.height, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_INT, null);
            }
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, this.depthTexture, 0);
        }
        else {
            if (this.renderTargets.length > 0) {
                this._textures = [];
                for (let i = 0; i < this.renderTargets.length; i++) {
                    const texture = this.gl.createTexture();
                    MemoryManager.trackTexture(texture);
                    // since we didnt create a beam texture but a webgl texture, there is n ot .bind method on it to be used as uniform
                    texture.bind = unit => {
                        if (!this.gl) {
                            return;
                        }
                        if (unit !== void 0) {
                            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
                        }
                        this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
                    };
                    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
                    if (this.renderTargets[i].type == this.gl.FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null); // new Float32Array( new Array(this.width * this.height * 4) ));
                    }
                    else if (this.renderTargets[i].type == this.gl.HALF_FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                    }
                    else {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.renderTargets[i].type, new Uint8Array(new Array(this.width * this.height * 4)));
                    }
                    this._textures.push(texture);
                }
            }
            else {
                this._texture = this.gl.createTexture();
                MemoryManager.trackTexture(this._texture);
                this._texture.__is_framebuffer_texture__ = true;
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                if (this.type == this.gl.FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null); // new Float32Array( new Array(this.width * this.height * 4) ));
                }
                else if (this.type == this.gl.HALF_FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                }
                else {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null); //new Uint8Array( new Array(this.width * this.height * 4) ));
                }
            }
            this.wrapS = this.options.wrapS;
            this.wrapT = this.options.wrapT;
            var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
            if (!isPOT) {
                //not POT textures can't repeat & cant use mipmap
                this.wrapS = gl.CLAMP_TO_EDGE;
                this.wrapT = gl.CLAMP_TO_EDGE;
                this.mipmap = false;
                this.mipmapLinear = false;
            }
            if (this._textures) {
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT);
                }
            }
            else {
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT);
            }
            //nPOT texture cannot mipmap
            this.setFilter(this.linear, this.mipmap, this.mipmapLinear);
            if (!this.options.depthTexture) {
                this.renderbuffer = this.gl.createRenderbuffer();
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
                {
                    this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
                }
            }
            this.fbo = this.gl.createFramebuffer();
            MemoryManager.trackFrameBuffer(this.fbo);
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            if (this._textures) {
                const buffers = [];
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT' + i], this.gl.TEXTURE_2D, this._textures[i], 0);
                    buffers.push(this.gl['COLOR_ATTACHMENT' + i]);
                }
                // console.log('DRAW_BUFFERS', this.options.name);
                this.gl.drawBuffers(buffers);
            }
            else {
                this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
            }
            // if (this.options.depthTexture) {
            //   this.depthTexture = this.options.depthTexture._texture;
            //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.options.depthTexture._texture, 0);
            // }
            // else {
            this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            // }
        }
        this.unbind();
    }
    /**
     * [setFilter description]
     * @param {[type]} linear       [description]
     * @param {[type]} mipmap       [description]
     * @param {[type]} mipmapLinear [description]
     */
    setFilter(linear, mipmap, mipmapLinear) {
        var gl = this.gl;
        var filter = getFilter(!!linear, !!mipmap, !!mipmapLinear);
        if (this._textures) {
            for (let i = 0; i < this._textures.length; i++) {
                gl.bindTexture(gl.TEXTURE_2D, this._textures[i]);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter(!!linear, false, false));
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
            }
        }
        else {
            gl.bindTexture(gl.TEXTURE_2D, this._texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter(!!linear, false, false));
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
        }
    }
    resize(w, h) {
        if (this.width !== w || this.height !== h) {
            this.width = w | 0;
            this.height = h | 0;
        }
        if (this.options.depthOnly) {
            // Bind the framebuffer and the depth texture
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
            // Resize the depth texture
            {
                this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT24, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_INT, null);
            }
            // Re-attach the depth texture to the framebuffer
            this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
        }
        else {
            var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
            if (!isPOT) {
                this.wrapS = this.gl.CLAMP_TO_EDGE;
                this.wrapT = this.gl.CLAMP_TO_EDGE;
                this.mipmap = false;
                this.mipmapLinear = false;
                this.setFilter(this.linear, this.mipmap, this.mipmapLinear);
            }
            if (this._textures) {
                const buffers = [];
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
                    if (this.type == this.gl.FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, (this.format), (this.type), null);
                    }
                    else if (this.type == this.gl.HALF_FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                    }
                    else {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
                    }
                    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
                    this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT' + i], this.gl.TEXTURE_2D, this._textures[i], 0);
                    buffers.push(this.gl['COLOR_ATTACHMENT' + i]);
                }
                this.gl.drawBuffers(buffers);
            }
            else {
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                if (this.type == this.gl.FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, (this.format), (this.type), null);
                }
                else if (this.type == this.gl.HALF_FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                }
                else {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
                }
                this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
                this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
            }
            // if (this.options.depthTexture) {
            //   this.depthTexture.resize(this.width, this.height);
            //   // this.gl.bindTexture(this.gl.TEXTURE_2D, this._depthTexture);
            //   // this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_SHORT, null);
            // }
            // if (this.options.depthTexture) {
            //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture._texture, 0);
            // }
            // else {
            this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
            {
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
            }
            this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            // }
        }
        this.unbind();
    }
    bindFrame(bindOnly) {
        if (bindOnly) {
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            return;
        }
        if (!this.skipViewport) {
            this.gl.viewport(0, 0, this.width, this.height);
        }
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
        if (this.options.depthOnly) {
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
            this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
            this.gl.drawBuffers([this.gl.NONE]);
            this.gl.readBuffer(this.gl.NONE);
        }
        else {
            if (!this.options.depthTexture) {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
            }
            else {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
                {
                    this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
                }
                this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            }
            this.clear();
        }
    }
    bind(unit) {
        this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.options.depthOnly ? this.depthTexture : this._texture);
    }
    unbind() {
        this.gl.bindTexture(this.gl.TEXTURE_2D, null);
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
        if (!this.options.depthTexture) {
            this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, null);
        }
    }
    clear(color, depth, stencil) {
        // if (this.options.depthOnly) {
        //   this.gl.clear( this.gl.DEPTH_BUFFER_BIT );
        // }
        // else {
        var bits = 0;
        if (color === void 0 || color)
            bits |= this.gl.COLOR_BUFFER_BIT;
        if (depth === void 0 || depth)
            bits |= this.gl.DEPTH_BUFFER_BIT;
        if (stencil === void 0 || stencil)
            bits |= this.gl.STENCIL_BUFFER_BIT;
        this.gl.clear(bits);
        // }
    }
    dispose() {
        MemoryManager.untrackFrameBuffer(this.fbo);
        this.gl.deleteFramebuffer(this.fbo);
        this.fbo = null;
        this.gl = null;
    }
}

let bindedBuffer = null;
class ArrayBuffer$1 {
    constructor(gl, data, size, element, type) {
        this.gl = gl;
        this.type = type || gl.FLOAT;
        this._buffer = gl.createBuffer();
        this._element = element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER';
        this._target = gl[element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER'];
        this.update(data, size);
    }
    update(data, size) {
        this.data = data;
        this.size = size;
        this.length = this.data.length;
        this.gl.bindBuffer(this._target, this._buffer);
        // any attribute starting with "instance" will is considered and instance attribute
        // TODO: do we really need to do this  istead of bufferData  for instanced attributes ?
        if (/^instance/.test(this.name)) {
            this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, this.data); //, this.gl.STATIC_DRAW);//if the attribute chnages oftenly, we need to use DYNAMIC_DRAW
        }
        else {
            this.gl.bufferData(this._target, this.data, this.gl.STATIC_DRAW);
        }
        this.gl.bindBuffer(this._target, null);
    }
    subUpdate(data, size, offset) {
        // this.hasCalledSubUpdate = true
        if (bindedBuffer != this) {
            bindedBuffer = this;
            this.gl.bindBuffer(this._target, this._buffer);
        }
        this.gl.bindBuffer(this._target, this._buffer);
        let byteOffset = offset * size * Float32Array.BYTES_PER_ELEMENT;
        this.gl.bufferSubData(this.gl.ARRAY_BUFFER, byteOffset, data, 0);
    }
    bind() {
        if (bindedBuffer != this) {
            bindedBuffer = this;
            this.gl.bindBuffer(this._target, this._buffer);
        }
    }
}

class WebGLDevice extends BaseGraphicsDevice {
    constructor(canvas, options = {}) {
        super();
        this.canvas = canvas;
        this.contextAttributes = Object.assign({}, {
            alpha: false,
            depth: true,
            stencil: true,
            antialias: false,
            premultipliedAlpha: true,
            preserveDrawingBuffer: false,
            failIfMajorPerformanceCaveat: false,
        }, (options || {}));
    }
    init() {
        let gl;
        try {
            gl = this.canvas.getContext("webgl2", this.contextAttributes);
        }
        catch (x) {
            try {
                gl = this.canvas.getContext("webgl", this.contextAttributes);
            }
            catch (x) {
                gl = null;
            }
        }
        this.gl = gl;
        this.supportWebgl = gl !== null;
        if (!this.supportWebgl) {
            console.warn('no Webgl support');
            return;
        }
        this._handleContextLost = this._handleContextLost.bind(this);
        this._handleContextRestored = this._handleContextRestored.bind(this);
        this.canvas.addEventListener('webglcontextlost', this._handleContextLost, false);
        this.canvas.addEventListener('webglcontextrestored', this._handleContextRestored, false);
        {
            // Avoid binding already binded texture, so same of performances
            const gl = this.gl;
            const state = this._textureState = {
                currentUnit: gl.getParameter(gl.ACTIVE_TEXTURE),
                bound: new Map()
            };
            const oActive = gl.activeTexture.bind(gl);
            const oBind = gl.bindTexture.bind(gl);
            const oDelete = gl.deleteTexture.bind(gl);
            gl.activeTexture = unit => {
                if (unit !== state.currentUnit) {
                    state.currentUnit = unit;
                    oActive(unit);
                }
            };
            gl.bindTexture = (target, texture) => {
                const key = state.currentUnit * 100000 + target;
                if (state.bound.get(key) !== texture) {
                    state.bound.set(key, texture);
                    oBind(target, texture);
                }
            };
            gl.deleteTexture = texture => {
                for (const [k, v] of state.bound) {
                    if (v === texture) {
                        state.bound.delete(k);
                    }
                }
                return oDelete(texture);
            };
        }
    }
    _handleContextLost(event) {
        event.preventDefault();
    }
    _handleContextRestored() {
        this._textureState.currentUnit = this.gl.getParameter(this.gl.ACTIVE_TEXTURE);
        this._textureState.bound.clear();
    }
    clearColor(r, g, b, alpha) {
        if (!this.gl) {
            return;
        }
        this.gl.clearColor(r, g, b, alpha);
    }
    clear(color, depth, stencil) {
        if (!this.gl) {
            return;
        }
        var bits = 0;
        if (color === void 0 || color)
            bits |= this.gl.COLOR_BUFFER_BIT;
        if (depth === void 0 || depth)
            bits |= this.gl.DEPTH_BUFFER_BIT;
        if (stencil === void 0 || stencil)
            bits |= this.gl.STENCIL_BUFFER_BIT;
        this.gl.clear(bits);
    }
    resize(w, h) {
        if (!this.gl) {
            return;
        }
        this.w = w;
        this.h = h;
        this.gl.viewport(0, 0, w, h);
    }
    beginPass(frameBuffer, options = {}) {
        if (frameBuffer) {
            frameBuffer.bindFrame(options?.bindOnly);
        }
        else {
            if (options?.skipViewport) ;
            else {
                this.gl.viewport(0, 0, this.w, this.h);
            }
        }
    }
    endPass(frameBuffer) {
        if (frameBuffer) {
            frameBuffer.unbind();
        }
    }
    createTexture(desc) {
        // console.log('WEBGLDevice.createTexture()', {gl: this.gl, desc})
        return new WebGLTexture(this.gl, desc);
    }
    createFrameBuffer(desc) {
        return new FrameBuffer$1(this.gl, desc);
    }
    createArrayBuffer(desc) {
        return new ArrayBuffer$1(this.gl, desc);
    }
    createProgram(desc) {
        return new Program(this.gl, desc);
    }
}

class WebGPUDevice extends BaseGraphicsDevice {
    constructor(canvas, options = {}) {
        super();
        this.canvas = canvas;
    }
    async init() {
        this.adapter = await navigator.gpu.requestAdapter();
        this.device = await this.adapter.requestDevice();
        this.context = this.canvas.getContext('webgpu');
        this.format = navigator.gpu.getPreferredCanvasFormat();
        this.context.configure({
            device: this.device,
            format: this.format,
            alphaMode: 'premultiplied'
        });
        this._createDepthTexture();
    }
    _createDepthTexture(w, h) {
        if (!this.device)
            return; // device not ready yet
        this._depthTexture = this.device.createTexture({
            size: [w, h, 1],
            format: 'depth24plus',
            usage: GPUTextureUsage.RENDER_ATTACHMENT
        });
    }
    beginPass(frameBuffer, options = {}) {
        const encoder = this.device.createCommandEncoder();
        if (frameBuffer) {
            const colorAttachments = frameBuffer.colorTextures.map(tex => ({
                view: tex.view,
                clearValue: this._clearColor,
                loadOp: 'clear',
                storeOp: 'store'
            }));
            const desc = {
                colorAttachments,
            };
            if (this.depthTexture) {
                desc.depthStencilAttachment = {
                    view: this.depthTexture.view,
                    depthLoadOp: 'clear',
                    depthClearValue: this.options.clearDepth,
                    depthStoreOp: 'store'
                };
            }
            const pass = encoder.beginRenderPass(desc);
            this.currentPass = {
                encoder,
                pass,
                format: frameBuffer.colorTextures[0].format,
                resolution: [frameBuffer.width, frameBuffer.height],
            };
        }
        else {
            const pass = encoder.beginRenderPass({
                colorAttachments: [{
                        view: this.context.getCurrentTexture().createView(),
                        loadOp: 'clear',
                        clearValue: this._clearColor,
                        storeOp: 'store'
                    }],
                depthStencilAttachment: {
                    view: this._depthTexture.createView(),
                    depthLoadOp: 'clear',
                    depthClearValue: 1.0,
                    depthStoreOp: 'store'
                }
            });
            this.currentPass = { encoder, pass };
        }
    }
    endPass(frameBuffer) {
        if (this.currentPass) {
            const { encoder, pass } = this.currentPass;
            pass.end();
            this.device.queue.submit([encoder.finish()]);
        }
    }
    clearColor(r, g, b, a = 1) {
        this._clearColor = { r, g, b, a };
    }
    // WebGPU has no gl.clear(); clearing happens in the render pass.
    // So this just sets the clearValue used in beginPass.
    clear(color = true) {
        if (color === false)
            return;
    }
    resize(w, h) {
        this._createDepthTexture(w, h);
    }
}

const GraphicsDevice = {
    device: null,
    Get() {
        // console.log('GraphicsDevice.Get', this.device);
        return this.device;
    },
    Create(canvas, options = {}) {
        if (!canvas) {
            throw new Error('GraphicsDevice.Create: canvas is required');
        }
        if (!this.device) {
            if (options.backend === 'webgpu' && navigator.gpu) {
                // console.log('GraphicsDevice.Create() WebGPUDevice', {canvas, options});
                this.device = new WebGPUDevice(canvas, options);
            }
            else {
                // console.log('GraphicsDevice.Create() WebGLDevice', {canvas, options});
                this.device = new WebGLDevice(canvas, options);
            }
        }
        return this.device;
    }
};

class Texture {
    constructor(gl, options = {}) {
        if (!gl) {
            return;
        }
        this.options = Object.assign({}, {
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE,
            width: 1,
            height: 1,
            linear: true,
            mipmap: false,
            miplinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            anisotropy: 0,
            flipY: true,
            dataFlipY: false,
            repeat: [1, 1],
            data: null,
            isHeightmap: false,
            target: gl.TEXTURE_2D,
            adjustments: null,
            isLightMap: false,
            colorSpace: "linear",
            encoding: "RGB_LOG_L",
            minLogLuminance: -1,
            maxLogLuminance: -1,
            rgbmRange: -1,
        }, options);
        this._uid = generateUUID(); //debug purpose
        this.uuid = this._uid;
        this.gl = gl;
        this.width = this.options.width;
        this.height = this.options.height;
        this.format = this.options.format;
        this.type = this.options.type;
        this.flipY = this.options.flipY;
        this._data = this.options.data; // || null
        this.repeat = this.options.repeat;
        this._anisotropy = this.options.anisotropy;
        this.target = this.options.target;
        this.wrapS = this.options.wrapS;
        this.wrapT = this.options.wrapT;
        this.colorSpace = this.options.colorSpace;
        this.encoding = this.options.encoding;
        this.minLogLuminance = this.options.minLogLuminance;
        this.maxLogLuminance = this.options.maxLogLuminance;
        this.rgbmRange = this.options.rgbmRange;
        this.device = GraphicsDevice.Get();
        // console.log(': new Texture', this.device.canvas, this.device.createTexture);
        // this.textureRessource = this.device.createTexture(this.options);
        if (this.type == gl.FLOAT) {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_float_linear');
            //   if (!floatTextures){//} || (window.innerWidth < 768)) {
            //       // console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
            //       this.type = "HALF_FLOAT"
            //   }
        }
        if (this.type == "HALF_FLOAT") {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_half_float_linear');
            //   if (!halfFloatTexturesExt) {
            //     console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
            //     this.type = gl.UNSIGNED_BYTE;
            //   }
            //   else {
            //     this.type = halfFloatTexturesExt.HALF_FLOAT_OES;
            //     this.isHalfFloat = true;
            //   }
        }
        this._texture = this.gl.createTexture();
        // MemoryManager.trackTexture( this._texture );
        gl.bindTexture(this.target, this._texture);
        //1x1 pixel default texture
        // gl.texImage2D(this.target, 0, (this.options.type == this.gl.FLOAT ? this.gl.RGBA32F : this.gl.RGBA), this.width, this.height, 0, this.gl.RGBA, (this.options.type), this._data);
        if (this.type == this.gl.FLOAT && this._data) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
        }
        if (this.options.isLightMap) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
            this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.options.isLightMap ? false : true);
            this.gl.pixelStorei(this.gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this.options.isLightMap ? this.gl.NONE : this.gl.BROWSER_DEFAULT_WEBGL);
        }
        this.gl.bindTexture(this.target, this._texture);
        this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_S, this.wrapS);
        this.gl.texParameteri(this.target, this.gl.TEXTURE_WRAP_T, this.wrapT);
        //nPOT texture cannot mipmap
        this.setFilter(this.options.linear, this.options.mipmap, this.options.miplinear);
        //unbind texture
        gl.bindTexture(this.target, null);
        // Object.defineProperty(this, 'anisotropy', {
        //   set: (value) => {
        //     this._anisotropy = value
        //     this.updateAnisotropyFilter()
        //   },
        //   get: () => {
        //     return this._anisotropy 
        //   }
        // });
    }
    updateAnisotropyFilter() {
        // let gl = this.gl;
        // if (!gl || this._anisotropy == 0) {
        //     return;
        // }
        // var ext = (
        //   gl.getExtension('EXT_texture_filter_anisotropic') ||
        //   gl.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
        //   gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic')
        // );
        // if (ext) {
        //   if (this._anisotropy > 0) {
        //     gl.bindTexture( this.target, this._texture );
        //     var max = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        //     gl.texParameterf(this.target, ext.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this._anisotropy, max) );
        //   }
        // }
        // console.log('ANISOTROPY');
    }
    bindData(data, width, height) {
        if (width)
            this.width = width;
        if (height)
            this.height = height;
        this._data = data;
        // this.textureRessource.bindData(data, width, height);
        if (this.type == this.gl.FLOAT && this._data) {
            this.gl.bindTexture(this.target, this._texture);
            // this.gl.pixelStorei( this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
            this.gl.bindTexture(this.target, null);
        }
    }
    bindSubData(data, x, y, width, height) {
        if (!this.gl || !this._texture || !data) {
            return;
        }
        if (x < 0 ||
            y < 0 ||
            width <= 0 ||
            height <= 0 ||
            x + width > this.width ||
            y + height > this.height) {
            throw new Error(`Texture.bindSubData region ${x},${y},${width},${height} ` +
                `exceeds texture ${this.width}x${this.height}`);
        }
        this.gl.bindTexture(this.target, this._texture);
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, 1);
        this.gl.texSubImage2D(this.target, 0, x, y, width, height, this.format, this.type, data);
        this.gl.bindTexture(this.target, null);
    }
    bindImage(img) {
        this.img = img;
        this.image = img;
        this.width = img.width;
        this.height = img.height;
        // console.log('[TEXTURE BIND_IMAGE]', {textureRessource: this.textureRessource, img});
        // this.textureRessource.bindImage(img);
        if (!this.gl) {
            return;
        }
        var isPOT = isPowerOf2(img.width) && isPowerOf2(img.height);
        this.gl.bindTexture(this.target, this._texture);
        if (this.options.isLightMap) {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
            this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.options.isLightMap ? false : true);
            this.gl.pixelStorei(this.gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this.options.isLightMap ? this.gl.NONE : this.gl.BROWSER_DEFAULT_WEBGL);
        }
        else {
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
        }
        if (this.options.type == this.gl.FLOAT) {
            this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.gl.RGBA, this.options.type, img);
        }
        else {
            this.gl.texImage2D(this.target, 0, this.gl.RGBA, this.gl.RGBA, this.options.type, img);
        }
        if (isPOT) {
            //nPOT texture cannot mipmap
            this.setFilter(this.options.linear, this.options.mipmap, this.options.miplinear);
            // this.gl.generateMipmap(this.target);
            if (this.options.mipmap) {
                this.gl.generateMipmap(this.target);
            }
        }
        else {
            this.setFilter(this.options.linear, false, false);
            this.wrapS = this.gl.CLAMP_TO_EDGE;
            this.wrapT = this.gl.CLAMP_TO_EDGE;
        }
        this.gl.bindTexture(this.target, null);
    }
    bind(unit) {
        // this.textureRessource.bind(unit);
        // if (!window.skipTextureResourceBind) {
        //     this.textureRessource.bind(unit);
        // }
        if (!this.gl) {
            return;
        }
        //unit is sent by the Program and defined by the unfirom order in the shaders; 
        if (unit !== void 0) {
            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        }
        this.gl.bindTexture(this.target, this._texture);
    }
    delete() {
        // this.textureRessource.delete( this._texture );
        if (this.gl) {
            this.gl.deleteTexture(this._texture);
            // MemoryManager.untrackTexture( this._texture );
        }
        this._texture = null;
        this.gl = null;
    }
    /**
     * Change the filtering parameters
     *   @param {boolean} [smooth=false]    if true, use LINEAR filtering
     *   @param {boolean} [mipmap=false]    if true, enable mipmaping
     *   @param {boolean} [miplinear=false] if true, use linear Mipmapping
     */
    setFilter(smooth, mipmap, miplinear) {
        // this.textureRessource.setFilter( smooth, mipmap, miplinear );
        if (!this.gl) {
            return;
        }
        var gl = this.gl;
        var filter = getFilter(!!smooth, !!mipmap, !!miplinear);
        gl.bindTexture(this.target, this._texture);
        gl.texParameteri(this.target, gl.TEXTURE_MAG_FILTER, getFilter(!!smooth, false, false));
        gl.texParameteri(this.target, gl.TEXTURE_MIN_FILTER, filter);
        // this.updateAnisotropyFilter()
    }
    on(eventName, cb) {
        if (eventName === 'loaded' && this.loaded) {
            cb(this);
            return () => { };
        }
        this.callbacks = this.callbacks || {};
        this.callbacks[eventName] = this.callbacks[eventName] || [];
        this.callbacks[eventName].push(cb);
        return () => {
            const callbacks = this.callbacks?.[eventName];
            if (!callbacks)
                return;
            const index = callbacks.indexOf(cb);
            if (index >= 0)
                callbacks.splice(index, 1);
        };
    }
    emit(eventName, ...args) {
        const callbacks = this.callbacks?.[eventName];
        if (!callbacks)
            return;
        callbacks.slice().forEach(cb => cb(...args));
        if (eventName === 'loaded') {
            this.callbacks[eventName] = [];
        }
    }
    bindCompressed(buffer) {
        if (!this.gl) {
            return false;
        }
        this.gl.bindTexture(this.target, this._texture);
        const result = uploadKTX2(this.gl, this.target, buffer);
        if (!result) {
            this.gl.bindTexture(this.target, null);
            return false;
        }
        this.width = result.width;
        this.height = result.height;
        this.compressedFormat = result.formatName;
        this.compressedLevels = result.levels;
        this.compressedBytes = result.bytes;
        const hasMips = result.levels > 1;
        this.setFilter(this.options.linear, hasMips, this.options.miplinear);
        /*
         * Without a chain down to 1x1, sampling a level that was never uploaded renders
         * black. Clamp to what the file actually provided.
         */
        if (hasMips) {
            this.gl.texParameteri(this.target, this.gl.TEXTURE_BASE_LEVEL, 0);
            this.gl.texParameteri(this.target, this.gl.TEXTURE_MAX_LEVEL, result.levels - 1);
        }
        this.gl.bindTexture(this.target, null);
        return true;
    }
    loadFromUrl(url, options = {}) {
        /*
         * Prefer a GPU-compressed variant when the asset declares one.
         *
         * The uncompressed paths below decode to RGBA8 and upload with gl.RGBA, so a
         * texture costs width*height*4 in VRAM plus a third again for mips no matter
         * how small its WebP download was. A KTX2 file holding block-compressed levels
         * stays compressed in video memory — BC7 is 4:1, BC1 8:1 — so this is the only
         * branch that reduces the allocation rather than the transfer.
         *
         * Failure is expected and cheaply absorbed: a device lacking the format, or a
         * file holding a Basis payload we cannot transcode, falls through to `url`.
         * bindCompressed() signals that by returning false rather than throwing, so an
         * unusable .ktx2 costs one request and then behaves exactly as before.
         * See TEXTURE-PIPELINE.md.
         */
        if (options.compressedUrl) {
            const fallback = () => this.loadFromUrl(url, { ...options, compressedUrl: null });
            (async () => {
                try {
                    const response = await fetch(options.compressedUrl);
                    if (!response.ok) {
                        throw new Error('HTTP ' + response.status);
                    }
                    const buffer = await response.arrayBuffer();
                    if (!this.bindCompressed(new Uint8Array(buffer))) {
                        fallback();
                        return;
                    }
                    this.loaded = true;
                    this.error = false;
                    this.isCompressed = true;
                    if (options.onLoaded) {
                        options.onLoaded(options.compressedUrl);
                    }
                    // if (this?.callbacks?.['loaded']) {
                    //   this.callbacks['loaded']?.forEach(cb => cb());
                    //   this.callbacks['loaded'] = [];
                    // }
                    this.emit('loaded', this);
                    this.emit('changed', this);
                }
                catch (error) {
                    console.warn(`Texture: compressed variant unusable (${options.compressedUrl}), falling back`, error);
                    fallback();
                }
            })();
            return;
        }
        if (options.useImageBitmap) {
            var img = new Image();
            img.crossOrigin = "";
            (async () => {
                try {
                    // Fetch the image as a Blob
                    const response = await fetch(url);
                    if (!response.ok)
                        throw new Error(`Failed to fetch: ${url}`);
                    const blob = await response.blob();
                    // Decode asynchronously into an ImageBitmap
                    const bitmap = await createImageBitmap(blob, {
                        premultiplyAlpha: 'default',
                        colorSpaceConversion: 'default',
                    });
                    // Bind image to GPU texture
                    // this.isImageBitmap = true;
                    // this.bindImage(bitmap);
                    // this.loaded = true;
                    this.isImageBitmap = true;
                    try {
                        this.bindImage(bitmap);
                    }
                    finally {
                        bitmap.close();
                    }
                    this.img = null;
                    this.image = null;
                    this.loaded = true;
                    this.error = false;
                    if (options.onLoaded) {
                        options.onLoaded(url);
                    }
                    // if (this?.callbacks?.['loaded']) {
                    //   this.callbacks['loaded']?.forEach(cb => cb());
                    //   this.callbacks['loaded']= [];
                    // }
                    this.emit('loaded', this);
                    this.emit('changed', this);
                    // Trigger a fake load event
                    var event = new Event("load");
                    img.dispatchEvent(event);
                }
                catch (err) {
                    this.loaded = false;
                    this.error = true;
                    if (options.onError)
                        options.onError(err);
                    // if (options.onLoaded) options.onLoaded(url);
                    console.warn(`this.fromUrl(${url}) failed`, err);
                }
            })();
        }
        else {
            var img = new Image();
            img.crossOrigin = "";
            img.onload = () => {
                img.onload = null;
                img.onerror = null;
                this.loaded = true;
                this.error = false;
                this.bindImage(img);
                if (options && options.onLoaded) {
                    options.onLoaded(url);
                }
                // if (this?.callbacks?.['loaded']) {
                //   this.callbacks['loaded']?.forEach(cb => cb());
                //   this.callbacks['loaded']= [];
                // }
                this.emit('loaded', this);
                this.emit('changed', this);
            };
            img.onerror = () => {
                img.onload = null;
                img.onerror = null;
                this.loaded = false;
                this.error = true;
                if (options && options.onError) {
                    options.onError(url);
                }
                // if (options && options.onLoaded) {
                //   options.onLoaded(url);
                // }
                console.warn('Invalid url provided to Texture.fromUrl() : ' + url);
            };
            img.src = url;
        }
    }
}
Texture.fromUrl = function (gl, url, options = {}) {
    const texture = new Texture(gl, options);
    texture.loaded = false;
    texture.loadFromUrl(url, options);
    return texture;
};
Texture.fromImage = function (gl, img, options) {
    if (!img.width || !img.height) {
        console.warn('Cannot create texture with provided image\n Please make sure the image is loaded before calling Texture.fromImage() or use Texture.fromUrl() instead', img);
        return;
    }
    var texture = new Texture(gl, options);
    texture.bindImage(img);
    texture.loaded = true;
    texture.error = false;
    return texture;
};

var fragmentShader = "precision highp float;\n\n\nuniform vec3 uColor;\nuniform float uAlpha;\n\nvarying vec3 vColor;\nvarying vec2 vUv;\n\nuniform sampler2D tMap;\nuniform float useMap;\nuniform int uDepthPass;\n\nvoid main(void) {\n\nif(uDepthPass == 1) {\ngl_FragColor = vec4( gl_FragCoord.z, 0., 0., 1. );\n}\nelse {\nvec4 color = vec4(uColor, uAlpha);\nif (useMap==1.) {\ncolor.rgb = texture2D(tMap, vUv).rgb;\n}\ngl_FragColor = color;\n}\n}";

let defaultTexture;
class Material extends Program$1 {
    constructor(gl, options) {
        defaultTexture = defaultTexture || new Texture(gl);
        options = Object.assign({}, {
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            map: null,
        }, options);
        options.uniforms = Object.assign({}, {
            uColor: [0, 1, 0],
            uAlpha: 1,
            useMap: 0,
            tMap: defaultTexture,
        }, options.uniforms);
        options.defines = Object.assign({}, {
            USE_MAP: false
        }, options.defines);
        super(gl, options);
        if (!gl) {
            return;
        }
        Object.defineProperty(this, 'map', {
            set: (value) => {
                if (value) {
                    if (this.uniforms.tMap) {
                        this.uniforms.tMap.value = value;
                        this.uniforms.useMap.value = 1;
                    }
                }
                else {
                    if (this.uniforms.useMap) {
                        this.uniforms.useMap.value = 0;
                    }
                }
            }
        });
        this.map = options.map;
    }
}

var UIVS = "#version 300 es\n\nprecision highp float;\nprecision highp int;\n\nuniform mat4 uMVMatrix;\nuniform mat4 uPMatrix;\nuniform mat4 uMMatrix;\nuniform mat4 uVMatrix;\n\nin vec3 position;\n\n#ifdef USE_INSTANCING\nin mat4 instanceMatrix;\n#ifdef USE_INSTANCE_COLOR\nin vec3 instanceColor;\nout vec3 vInstanceColor;\n#endif\n#endif\n\nout vec2 vUv;\n\n#ifdef USE_VERTEX_COLOR\nin vec4 color;\nout vec4 vColor;\n#endif\n\nvoid main(void) {\n\nvec3 newPosition = position;\n\n#ifdef USE_INSTANCING\nnewPosition = (instanceMatrix * vec4(newPosition, 1.)).xyz;\n#endif\n\n#ifdef USE_INSTANCE_COLOR\nvInstanceColor = instanceColor;\n#endif\n\n#ifdef USE_VERTEX_COLOR\nvColor = color;\n#endif\n\ngl_Position = uPMatrix * uVMatrix * ( (uMMatrix * vec4( vec3(newPosition), 1.0)) );\n\n}";

var UIFS = "#version 300 es\nprecision highp float;\nprecision highp int;\n\nuniform float uAlpha;\nuniform vec3 uColor;\nuniform sampler2D tDepth;\nuniform int useDepthTest;\n\n\nout vec4 fragColor;\n\n#ifdef USE_INSTANCE_COLOR\nin vec3 vInstanceColor;\n#endif\n\n#ifdef USE_VERTEX_COLOR\nin vec4 vColor;\n#endif\n\nvoid main() {\n\n#ifdef USE_INSTANCE_COLOR\nfragColor = vec4(vInstanceColor, uAlpha);\n#else\n#ifdef USE_VERTEX_COLOR\nfragColor = vec4(vColor);\nif (fragColor.a < 0.5) {\ndiscard;\n}\n#else\nfragColor = vec4(uColor, uAlpha);\n#endif\n#endif\n\nif (useDepthTest == 1) {\nfloat depth = texelFetch(tDepth, ivec2(gl_FragCoord.xy / 2.), 0).r;\nif (gl_FragCoord.z > depth) {\ndiscard;\n}\n}\n\n}";

class UIMaterial extends Program$1 {
    constructor(gl, options) {
        options = Object.assign({}, {
            vertexShader: UIVS,
            fragmentShader: UIFS,
            depthTest: false,
            wireframe: false,
            blend: true,
            blendSrcRGB: gl.SRC_ALPHA,
            blendSrcAlpha: gl.ONE,
            blendDstRGB: gl.ONE_MINUS_SRC_ALPHA,
            blendDstAlpha: gl.ONE_MINUS_SRC_ALPHA,
        }, options);
        options.uniforms = Object.assign({}, {
            uColor: [1, 1, 1],
            uAlpha: 1,
            useDepthTest: 0,
        }, options.uniforms);
        super(gl, options);
        if (!gl) {
            return;
        }
    }
}

class Container extends Object3d {
    constructor() {
        super();
        this.visible = true;
        this.parent = null;
        this.children = [];
    }
    add(child) {
        let hasChild = false;
        for (let i = 0, l = this.children.length; i < l; i++) {
            if (this.children[i] == child) {
                hasChild = true;
                break;
            }
        }
        if (!hasChild) {
            this.children.push(child);
        }
        child.parent = this;
    }
    remove(child) {
        for (let i = 0, l = this.children.length; i < l; i++) {
            if (this.children[i] == child) {
                child.parent = null;
                this.children.splice(i, 1);
                break;
            }
        }
    }
    destroy() {
        for (let i = 0, l = this.children.length; i < l; i++) {
            this.children[i].destroy();
        }
        if (this.parent !== null) {
            this.parent.removeChild(this);
        }
    }
    render(camera, options) {
        // if (this.visible) {
        // super.render();		
        for (let i = 0, l = this.children.length; i < l; i++) {
            if (this.children[i].visible) {
                this.children[i].render(camera, options);
            }
        }
        // }
    }
}

/*
 * Pass generation counter.
 *
 * A large amount of per-draw CPU work in Mesh.render()/Program.draw() is
 * actually constant for a whole render pass (camera matrices, scene-wide
 * "shared" uniforms, inherited defines). Renderers call beginPass() whenever
 * they start a pass / change camera; Mesh and Program then only redo that
 * work the first time a given material is used within the pass.
 *
 * Measured on a 390-draw scene: hoisting the shared-uniform application and
 * the define reconciliation out of the per-draw path cut CPU frame time 27%,
 * and narrowing the per-draw uniform scan cut a further 35%.
 */
let passGeneration = 1;
let frameGeneration = 1;
function beginPass() {
    passGeneration++;
    return passGeneration;
}
function getPassGeneration() {
    return passGeneration;
}
/*
 * Frame boundary, called by the render pipeline.
 *
 * Program.draw() does one exhaustive uniform scan per program per frame and
 * then only visits uniforms actually written since the last draw. Per-frame
 * rather than per-pass is safe because everything that differs between passes
 * (camera matrices, shared uniforms, per-batch values) is applied through
 * setUniform()/setUniformsFrom(), which records it as dirty. The once-a-frame
 * full scan is the backstop for any value mutated in place without going
 * through those setters.
 */
function beginFrame() {
    frameGeneration++;
    return frameGeneration;
}
function getFrameGeneration() {
    return frameGeneration;
}

function isValidDefineValue(value) {
    return value !== void 0 && value !== null && value !== false;
}
function hasInheritedDefine(sharedDefines, optionDefines, k) {
    return ((sharedDefines && isValidDefineValue(sharedDefines[k])) ||
        (optionDefines && isValidDefineValue(optionDefines[k])));
}
function applyInheritedDefines(material, defines) {
    if (!defines)
        return;
    for (const k in defines) {
        if (k.startsWith('INHERITED_'))
            continue;
        const value = defines[k];
        if (!isValidDefineValue(value))
            continue;
        material.defines[k] = value;
        material.defines[`INHERITED_${k}`] = 1;
    }
}
const inheritedDefinesCache = new WeakMap();
function getInheritedDefines(defines, passGeneration) {
    if (!defines)
        return defines;
    let cache = inheritedDefinesCache.get(defines);
    if (cache?.passGeneration === passGeneration)
        return cache.defines;
    if (!cache) {
        cache = { defines: Object.create(null), count: 0 };
        inheritedDefinesCache.set(defines, cache);
    }
    let count = 0;
    let changed = false;
    for (const k in defines) {
        count++;
        if (!Object.prototype.hasOwnProperty.call(cache.defines, k) || cache.defines[k] !== defines[k])
            changed = true;
    }
    if (changed || count !== cache.count) {
        cache.defines = Object.create(null);
        for (const k in defines)
            cache.defines[k] = defines[k];
        cache.count = count;
    }
    cache.passGeneration = passGeneration;
    return cache.defines;
}
create$5();
class Mesh extends Container {
    constructor(options) {
        super();
        this.material = null;
        this.geometry = null;
        this.options = options || {};
        this.debug = options?.debug;
        this._viewMatrix = create$6();
        this._invViewMatrix = create$6();
        this._modelViewMatrix = create$6();
        this._projectViewMatrix = create$6();
        this._projectionMatrix = create$6();
        this._cameraPosition = create$5();
        this.uniforms = {};
    }
    render(camera, options = {}, debug) {
        let material = this.material;
        // let isOverriden = false;
        if (options.overrideMaterial || options.overrideInstancedMaterial) {
            // material = options.overrideMaterial;
            // isOverriden = true;
            console.warn('MATERIAL override is depreciated, use Shader permutation instead');
        }
        if (!material?.setUniform) {
            return;
        }
        if (camera &&
            material &&
            this.geometry
        /* TODO: check for geometry.length */
        ) {
            if (!this.visible) {
                return;
            }
            super.render(camera, options);
            const modelMatrix = options?.overrideMatrices?.worldMatrix || this.worldMatrix;
            const invModelMatrix = options?.overrideMatrices?.inverseWorldMatrix || this.inverseWorldMatrix;
            const normalMatrix = options?.overrideMatrices?.normalMatrix || this._normalMatrix;
            const prevViewMatrix = options?.overrideMatrices?.prevViewMatrix || this._prevViewMatrix;
            const prevPVMatrix = options?.overrideMatrices?.prevPVMatrix || this._prevPVMatrix;
            const prevProjectionMatrix = options?.overrideMatrices?.prevProjectionMatrix || this._prevProjectionMatrix;
            const prevWorldMatrix = options?.overrideMatrices?.prevWorldMatrix || this._prevWorldMatrix;
            let passOwner = material;
            while (passOwner?.parent) {
                passOwner = passOwner.parent;
            }
            passOwner.uniforms;
            const passGeneration = getPassGeneration();
            const isFirstUseInPass = passOwner._passGeneration !== passGeneration ||
                passOwner._passCamera !== camera;
            if (isFirstUseInPass) {
                passOwner._passGeneration = passGeneration;
                passOwner._passCamera = camera;
                copy$6(this._viewMatrix, camera.inverseWorldMatrix);
                copy$6(this._projectionMatrix, camera.projectionMatrix);
                multiply$6(this._projectViewMatrix, camera.projectionMatrix, this._viewMatrix);
                this._cameraPosition[0] = camera.worldMatrix[12];
                this._cameraPosition[1] = camera.worldMatrix[13];
                this._cameraPosition[2] = camera.worldMatrix[14];
                material.setUniform('uCameraPosition', this._cameraPosition);
                material.setUniform('uVMatrix', this._viewMatrix);
                material.setUniform('uPVMatrix', this._projectViewMatrix);
                material.setUniform('uNormalViewMatrix', camera._normalMatrix);
                material.setUniform('uPMatrix', this._projectionMatrix);
            }
            // Per-mesh. Built straight off the camera so it does not depend on
            // this mesh's own _viewMatrix having been refreshed above.
            multiply$6(this._modelViewMatrix, camera.inverseWorldMatrix, modelMatrix);
            material.setUniform('uNormalMatrix', normalMatrix);
            material.setUniform('uMMatrix', modelMatrix);
            material.setUniform('uInvMMatrix', invModelMatrix);
            material.setUniform('uMVMatrix', this._modelViewMatrix);
            material.setUniform('uPrevVMatrix', prevViewMatrix);
            material.setUniform('uPrevPVMatrix', prevPVMatrix);
            material.setUniform('uPrevPMatrix', prevProjectionMatrix);
            material.setUniform('uPrevMMatrix', prevWorldMatrix);
            // if (options?.sharedUniforms ) {
            // 	const sharedUniforms = options.sharedUniforms;
            // 	if (sharedUniforms) {
            // 		for (const u in sharedUniforms) {
            // 			material.setUniform(u, sharedUniforms[u]);
            // 		}
            // 	}
            // }
            // if (typeof material.setUniformsFrom !== 'function') {
            // 	console.error('INVALID_PROGRAM_INSTANCE', {
            // 		constructor: material?.constructor?.name,
            // 		prototype: Object.getPrototypeOf(material),
            // 		material,
            // 	});
            // 	debugger;
            // }
            if (isFirstUseInPass) {
                material.setUniformsFrom(options?.sharedUniforms);
            }
            if (isFirstUseInPass && options?.uniforms) {
                const optionUniforms = options.uniforms;
                for (const u in optionUniforms) {
                    passOwner.setUniform(u, optionUniforms[u]);
                }
            }
            for (const u in this.uniforms) {
                material.setUniform(u, this.uniforms[u]);
            }
            // Add inhreited defines, and make sure they get delete when no used anymore
            // when setting a deined, we defined acopy with a prefix INHEIRETED_* that will help us finding them and deleteing them from the material
            // when the defined does exists anymore on the context.
            // this is quite hacky, but this works, and doesnt have any bad side effects
            const sharedDefines = getInheritedDefines(options.sharedDefines, passGeneration);
            const optionDefines = getInheritedDefines(options.defines, passGeneration);
            const inheritedDefinesChanged = passOwner._inheritedDefinesInitialized !== true ||
                passOwner._inheritedDefinesDirty === true ||
                passOwner._lastSharedDefines !== sharedDefines ||
                passOwner._lastOptionDefines !== optionDefines;
            if (inheritedDefinesChanged && !window.freezeInheritedDefines) {
                for (const k in material.defines) {
                    if (!k.startsWith('INHERITED_'))
                        continue;
                    const realKey = k.slice('INHERITED_'.length);
                    if (!hasInheritedDefine(sharedDefines, optionDefines, realKey)) {
                        delete material.defines[realKey];
                        delete material.defines[k];
                    }
                }
                applyInheritedDefines(material, sharedDefines);
                applyInheritedDefines(material, optionDefines);
                passOwner._inheritedDefinesInitialized = true;
                passOwner._inheritedDefinesDirty = false;
                passOwner._lastSharedDefines = sharedDefines;
                passOwner._lastOptionDefines = optionDefines;
            }
            if (this.options.beforeRender) {
                this.options.beforeRender(this, material);
            }
            let drawOptions = options;
            // Handle special case for reverse culling.
            // if a mesh uses negative scaling, we need to invert the cullign because triangle winding is reversed
            // We also need to handle case wehre we have global oveeride(ex: shadows) so we can flip that override
            // The reverseCullign is managed at Mesh level, because a same material coudl be used by different mesh, and only soem may need reverse culling
            if (this.reverseCulling) {
                const overrides = Object.assign({}, options?.overrides);
                if (overrides.cullFace !== Constants.CullMode.None) {
                    const cullFace = overrides.cullFace !== void 0
                        ? overrides.cullFace
                        : material.cullFace;
                    overrides.cullFace = cullFace === Constants.CullMode.Front
                        ? Constants.CullMode.Back
                        : Constants.CullMode.Front;
                }
                drawOptions = {
                    overrides,
                    usetransformFeedback: options?.usetransformFeedback
                };
            }
            material.beforeDraw?.();
            material.draw(this.geometry, drawOptions);
            material.afterDraw?.();
            if (this.options?.afterRender) {
                this.options?.afterRender();
            }
        }
    }
}

let _vector = create$5();
class Plane {
    constructor() {
        this.normal = create$5();
        this.w = 0;
    }
    distanceToPoint(p) {
        return dot$3(this.normal, p) + this.w;
    }
    setComponents(x, y, z, w) {
        set$5(this.normal, x, y, z);
        this.w = w;
        return this;
    }
    normalize() {
        let inverseNormalLength = 1.0 / length$3(this.normal);
        scale$5(this.normal, this.normal, inverseNormalLength);
        this.w *= inverseNormalLength;
        return this;
    }
}
class Frustum {
    constructor() {
        this.planes = [];
        for (var i = 0; i < 6; i++) {
            this.planes.push(new Plane());
        }
    }
    intersectsSphere(sphere) {
        for (let i = 0; i < 6; i++) {
            let dist = this.planes[i].distanceToPoint(sphere.center);
            if (dist < -sphere.radius) {
                return false;
            }
        }
        return true;
    }
    intersectsBox(box) {
        var planes = this.planes;
        for (var i = 0; i < 6; i++) {
            var plane = planes[i];
            _vector[0] = plane.normal[0] > 0 ? box.max[0] : box.min[0];
            _vector[1] = plane.normal[1] > 0 ? box.max[1] : box.min[1];
            _vector[2] = plane.normal[2] > 0 ? box.max[2] : box.min[2];
            if (plane.distanceToPoint(_vector) < 0) {
                return false;
            }
        }
        return true;
    }
    setFromProjectionViewMatrix(m) {
        this.planes[0].setComponents(m[3] - m[0], m[7] - m[4], m[11] - m[8], m[15] - m[12]).normalize();
        this.planes[1].setComponents(m[3] + m[0], m[7] + m[4], m[11] + m[8], m[15] + m[12]).normalize();
        this.planes[2].setComponents(m[3] + m[1], m[7] + m[5], m[11] + m[9], m[15] + m[13]).normalize();
        this.planes[3].setComponents(m[3] - m[1], m[7] - m[5], m[11] - m[9], m[15] - m[13]).normalize();
        this.planes[4].setComponents(m[3] - m[2], m[7] - m[6], m[11] - m[10], m[15] - m[14]).normalize();
        this.planes[5].setComponents(m[3] + m[2], m[7] + m[6], m[11] + m[10], m[15] + m[14]).normalize();
    }
}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 2 Dimensional Vector
 * @module vec2
 */
/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */
function create$1() {
    let out = new ARRAY_TYPE(2);
    out[0] = 0;
    out[1] = 0;
    return out;
}
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {vec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */
function clone$1(a) {
    let out = new ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */
function fromValues$1(x, y) {
    let out = new ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the source vector
 * @returns {vec2} out
 */
function copy$1(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */
function set$1(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function add$1(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function subtract$1(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function multiply$1(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function divide(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to ceil
 * @returns {vec2} out
 */
function ceil(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to floor
 * @returns {vec2} out
 */
function floor(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function min(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function max(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to round
 * @returns {vec2} out
 */
function round(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */
function scale$1(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */
function scaleAndAdd(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} distance between a and b
 */
function distance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {vec2} a vector to calculate length of
 * @returns {Number} length of a
 */
function length(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {vec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */
function negate(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to invert
 * @returns {vec2} out
 */
function inverse(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */
function normalize(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec3} out
 */
function cross(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec2} out
 */
function lerp(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */
function random(out, scale) {
    scale = scale || 1.0;
    var r = RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat2(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2d} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat2d(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat3} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat4(out, a, m) {
    let x = a[0];
    let y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {vec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$1(a) {
    return 'vec2(' + a[0] + ', ' + a[1] + ')';
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$1(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$1(a, b) {
    let a0 = a[0], a1 = a[1];
    let b0 = b[0], b1 = b[1];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)));
}
/**
 * Alias for {@link vec2.length}
 * @function
 */
const len = length;
/**
 * Alias for {@link vec2.subtract}
 * @function
 */
const sub$1 = subtract$1;
/**
 * Alias for {@link vec2.multiply}
 * @function
 */
const mul$1 = multiply$1;
/**
 * Alias for {@link vec2.divide}
 * @function
 */
const div = divide;
/**
 * Alias for {@link vec2.distance}
 * @function
 */
const dist = distance;
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */
const sqrDist = squaredDistance;
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */
const sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach = (function () {
    let vec = create$1();
    return function (a, stride, offset, count, fn, arg) {
        let i, l;
        if (!stride) {
            stride = 2;
        }
        if (!offset) {
            offset = 0;
        }
        if (count) {
            l = Math.min((count * stride) + offset, a.length);
        }
        else {
            l = a.length;
        }
        for (i = offset; i < l; i += stride) {
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
})();

var vec2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create$1,
  clone: clone$1,
  fromValues: fromValues$1,
  copy: copy$1,
  set: set$1,
  add: add$1,
  subtract: subtract$1,
  multiply: multiply$1,
  divide: divide,
  ceil: ceil,
  floor: floor,
  min: min,
  max: max,
  round: round,
  scale: scale$1,
  scaleAndAdd: scaleAndAdd,
  distance: distance,
  squaredDistance: squaredDistance,
  length: length,
  squaredLength: squaredLength,
  negate: negate,
  inverse: inverse,
  normalize: normalize,
  dot: dot,
  cross: cross,
  lerp: lerp,
  random: random,
  transformMat2: transformMat2,
  transformMat2d: transformMat2d,
  transformMat3: transformMat3,
  transformMat4: transformMat4,
  str: str$1,
  exactEquals: exactEquals$1,
  equals: equals$1,
  len: len,
  sub: sub$1,
  mul: mul$1,
  div: div,
  dist: dist,
  sqrDist: sqrDist,
  sqrLen: sqrLen,
  forEach: forEach
});

function applyMat4(v, e) {
    const w = 1 / (e[3] * v[0] + e[7] * v[1] + e[11] * v[2] + e[15]);
    return [
        (e[0] * v[0] + e[4] * v[1] + e[8] * v[2] + e[12]) * w,
        (e[1] * v[0] + e[5] * v[1] + e[9] * v[2] + e[13]) * w,
        (e[2] * v[0] + e[6] * v[1] + e[10] * v[2] + e[14]) * w
    ];
}

const TOUCH = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0);
const POINTER = !!window.navigator.pointerEnabled;
const MS_POINTER = !!window.navigator.msPointerEnabled;
const POINTER_DOWN = TOUCH ? 'touchstart' : (POINTER ? 'pointerdown' : (MS_POINTER ? 'MSPointerDown' : 'mousedown'));
const POINTER_MOVE = TOUCH ? 'touchmove' : (POINTER ? 'pointermove' : (MS_POINTER ? 'MSPointerMove' : 'mousemove'));
const POINTER_UP = TOUCH ? 'touchend' : (POINTER ? 'pointerup' : (MS_POINTER ? 'MSPointerUp' : 'mouseup'));
class Camera extends Object3d {
    constructor(options) {
        super();
        this.touchEventPageX = 0;
        this.touchEventPageY = 0;
        this._onPointerDown = this._onPointerDown.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onPointerUp = this._onPointerUp.bind(this);
        this._onMouseWheel = this._onMouseWheel.bind(this);
        this.onContextMenu = this.onContextMenu.bind(this);
        this._handleOrientation = this._handleOrientation.bind(this);
        this._projScreenMatrix = create$6();
        options = Object.assign({}, {
            fov: 45,
            aspect: window.innerWidth / window.innerHeight,
            near: 10,
            far: 1000,
            type: 'perspective',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            orbitControl: false,
            wheel: true,
            lookAt: null,
            pointerParent: document,
            firstPerson: false,
            lookAround: false,
            playerCamera: false,
            tilt: false,
            moveSpeed: 1,
            wheelSpeed: 1,
            distance: 20,
            position: [0, 0, 0],
            frustum: false,
            cameraDistance: 100,
            theta: 0,
            phi: 0,
            minTheta: -Math.PI,
            maxTheta: Math.PI,
            minPhi: -Math.PI,
            maxPhi: Math.PI,
            minCameraDistance: 0,
            maxCameraDistance: 10000,
            offset: [0, 0, 0],
            drag: false,
            heightMap: null,
            landscapeSize: [0, 0],
            useCameraRotationEase: true,
            reverseCameraRotation: false,
            cameraTiltTheta: 0.1,
            cameraTiltPhi: 0.05,
            useTilt: false,
            useRail: false,
            followTerrain: false,
            useCollision: false,
            minPolarAngle: Math.PI * -1,
            maxPolarAngle: Math.PI * 1,
            skipGlobalSettings: false,
            thetaSmoothing: 0.1,
            phiSmoothing: 0.8,
            preventKeyboard: false,
        }, options);
        this._cache = {};
        this.preventKeyboard = options.preventKeyboard;
        this.useTilt = options.useTilt;
        this.useRail = options.useRail;
        this.followTerrain = options.followTerrain;
        this.useCollision = options.useCollision;
        this.skipGlobalSettings = options.skipGlobalSettings;
        this.extraTheta = 0;
        this.extraPhi = 0;
        this._cameraTiltTheta = options.cameraTiltTheta; // 0.1
        this._cameraTiltPhi = options.cameraTiltPhi; //0.05
        this.heightMap = options.heightMap;
        this.landscapeSize = options.landscapeSize;
        this.playerCamera = options.playerCamera;
        this.drag = options.drag;
        this.dragDirX = create$1();
        this.dragDirY = create$1();
        this.offset = options.offset || [0, 0, 0];
        this.minCameraDistance = options.minCameraDistance;
        this.maxCameraDistance = options.maxCameraDistance;
        this.minPolarAngle = options.minPolarAngle; //Math.PI * -1 
        this.maxPolarAngle = options.maxPolarAngle; // Math.PI * 1 
        this.theta = options.theta;
        this.phi = options.phi;
        this.currTheta = this.theta;
        this.currPhi = this.phi;
        this.pointerTheta = 0;
        this.pointerPhi = 0;
        this.currPointerPhi = 0;
        this.currPointerTheta = 0;
        this.useCameraRotationEase = options.useCameraRotationEase;
        this.reverseCameraRotation = options.reverseCameraRotation;
        this.minTheta = options.minTheta;
        this.maxTheta = options.maxTheta;
        this.minPhi = options.minPhi;
        this.maxPhi = options.maxPhi;
        this.frustum = options.frustum ? new Frustum() : null;
        this.lookAt = options.lookAt;
        this.fov = options.fov;
        this.aspect = options.aspect;
        this.near = options.near;
        this.far = options.far;
        this.type = options.type;
        this.left = options.left;
        this.right = options.right;
        this.top = options.top;
        this.bottom = options.bottom;
        this.orbitControl = options.orbitControl;
        this.tilt = options.tilt;
        this.firstPerson = options.firstPerson;
        this.lookAround = options.lookAround;
        this.wheel = options.wheel;
        this.thetaSmoothing = options.thetaSmoothing;
        this.phiSmoothing = options.phiSmoothing;
        this.projectionMatrix = create$6();
        this.inverseProjectionMatrix = create$6();
        this.updateProjectionMatrix();
        if (this.orbitControl || this.tilt || this.firstPerson || this.lookAround) {
            if (!this.lookAt) {
                this.lookAt = create$5();
                set$5(this.lookAt, 0, 0, 0);
            }
            this.originalLookAt = create$5();
            copy$5(this.originalLookAt, this.lookAt);
            this._pointerParent = options.pointerParent;
            this._initPointerEvents();
            this._cameraDistance = options.cameraDistance;
        }
        if (this.firstPerson && !this.preventKeyboard) {
            document.addEventListener("contextmenu", this.onContextMenu.bind(this), false);
            document.addEventListener("keydown", this.onKeyDown.bind(this), false);
            document.addEventListener("keyup", this.onKeyUp.bind(this), false);
        }
        this.pitchObject = new Container();
        this.pitchObject.id = this.pitchObject.name = 'Camera__pitchObject';
        this.yawObject = new Container();
        this.yawObject.id = this.yawObject.name = 'Camera__yawObject';
        this.yawObject.add(this.pitchObject);
        this.moveSpeed = options.moveSpeed;
        this.wheelSpeed = options.wheelSpeed;
        this.time = Date.now();
        this._velocity = create$5();
        this._moveForward = false;
        this._moveBackward = false;
        this._moveLeft = false;
        this._moveRight = false;
        this._moveUp = false;
        this._camera = create$5();
        this._oldPosition = create$5();
        this.position[0] = options.position[0];
        this.position[1] = options.position[1];
        this.position[2] = options.position[2];
        this._oldPosition[0] = this.position[0];
        this._oldPosition[1] = this.position[1];
        this._oldPosition[2] = this.position[2];
        this.currPointerXMove = 0;
        this.currPointerYMove = 0;
    }
    updateProjectionMatrix() {
        if (this.type == 'perspective') {
            perspective(this.projectionMatrix, this.fov * Math.PI / 180.0, this.aspect, this.near, this.far);
        }
        else if (this.type == 'orthographic' || this.type == 'ortho') {
            ortho(this.projectionMatrix, this.left, this.right, this.bottom, this.top, this.near, this.far);
        }
        invert$3(this.inverseProjectionMatrix, this.projectionMatrix);
    }
    _initPointerEvents() {
        this.winWidth = window.innerWidth;
        this.winHeight = window.innerHeight;
        this._isPointerDown = false;
        this.isRightClick = false;
        this.pointerXMove = 0;
        this.pointerYMove = 0;
        this.pointerX = 0;
        this.pointerY = 0;
        this.pointerZ = 0;
        this.lastPointerX = 0;
        this.lastPointerY = 0;
        this.lastPointerZ = 0;
        this.thetaDown = this.theta;
        this.phiDown = this.phi;
        this._pointerParent.addEventListener(POINTER_DOWN, this._onPointerDown, { passive: false });
        document.addEventListener(POINTER_MOVE, this._onPointerMove, { passive: false });
        document.addEventListener(POINTER_UP, this._onPointerUp, false);
        // if (window.DeviceMotionEvent && typeof window.DeviceMotionEvent.requestPermission === 'function') {
        //   document.addEventListener('click', function () {
        //       DeviceOrientationEvent.requestPermission().then(response => {
        //         if (response == 'granted') {
        //           window.addEventListener("deviceorientation", this._handleOrientation, true);
        //         }
        //       }).catch(console.error)
        //   });
        // }
        // else {
        //   window.addEventListener("deviceorientation", this._handleOrientation, true);
        // }
        this._pointerParent.addEventListener("contextmenu", this.onContextMenu, false);
        if (this.wheel) {
            this._pointerParent.addEventListener('DOMMouseScroll', this._onMouseWheel); //,  {passive:false} );
            this._pointerParent.addEventListener('mousewheel', this._onMouseWheel); //,  {passive:false} );
        }
    }
    delete() {
        this._pointerParent.removeEventListener(POINTER_DOWN, this._onPointerDown, false);
        document.removeEventListener(POINTER_MOVE, this._onPointerMove, false);
        document.removeEventListener(POINTER_UP, this._onPointerUp, false);
        this._pointerParent.removeEventListener("contextmenu", this.onContextMenu, false);
        if (this.wheel) {
            this._pointerParent.removeEventListener('DOMMouseScroll', this._onMouseWheel); //,  {passive:false} );
            this._pointerParent.removeEventListener('mousewheel', this._onMouseWheel); //,  {passive:false} );
        }
        document.removeEventListener("keydown", this.onKeyDown, false);
        document.removeEventListener("keyup", this.onKeyUp, false);
    }
    destroy() {
        this.delete();
    }
    onContextMenu(e) {
        if (this.disabled) {
            return;
        }
        event.preventDefault();
    }
    onKeyDown(event) {
        if (this.disabled) {
            return;
        }
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
                this._moveForward = true;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                this._moveLeft = true;
                break;
            case 'ArrowDown':
            case 'KeyS':
                this._moveBackward = true;
                break;
            case 'ArrowRight':
            case 'KeyD':
                this._moveRight = true;
                break;
            case 'Space':
                this._velocity[1] += 5;
                break;
        }
    }
    onKeyUp(event) {
        if (this.disabled) {
            return;
        }
        switch (event.code) {
            case 'ArrowUp':
            case 'KeyW':
                this._moveForward = false;
                break;
            case 'ArrowLeft':
            case 'KeyA':
                this._moveLeft = false;
                break;
            case 'ArrowDown':
            case 'KeyS':
                this._moveBackward = false;
                break;
            case 'ArrowRight':
            case 'KeyD':
                this._moveRight = false;
                break;
        }
    }
    _onMouseWheel(e) {
        if (this.disabled) {
            return;
        }
        // e.preventDefault();
        // e.stopPropagation();
        var wheelDeltaY;
        if (e.wheelDelta) {
            wheelDeltaY = e.wheelDelta; //6 or 12
        }
        else if (e.detail) {
            wheelDeltaY = -e.detail * 40; // *3
        }
        else if (e.wheelDeltaX) {
            wheelDeltaY = e.wheelDeltaY / 12;
            -1 * e.wheelDeltaX / 12;
        }
        else if (e.axis !== undefined && e.axis === e.HORIZONTAL_AXIS) {
            wheelDeltaY = 0;
        }
        else {
            wheelDeltaY = 0;
        }
        this._cameraDistance += wheelDeltaY * -1 * this.wheelSpeed; //0.001;
        this._cameraDistance = Math.min(this.maxCameraDistance, Math.max(this.minCameraDistance, this._cameraDistance));
    }
    disable() {
        this.disabled = true;
    }
    enable() {
        this.disabled = false;
    }
    _onPointerDown(event) {
        if (this.disabled) {
            return;
        }
        if (event.which == 3) {
            this.isRightClick = true;
        }
        document.body.classList.add("is-dragging");
        this._isPointerDown = true;
        this.touchEvent = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
        // if (!this.lookAround) {
        this.touchEventPageX = this.touchEvent.pageX;
        this.touchEventPageY = this.touchEvent.pageY;
        this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
        this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
        this.pointerXDown = this.touchEventPageX;
        this.pointerYDown = this.touchEventPageY;
        this.startPointerX = this.pointerXMove;
        this.startPointerY = this.pointerYMove;
        if (this.drag) {
            set$1(this.dragDirY, this.position[0], this.position[2]);
            subtract$1(this.dragDirY, this.dragDirY, [this.lookAt[0], this.lookAt[2]]);
            normalize(this.dragDirY, this.dragDirY);
            set$1(this.dragDirX, this.dragDirY[1], -this.dragDirY[0]);
        }
        if (!this.tilt) {
            this.thetaDown = this.theta;
            this.phiDown = this.phi;
        }
        // }
    }
    _handleOrientation() {
        // if (this._isPointerDown) {
        //   return
        // }
        // if (this.playerCamera) {
        //   this.pointerRatio[0] = (event.gamma) / 25
        //   this.pointerRatio[1] = (event.beta-45) / 25
        //   this.pointerTheta = (  (event.gamma) / 25  * 0.1 * -1  );
        //   this.pointerPhi   = ( (event.beta-45) / 25 * 0.05 * -1);
        // }
    }
    _onPointerMove(event) {
        if ((!this._isPointerDown && !document.pointerLockElement && (!this.lookAround && !this.tilt)) || this.disabled) {
            return;
        }
        if (this._isPointerDown) {
            event.preventDefault();
            if (TOUCH)
                event.stopPropagation();
        }
        if ( /*this.isRightClick || */this._isPointerDown && this.drag) {
            let touchEvent = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
            let touchEventPageX = touchEvent.pageX;
            let touchEventPageY = touchEvent.pageY;
            touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
            this.pointerXMove = this.startPointerX
                + (this.dragDirY[0] * (touchEventPageY - this.pointerYDown) * -1)
                + (this.dragDirX[0] * (touchEventPageX - this.pointerXDown) * -1 * 0.5);
            this.pointerYMove = this.startPointerY
                + (this.dragDirY[1] * (touchEventPageY - this.pointerYDown) * -1)
                + (this.dragDirX[1] * (touchEventPageX - this.pointerXDown) * -1 * 0.5);
            return;
        }
        if (!!document.pointerLockElement) {
            this.touchEvent = event;
            this.touchEventPageX += this.touchEvent.movementX;
            this.touchEventPageY += this.touchEvent.movementY;
            this.touchEventPageY = Math.max(0, Math.min(window.innerHeight, this.touchEventPageY));
            this.pointerXOrbiter = (this.touchEventPageX);
            this.pointerYOrbiter = (this.touchEventPageY);
            this.theta = (((this.pointerXOrbiter / window.innerWidth) - 0.5) * Math.PI) * -1;
            this.phi = (((this.pointerYOrbiter / window.innerHeight) - 0.5) * Math.PI);
        }
        else {
            this.touchEvent = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
            this.touchEventPageX = this.touchEvent.pageX;
            this.touchEventPageY = this.touchEvent.pageY;
            // this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
            this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
            if (this.lookAround || this.tilt) {
                if (this.tilt) {
                    this.pointerXOrbiter = this.touchEventPageX;
                    this.pointerYOrbiter = this.touchEventPageY;
                    this.theta = this.thetaDown + (((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI / (20 / 2) * -1); //20
                    this.phi = this.phiDown + (((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI / 30); //30
                    this.phi = Math.max(this.minPhi, Math.min(this.maxPhi, this.phi));
                    this.theta = Math.max(this.minTheta, Math.min(this.maxTheta, this.theta));
                }
                else {
                    if (this.playerCamera) {
                        if (this._isPointerDown) {
                            this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
                            this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
                            this.theta = this.thetaDown + (((this.pointerXOrbiter / window.innerWidth) * 2) * Math.PI / 4 * -1);
                            this.phi = this.phiDown + (((this.pointerYOrbiter / window.innerHeight) * 2) * Math.PI / 8 * -1);
                        }
                        this.pointerTheta = (((this.touchEventPageX / window.innerWidth - .5) * 2) * this._cameraTiltTheta * -1);
                        this.pointerPhi = (((this.touchEventPageY / window.innerHeight - .5) * 2) * this._cameraTiltPhi * -1);
                    }
                    else {
                        this.pointerXOrbiter = this.touchEventPageX;
                        this.pointerYOrbiter = this.touchEventPageY;
                        this.theta = (((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI * 0.4 * -1);
                        this.phi = (((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI * 0.125 * -1);
                    }
                    this.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this.phi));
                    // this.phi   = Math.max( this.minPhi, Math.min( this.maxPhi, this.phi ) );
                    this.theta = Math.max(this.minTheta, Math.min(this.maxTheta, this.theta));
                }
            }
            else if (this.firstPerson && this.reverseCameraRotation) {
                this.pointerXMove = this.startPointerX + (this.touchEventPageX - this.pointerXDown);
                this.pointerYMove = this.startPointerY + (this.touchEventPageY - this.pointerYDown);
                this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
                this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
                this.theta = this.thetaDown + (this.pointerXOrbiter / window.innerWidth * 2 * Math.PI * 0.5 * -1);
                this.phi = this.phiDown + (this.pointerYOrbiter / window.innerHeight * 2 * Math.PI * 0.2);
                this.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this.phi));
            }
            else {
                this.pointerXMove = this.startPointerX + (this.touchEventPageX - this.pointerXDown);
                this.pointerYMove = this.startPointerY + (this.touchEventPageY - this.pointerYDown);
                this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
                this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
                this.theta = this.thetaDown + (this.pointerXOrbiter / window.innerWidth * 2 * Math.PI);
                this.phi = this.phiDown + (this.pointerYOrbiter / window.innerHeight * 2 * Math.PI * -1);
                this.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this.phi));
            }
        }
    }
    _onPointerUp() {
        this._isPointerDown = false;
        this.isRightClick = false;
        document.body.classList.remove("is-dragging");
    }
    freeze() {
        this.isFrozen = true;
    }
    unfreeze() {
        this.isFrozen = false;
    }
    update(skipRotation) {
        if (this.isFrozen || this.disabled) {
            return;
        }
        let projectionMatrixNeedsUpdate = false;
        let projectionsProps = ['type', 'fov', 'near', 'far', 'left', 'right', 'top', 'bottom', 'aspect'];
        projectionsProps?.forEach(prop => {
            if (this._cache[prop] !== this[prop]) {
                this._cache[prop] = this[prop];
                projectionMatrixNeedsUpdate = true;
            }
        });
        if (projectionMatrixNeedsUpdate) {
            this.updateProjectionMatrix();
        }
        if (this.orbitControl) {
            this.currTheta += (this.theta - this.currTheta) * this.thetaSmoothing;
            this.currPhi += (this.phi - this.currPhi) * 0.8;
            this.position[0] = this.offset[0] + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
            this.position[1] = this.offset[1] + Math.sin(this.currPhi) * this._cameraDistance;
            this.position[2] = this.offset[2] + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
            this.lookAt[0] = this.offset[0]; //0.000000001//this.pointerXMove / -100;
            this.lookAt[1] = this.offset[1]; //0.000000001//this.pointerYMove / 100; 
            this.lookAt[2] = this.offset[2]; //0.000000001
            // super.render(true);
            super.updateMatrices(true);
        }
        else if (this.tilt) {
            this.currTheta += (this.theta - this.currTheta) * 0.05;
            this.currPhi += (this.phi - this.currPhi) * 0.05;
            let dragY = create$5();
            copy$5(dragY, this.position);
            subtract$4(dragY, dragY, this.lookAt);
            normalize$3(dragY, dragY);
            // this.pointerYMove
            this.currPointerXMove += (this.pointerXMove - this.currPointerXMove) * 0.15;
            this.currPointerYMove += (this.pointerYMove - this.currPointerYMove) * 0.15;
            this.position[0] = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
            this.position[1] = this.offset[1] + Math.sin(this.currPhi) * this._cameraDistance;
            this.position[2] = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
            this.lookAt[0] = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1;
            this.lookAt[1] = this.offset[1] + Math.sin(this.currPhi) * this._cameraDistance * -1;
            this.lookAt[2] = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1;
            // super.render(true);
            super.updateMatrices(true);
        }
        else if (this.lookAround) {
            if (!skipRotation) {
                let time = Date.now();
                this.lastTiltTime = this.lastTiltTime || Date.now();
                let dd = (time - this.lastTiltTime) / 1000;
                this.lastTiltTime = time;
                const easSpeed = 0.07 * (dd / 0.016);
                const easSpeed2 = 0.05 * (dd / 0.016);
                // this.currTheta += (this.theta - this.currTheta) * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;
                // this.currPhi   += (this.phi   - this.currPhi)     * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;
                this.currTheta += ((this.theta) - this.currTheta) * easSpeed;
                this.currPhi += ((this.phi) - this.currPhi) * easSpeed;
                this.currPointerTheta += ((this.pointerTheta) - this.currPointerTheta) * easSpeed2;
                this.currPointerPhi += ((this.pointerPhi) - this.currPointerPhi) * easSpeed2;
            }
            this.lookAt[0] = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta || 0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100;
            this.lookAt[1] = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi + (this.extraPhi || 0)) * 100;
            this.lookAt[2] = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta || 0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100;
            // if (this.playerCamera) {
            //   this.position[0] = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
            //   this.position[1] = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi ) * 70 * -1
            //   this.position[2] = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
            // }
            // else {
            this.position[0] = this.offset[0]; //+ Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
            this.position[1] = this.offset[1]; //+ Math.sin(this.currPhi + this.currPointerTheta ) * -1
            this.position[2] = this.offset[2]; //+ Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
            // }
            // super.render();
            super.updateMatrices();
        }
        else if (this.firstPerson) {
            let time = Date.now();
            let delta = (time - this.time) / 1000;
            this.prevTime = time;
            delta = Math.min(1000 / 30, delta);
            // use delta to accomodate for 120fps mode
            // update phi and theta easing
            if (!skipRotation) {
                let time = Date.now();
                this.lastTiltTime = this.lastTiltTime || Date.now();
                let tiltDelta = (time - this.lastTiltTime) / 1000;
                this.lastTiltTime = time;
                const easSpeed = 0.1 * (tiltDelta / 0.016);
                this.currTheta += (this.theta - this.currTheta) * (this.useCameraRotationEase ? easSpeed : 0.5); //0.2//0.1;
                this.currPhi += (this.phi - this.currPhi) * (this.useCameraRotationEase ? easSpeed : 0.5); //0.2//0.1;
            }
            /* first we reset position to only rotate the camera and get a worldmatrix without the translation */
            // this._oldPosition[0] = this.position[0] + this.offset[0] ;
            // this._oldPosition[1] = this.position[1] + this.offset[1] ;
            // this._oldPosition[2] = this.position[2] + this.offset[2] ;
            this._lastOffset ||= create$5();
            this._oldPosition[0] = this.position[0] + this.offset[0] - this._lastOffset[0];
            this._oldPosition[1] = this.position[1] + this.offset[1] - this._lastOffset[1];
            this._oldPosition[2] = this.position[2] + this.offset[2] - this._lastOffset[2];
            copy$5(this._lastOffset, this.offset);
            this.position[0] = 0;
            this.position[1] = 0;
            this.position[2] = 0;
            this.lookAt[0] = Math.sin(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100;
            this.lookAt[1] = Math.sin(this.currPhi + (this.extraPhi || 0)) * 100 * -1;
            this.lookAt[2] = Math.cos(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100;
            this.updateMatrix();
            /* get the rotation matrix now */
            var _matrix = create$6();
            copy$6(_matrix, this.matrix);
            let velocityTowardDir = create$5();
            if (this._moveForward) {
                add$5(velocityTowardDir, velocityTowardDir, [0, 0, -1]);
            }
            if (this._moveBackward) {
                add$5(velocityTowardDir, velocityTowardDir, [0, 0, 1]);
            }
            if (this._moveLeft) {
                add$5(velocityTowardDir, velocityTowardDir, [-1, 0, 0]);
            }
            if (this._moveRight) {
                add$5(velocityTowardDir, velocityTowardDir, [1, 0, 0]);
            }
            normalize$3(velocityTowardDir, velocityTowardDir);
            /* rotate the direction vector to align with camera rotation */
            velocityTowardDir = applyMat4(velocityTowardDir, _matrix);
            normalize$3(velocityTowardDir, velocityTowardDir);
            /* now scale it to the required speed */
            scale$5(velocityTowardDir, velocityTowardDir, this.moveSpeed * 20);
            /* then scale to delta for euler integration */
            scale$5(velocityTowardDir, velocityTowardDir, delta);
            /* now add it to velocity */
            add$5(this._velocity, this._velocity, velocityTowardDir);
            /*  now integrate move position with velocity */
            this.position[0] = this._oldPosition[0] + this._velocity[0] * delta;
            this.position[1] = this._oldPosition[1] + this._velocity[1] * delta;
            this.position[2] = this._oldPosition[2] + this._velocity[2] * delta;
            /* friction/damping */
            this._velocity[0] *= 0.9;
            this._velocity[1] *= 0.9;
            this._velocity[2] *= 0.9;
            this.time = time;
            /*  update the lookAt to integrate the new position */
            this.lookAt[0] = Math.sin(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 + this.position[0];
            this.lookAt[1] = Math.sin(this.currPhi + (this.extraPhi || 0)) * 100 * -1 + this.position[1];
            this.lookAt[2] = Math.cos(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 + this.position[2];
            this.updateMatrices();
        }
        else {
            // super.render(true);
            super.updateMatrices(true);
        }
        // if (this.frustum) {
        //   mat4.multiply(this._projScreenMatrix, this.projectionMatrix, this.inverseWorldMatrix );
        //   this.frustum && this.frustum.setFromProjectionViewMatrix( this._projScreenMatrix )
        // }
    }
}
__decorate([
    property({ type: 'number', category: 'Camera', step: 1, min: 0, max: 180 })
], Camera.prototype, "fov", void 0);
__decorate([
    property({ type: 'number', category: 'Camera', step: 1, min: 0, max: 100 })
], Camera.prototype, "near", void 0);
__decorate([
    property({ type: 'number', category: 'Camera', step: 1000, min: 0, max: 100_000, allowInfinity: true })
], Camera.prototype, "far", void 0);
__decorate([
    property({ type: 'number', category: 'Camera', step: 1000, min: 0, max: 10_000 })
], Camera.prototype, "moveSpeed", void 0);

const extensions = {};
function getType(gl, type) {
    if (extensions['EXT_color_buffer_float'] === void 0) {
        extensions['EXT_color_buffer_float'] = gl.getExtension('EXT_color_buffer_float');
    }
    if (extensions['OES_texture_float_linear'] === void 0) {
        extensions['OES_texture_float_linear'] = gl.getExtension('OES_texture_float_linear');
    }
    if (extensions['EXT_color_buffer_float'] === void 0) {
        extensions['EXT_color_buffer_float'] = gl.getExtension('EXT_color_buffer_float');
    }
    if (extensions['OES_texture_half_float_linear'] === void 0) {
        extensions['OES_texture_half_float_linear'] = gl.getExtension('OES_texture_half_float_linear');
    }
    if (type === gl.FLOAT) {
        if (!extensions['EXT_color_buffer_float']) {
            console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
            type = gl.HALF_FLOAT;
        }
    }
    if (type === gl.HALF_FLOAT) {
        if (!extensions['EXT_color_buffer_float']) {
            console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
            type = gl.UNSIGNED_BYTE;
        }
    }
    return type;
}
const resizeQueue = [];
let resizeQueueFrame = null;
function cancelResize(frameBuffer) {
    frameBuffer._pendingResize = null;
    if (!frameBuffer._resizeQueued) {
        return;
    }
    const index = resizeQueue.indexOf(frameBuffer);
    if (index !== -1) {
        resizeQueue.splice(index, 1);
    }
    frameBuffer._resizeQueued = false;
    if (resizeQueue.length === 0 && resizeQueueFrame !== null) {
        cancelAnimationFrame(resizeQueueFrame);
        resizeQueueFrame = null;
    }
}
class FrameBuffer {
    constructor(gl, options = {}) {
        // console.log('NEW_FRAME_BUFFER', options.source);
        this.options = Object.assign({}, {
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE,
            linear: true,
            mipmap: false,
            mipmapLinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            depthTexture: null,
            skipViewport: false,
            numRenderTargets: 1,
            renderTargets: [],
            depthOnly: false,
            name: 'FrameBuffer'
        }, options);
        this.gl = gl;
        this.type = getType(gl, this.options.type);
        this.name = this.options.name;
        this.skipViewport = this.options.skipViewport;
        this.width = this.options.width;
        this.height = this.options.height;
        this._resizeQueued = false;
        this._pendingResize = null;
        this.format = this.options.format;
        this.linear = this.options.linear;
        this.mipmap = this.options.mipmap;
        this.mipmapLinear = this.options.mipmapLinear;
        this.renderTargets = [];
        if (this.options.numRenderTargets > 1) {
            for (let i = 0; i < this.options.numRenderTargets; i++) {
                this.renderTargets.push({
                    type: this.type,
                });
            }
        }
        if (this.options.renderTargets.length > 0) {
            for (let i = 0; i < this.options.renderTargets.length; i++) {
                this.renderTargets.push({
                    type: getType(gl, this.options.renderTargets[i].type),
                });
            }
        }
        if (this.options.depthOnly) {
            this.fbo = gl.createFramebuffer();
            this.fbo.name = this.name;
            MemoryManager.trackFrameBuffer(this.fbo);
            gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo);
            this.depthTexture = gl.createTexture();
            MemoryManager.trackTexture(this.depthTexture);
            gl.bindTexture(gl.TEXTURE_2D, this.depthTexture);
            {
                gl.texImage2D(gl.TEXTURE_2D, 0, gl.DEPTH_COMPONENT24, this.width, this.height, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_INT, null);
                // gl.texImage2D(gl.TEXTURE_2D, 0, gl.DEPTH_COMPONENT16, this.width, this.height, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_SHORT, null);
            }
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, this.depthTexture, 0);
        }
        else {
            if (this.renderTargets.length > 0) {
                this._textures = [];
                for (let i = 0; i < this.renderTargets.length; i++) {
                    const texture = this.gl.createTexture();
                    MemoryManager.trackTexture(texture);
                    // since we didnt create a beam texture but a webgl texture, there is n ot .bind method on it to be used as uniform
                    texture.bind = unit => {
                        if (!this.gl) {
                            return;
                        }
                        if (unit !== void 0) {
                            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
                        }
                        this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
                    };
                    this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
                    if (this.renderTargets[i].type == this.gl.FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null); // new Float32Array( new Array(this.width * this.height * 4) ));
                    }
                    else if (this.renderTargets[i].type == this.gl.HALF_FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                    }
                    else {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.renderTargets[i].type, new Uint8Array(new Array(this.width * this.height * 4)));
                    }
                    this._textures.push(texture);
                }
            }
            else {
                this._texture = this.gl.createTexture();
                MemoryManager.trackTexture(this._texture);
                this._texture.__is_framebuffer_texture__ = true;
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                if (this.type == this.gl.FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null); // new Float32Array( new Array(this.width * this.height * 4) ));
                }
                else if (this.type == this.gl.HALF_FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                }
                else {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null); //new Uint8Array( new Array(this.width * this.height * 4) ));
                }
            }
            this.wrapS = this.options.wrapS;
            this.wrapT = this.options.wrapT;
            var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
            if (!isPOT) {
                //not POT textures can't repeat & cant use mipmap
                this.wrapS = gl.CLAMP_TO_EDGE;
                this.wrapT = gl.CLAMP_TO_EDGE;
                this.mipmap = false;
                this.mipmapLinear = false;
            }
            if (this._textures) {
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT);
                }
            }
            else {
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT);
            }
            //nPOT texture cannot mipmap
            this.setFilter(this.linear, this.mipmap, this.mipmapLinear);
            if (!this.options.depthTexture) {
                this.renderbuffer = this.gl.createRenderbuffer();
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
                {
                    this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
                    // this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT16, this.width, this.height);
                }
            }
            this.fbo = this.gl.createFramebuffer();
            MemoryManager.trackFrameBuffer(this.fbo);
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            if (this._textures) {
                const buffers = [];
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT' + i], this.gl.TEXTURE_2D, this._textures[i], 0);
                    buffers.push(this.gl['COLOR_ATTACHMENT' + i]);
                }
                // console.log('DRAW_BUFFERS', this.options.name);
                this.gl.drawBuffers(buffers);
            }
            else {
                this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
            }
            // if (this.options.depthTexture) {
            //   this.depthTexture = this.options.depthTexture._texture;
            //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.options.depthTexture._texture, 0);
            // }
            // else {
            this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            // }
        }
        this.unbind();
    }
    /**
     * [setFilter description]
     * @param {[type]} linear       [description]
     * @param {[type]} mipmap       [description]
     * @param {[type]} mipmapLinear [description]
     */
    setFilter(linear, mipmap, mipmapLinear) {
        var gl = this.gl;
        var filter = getFilter(!!linear, !!mipmap, !!mipmapLinear);
        if (this._textures) {
            for (let i = 0; i < this._textures.length; i++) {
                gl.bindTexture(gl.TEXTURE_2D, this._textures[i]);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter(!!linear, false, false));
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
            }
        }
        else {
            gl.bindTexture(gl.TEXTURE_2D, this._texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter(!!linear, false, false));
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
        }
    }
    // resize(w, h) {
    //   if (!this.gl) {
    //     return;
    //   }
    //   const width = w|0;
    //   const height = h|0;
    //   const pendingResize = this._pendingResize;
    //   const currentWidth = pendingResize ? pendingResize.width : this.width;
    //   const currentHeight = pendingResize ? pendingResize.height : this.height;
    //   if (currentWidth === width && currentHeight === height) {
    //     return;
    //   }
    //   enqueueResize(this, width, height);
    // }
    resize(w, h) {
        if (!this.gl) {
            return;
        }
        const width = w | 0;
        const height = h | 0;
        cancelResize(this);
        if (this.width === width && this.height === height) {
            return;
        }
        this._resizeNow(width, height);
    }
    _resizeNow(w, h) {
        if (!this.gl || (this.width === w && this.height === h)) {
            return;
        }
        this.width = w;
        this.height = h;
        if (this.options.depthOnly) {
            // Bind the framebuffer and the depth texture
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
            // Resize the depth texture
            {
                this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT24, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_INT, null);
                // this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT16, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_SHORT, null);
            }
            // Re-attach the depth texture to the framebuffer
            this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
        }
        else {
            var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
            if (!isPOT) {
                this.wrapS = this.gl.CLAMP_TO_EDGE;
                this.wrapT = this.gl.CLAMP_TO_EDGE;
                this.mipmap = false;
                this.mipmapLinear = false;
                this.setFilter(this.linear, this.mipmap, this.mipmapLinear);
            }
            if (this._textures) {
                const buffers = [];
                for (let i = 0; i < this._textures.length; i++) {
                    this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
                    // if (this.type == this.gl.FLOAT) {
                    //   this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, ( this.format),  (this.type), null);
                    // }
                    // else if (this.type == this.gl.HALF_FLOAT) {
                    //   this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                    // }
                    // else {
                    //   this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
                    // }
                    const type = this.renderTargets[i].type;
                    if (type == this.gl.FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, type, null);
                    }
                    else if (type == this.gl.HALF_FLOAT) {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, type, null);
                    }
                    else {
                        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, type, null);
                    }
                    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
                    this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT' + i], this.gl.TEXTURE_2D, this._textures[i], 0);
                    buffers.push(this.gl['COLOR_ATTACHMENT' + i]);
                }
                this.gl.drawBuffers(buffers);
            }
            else {
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                if (this.type == this.gl.FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, (this.format), (this.type), null);
                }
                else if (this.type == this.gl.HALF_FLOAT) {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
                }
                else {
                    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
                }
                this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
                this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
            }
            // if (this.options.depthTexture) {
            //   this.depthTexture.resize(this.width, this.height);
            //   // this.gl.bindTexture(this.gl.TEXTURE_2D, this._depthTexture);
            //   // this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_SHORT, null);
            // }
            // if (this.options.depthTexture) {
            //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture._texture, 0);
            // }
            // else {
            this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
            {
                this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
                // this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT16, this.width, this.height);
            }
            this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            // }
        }
        this.unbind();
    }
    bindFrame(bindOnly) {
        if (bindOnly) {
            this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
            return;
        }
        if (!this.skipViewport) {
            this.gl.viewport(0, 0, this.width, this.height);
        }
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
        if (this.options.depthOnly) {
            this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
            this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
            this.gl.drawBuffers([this.gl.NONE]);
            this.gl.readBuffer(this.gl.NONE);
        }
        else {
            if (!this.options.depthTexture) {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
            }
            else {
                this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
                {
                    this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT24, this.width, this.height);
                    // this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT16, this.width, this.height);
                }
                this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
            }
            this.clear();
        }
    }
    bind(unit) {
        this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        this.gl.bindTexture(this.gl.TEXTURE_2D, this.options.depthOnly ? this.depthTexture : this._texture);
    }
    unbind() {
        this.gl.bindTexture(this.gl.TEXTURE_2D, null);
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
        if (!this.options.depthTexture) {
            this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, null);
        }
    }
    clear(color, depth, stencil) {
        // if (this.options.depthOnly) {
        //   this.gl.clear( this.gl.DEPTH_BUFFER_BIT );
        // }
        // else {
        var bits = 0;
        if (color === void 0 || color)
            bits |= this.gl.COLOR_BUFFER_BIT;
        if (depth === void 0 || depth)
            bits |= this.gl.DEPTH_BUFFER_BIT;
        if (stencil === void 0 || stencil)
            bits |= this.gl.STENCIL_BUFFER_BIT;
        this.gl.clear(bits);
        // }
    }
    dispose() {
        cancelResize(this);
        MemoryManager.untrackFrameBuffer(this.fbo);
        this.gl.deleteFramebuffer(this.fbo);
        this.fbo = null;
        this.gl = null;
    }
}

function defineLightObservable(instance, name) {
    const key = `_${name}`;
    Object.defineProperty(instance, name, {
        get() {
            return this[key];
        },
        set(value) {
            if (Object.is(this[key], value)) {
                return;
            }
            this[key] = value;
            this.lightDataNeedsUpdate = true;
        },
        enumerable: true,
        configurable: true,
    });
}
class Light extends Container {
    constructor(options = {}) {
        options = Object.assign({
            type: 'SpotLight',
            size: 1,
            color: [1, 1, 1],
            direction: [-1, -1, 0],
            position: [1, 1, 1],
            intensity: 1,
            near: 1,
            distance: 100,
            decay: 2,
            angle: Math.PI / 4,
            exponent: 1,
            penumbra: 0,
            castShadow: false,
            shadowMap: false,
            shadowMapResolution: 256,
            width: 0,
            height: 0,
            left: 1000,
            right: 1000,
            top: 1000,
            bottom: 1000,
            shadowCamera: null,
            temperature: -1,
            useTemperature: false,
            maxCameraAngle: 0.9 * Math.PI / 2,
            shadowMode: 'pcf',
            mode: 'dynamic'
        }, options);
        super(options);
        this.__is_light__ = true;
        this.lightDataNeedsUpdate = true;
        this.static = true;
        defineLightObservable(this, 'type');
        defineLightObservable(this, 'mode');
        defineLightObservable(this, 'size');
        defineLightObservable(this, 'intensity');
        defineLightObservable(this, 'distance');
        defineLightObservable(this, 'decay');
        defineLightObservable(this, 'angle');
        defineLightObservable(this, 'exponent');
        defineLightObservable(this, 'penumbra');
        defineLightObservable(this, 'castShadow');
        defineLightObservable(this, 'shadowMap');
        defineLightObservable(this, 'shadowMapResolution');
        defineLightObservable(this, 'width');
        defineLightObservable(this, 'height');
        defineLightObservable(this, 'near');
        defineLightObservable(this, 'useTemperature');
        defineLightObservable(this, 'temperature');
        defineLightObservable(this, 'maxCameraAngle');
        defineLightObservable(this, 'shadowMode');
        this.type = options.type;
        this.size = options.size;
        this.color = options.color;
        this.intensity = options.intensity;
        this.position = options.position;
        this.distance = options.distance;
        this.decay = options.decay;
        this.angle = options.angle;
        this.exponent = options.exponent;
        this.penumbra = options.penumbra;
        this.castShadow = options.castShadow;
        this.shadowMap = options.shadowMap || options.castShadow;
        this.shadowMapResolution = options.shadowMapResolution;
        this.left = options.left;
        this.right = options.right;
        this.top = options.top;
        this.bottom = options.bottom;
        this.near = options.near;
        this.width = options.width;
        this.height = options.height;
        this.useTemperature = options.useTemperature;
        this.temperature = options.temperature;
        this.maxCameraAngle = options.maxCameraAngle;
        this.shadowMode = options.shadowMode;
        this.mode = options.mode;
        this.lightDataNeedsUpdate = true;
        if (options.lookAt) {
            this.lookAt = options.lookAt;
        }
        if (this.shadowMap) {
            this.createShadowMapCamera(options);
        }
    }
    markLightDataNeedsUpdate() {
        this.lightDataNeedsUpdate = true;
    }
    _transformChanged() {
        super._transformChanged();
        this.markLightDataNeedsUpdate();
    }
    _rotationChanged() {
        super._rotationChanged();
        if (!this._constructing) {
            this.markLightDataNeedsUpdate();
        }
    }
    _quaternionChanged() {
        super._quaternionChanged();
        if (!this._constructing) {
            this.markLightDataNeedsUpdate();
        }
    }
    createShadowMapCamera(options) {
        const cameraOption = {
            near: options?.shadowCamera?.near || this.near,
            far: options?.shadowCamera?.far || this.distance,
            type: options?.shadowCamera?.type || (this.type === 'DirectionalLight' ? 'orthographic' : 'perspective'),
            orbitControl: false,
            firstPerson: false,
        };
        if (cameraOption.type === 'perspective') {
            cameraOption.fov = (2 * Math.min(this.maxCameraAngle, this.angle)) * 180 / Math.PI;
            cameraOption.aspect = 1;
            cameraOption.frustum = true;
        }
        if (cameraOption.type === 'orthographic') {
            cameraOption.left = options?.shadowCamera?.left || this.left;
            cameraOption.right = options?.shadowCamera?.right || this.right;
            cameraOption.top = options?.shadowCamera?.top || this.top;
            cameraOption.bottom = options?.shadowCamera?.bottom || this.bottom;
            cameraOption.frustum = false;
        }
        this.shadowMapCamera = new Camera(cameraOption);
        if (this.lookAt) {
            this.shadowMapCamera.lookAt = create$5();
            copy$5(this.shadowMapCamera.lookAt, this.lookAt);
        }
    }
    update() {
        this.updateMatrices();
        if (!this.shadowMap)
            return;
        this.shadowMapCamera.fov = (2 * Math.min(this.maxCameraAngle, this.angle)) * 180 / Math.PI;
        this.shadowMapCamera.updateProjectionMatrix();
        this.shadowMapCamera.position[0] = this.worldMatrix[12];
        this.shadowMapCamera.position[1] = this.worldMatrix[13];
        this.shadowMapCamera.position[2] = this.worldMatrix[14];
        this.shadowMapCamera.rotation[0] = this.rotation[0];
        this.shadowMapCamera.rotation[1] = this.rotation[1];
        this.shadowMapCamera.rotation[2] = this.rotation[2];
        if (this.lookAt) {
            this.shadowMapCamera.lookAt = this.shadowMapCamera.lookAt || create$5();
            set$5(this.shadowMapCamera.lookAt, this.lookAt[0], this.lookAt[1], this.lookAt[2]);
        }
        this.shadowMapCamera.update();
        this.hasUpdatedOnce = true;
    }
}
__decorate([
    property({ type: 'string', category: 'Light' })
], Light.prototype, "type", void 0);
__decorate([
    property({ type: 'string', category: 'Light' })
], Light.prototype, "mode", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 100, step: 0.05 })
], Light.prototype, "size", void 0);
__decorate([
    property({ type: 'color', category: 'Light' })
], Light.prototype, "color", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 100, step: 0.05 })
], Light.prototype, "intensity", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 1000, step: 0.05 })
], Light.prototype, "distance", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 10, step: 0.05 })
], Light.prototype, "decay", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: Math.PI / 2, step: 0.01 })
], Light.prototype, "angle", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 10, step: 0.05 })
], Light.prototype, "exponent", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: 10, step: 0.05 })
], Light.prototype, "penumbra", void 0);
__decorate([
    property({ type: 'boolean', category: 'Light' })
], Light.prototype, "castShadow", void 0);
__decorate([
    property({ type: 'boolean', category: 'Light' })
], Light.prototype, "shadowMap", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 1, max: 8192, step: 1 })
], Light.prototype, "shadowMapResolution", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, step: 0.1 })
], Light.prototype, "width", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, step: 0.1 })
], Light.prototype, "height", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, step: 0.1 })
], Light.prototype, "near", void 0);
__decorate([
    property({ type: 'boolean', category: 'Light' })
], Light.prototype, "useTemperature", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: -1, max: 40000, step: 100 })
], Light.prototype, "temperature", void 0);
__decorate([
    property({ type: 'number', category: 'Light', min: 0, max: Math.PI / 2, step: 0.01 })
], Light.prototype, "maxCameraAngle", void 0);
__decorate([
    property({
        category: 'Light', type: "select",
        choices: [
            { name: "sharp", label: "Sharp" },
            { name: "linear", label: "Linear" },
            { name: "pcf", label: "PCF" },
            { name: "pcss", label: "PCSS" },
        ]
    })
], Light.prototype, "shadowMode", void 0);

class AmbientLight extends Light {
    constructor(options = {}) {
        options.type = 'AmbientLight';
        options = Object.assign({}, {
            color: [1, 1, 1],
            intensity: 1,
            temperature: -1,
            useTemperature: false,
        }, options);
        super(options);
        this.__is_light__ = true;
        this.type = options.type;
        this.color = options.color;
        this.intensity = options.intensity;
        this.useTemperature = options.useTemperature;
        this.temperature = options.temperature;
    }
}

class SpotLight extends Light {
    constructor(options = {}) {
        options.type = 'SpotLight';
        super(options);
    }
}

class RectLight extends Light {
    constructor(options = {}) {
        options.type = 'RectLight';
        super(options);
    }
}

class DirectionalLight extends Light {
    constructor(options = {}) {
        options.type = 'DirectionalLight';
        super(options);
    }
}

class PointLight extends Light {
    constructor(options = {}) {
        options.type = 'PointLight';
        super(options);
    }
}

class Scene extends Container {
    constructor(options = {}) {
        super();
        this.defines = {};
        this.lights = [];
        this.ambientLights = [];
        this.reflectors = [];
        // this.overrideMaterial = null; 
        this.overrides = {};
        this.uniforms = {};
        this.inverseViewProjectionMatrix = create$6();
        this.lightInvVPMatrix = create$6();
        this.viewProjectionwMatrix = create$6();
        this.cameraDirection = create$5();
        this.cameraPosition = create$5();
        this.lastViewProjectionMatrix = create$6();
        this.lastInvViewProjectionMatrix = create$6();
        this.autoUpdateCameraUniforms = options.autoUpdateCameraUniforms ? options.autoUpdateCameraUniforms : false;
        this._listeners = {};
    }
    on(type, fn) {
        (this._listeners[type] ||= new Set()).add(fn);
        return () => this.off(type, fn);
    }
    off(type, fn) {
        this._listeners[type]?.delete(fn);
    }
    emit(type, data) {
        this._listeners[type]?.forEach(fn => fn(data));
    }
    markHierarchyDirty(reason, object) {
        this.emit('hierarchy:changed', { reason, object });
    }
    add(obj) {
        super.add(obj);
        this.markHierarchyDirty('added', obj);
        return this;
    }
    remove(obj) {
        super.remove(obj);
        this.markHierarchyDirty('removed', obj);
        return this;
    }
    updateLights() {
        this.lights = [];
        this.ambientLights = [];
        this.traverse(obj => {
            if (obj instanceof AmbientLight ||
                obj instanceof RectLight ||
                obj instanceof SpotLight ||
                obj instanceof DirectionalLight ||
                obj instanceof PointLight) {
                this.lights.push(obj);
            }
            if (obj instanceof AmbientLight ||
                obj instanceof RectLight ||
                obj instanceof SpotLight ||
                obj instanceof DirectionalLight ||
                obj instanceof PointLight) {
                this.ambientLights.push(obj);
            }
        });
        this.ambientLights = this.lights.filter(l => l instanceof AmbientLight);
        this.rectLights = this.lights.filter(l => l instanceof RectLight);
        this.spotLights = this.lights.filter(l => l instanceof SpotLight);
        this.directionalLights = this.lights.filter(l => l instanceof DirectionalLight);
        this.pointLights = this.lights.filter(l => l instanceof PointLight);
    }
    updateCameraUniforms(camera) {
        set$5(this.cameraPosition, camera.worldMatrix[12], camera.worldMatrix[13], camera.worldMatrix[14]);
        if (camera.lookAt) {
            copy$5(this.cameraDirection, camera.lookAt);
            subtract$4(this.cameraDirection, this.cameraDirection, this.cameraPosition);
            normalize$3(this.cameraDirection, this.cameraDirection);
        }
        else if (camera.forwardVector) {
            copy$5(this.cameraDirection, camera.forwardVector);
        }
        copy$6(this.viewProjectionwMatrix, camera.projectionMatrix);
        multiply$6(this.viewProjectionwMatrix, this.viewProjectionwMatrix, camera.inverseWorldMatrix);
        invert$3(this.inverseViewProjectionMatrix, this.viewProjectionwMatrix);
        this.uniforms.uInverseViewProjectionMatrix = this.inverseViewProjectionMatrix;
        this.uniforms.uProjViewMatrix = this.viewProjectionwMatrix;
        this.uniforms.uCameraPosition = this.cameraPosition;
        this.uniforms.uEyePosition = this.cameraPosition;
        this.uniforms.uEyeDirection = this.cameraDirection;
        this.uniforms.uInverseViewMatrix = this.uniforms.uInverseViewMatrix || create$6();
        this.uniforms.uViewMatrix = camera.inverseWorldMatrix;
        this.uniforms.uProjectionMatrix = camera.projectionMatrix;
        this.uniforms.uInverseProjectionMatrix = this.uniforms.uInverseProjectionMatrix || create$6();
        copy$6(this.uniforms.uInverseViewMatrix, camera.inverseWorldMatrix);
        invert$3(this.uniforms.uInverseViewMatrix, this.uniforms.uInverseViewMatrix);
        invert$3(this.uniforms.uInverseProjectionMatrix, camera.projectionMatrix);
        this.uniforms.uCameraNear = camera.near;
        this.uniforms.uCameraFar = camera.far;
    }
    render(camera) {
        this.updateLights();
        // We need to tell the scene thatw e want to update global camera uniforms using given camera
        // TODO: should really the scene mange this ?...
        // TODO2: use different scene for buffer scene render so we use the correct camera
        if (this.autoUpdateCameraUniforms && camera) {
            this.updateCameraUniforms(camera);
        }
        super.render(camera, this);
    }
}

class Renderer {
    constructor(options) {
        options = Object.assign({}, {
            alpha: false,
            depth: true,
            stencil: true,
            antialias: false,
            premultipliedAlpha: true,
            preserveDrawingBuffer: false,
            failIfMajorPerformanceCaveat: false,
            backend: 'webgl2',
            canvas: null,
        }, options || {});
        this.canvas = options?.canvas || document.createElement('canvas');
        this._pixelRatio = options.devicePixelRatio || 1;
        this._width = 0;
        this._height = 0;
        this._clearColor = { r: 0, g: 0, b: 0, a: 1 };
        this.device = GraphicsDevice.Create(this.canvas, options);
        this.device.init();
        this.gl = this.device.gl;
    }
    setPixelRatio(ratio) {
        this._pixelRatio = ratio;
        this.resize(this._width, this._height);
    }
    render(container, camera, frameBuffer, options = {}) {
        beginPass();
        this.device?.beginPass(frameBuffer, options);
        // calls updateMatrices recursively and let each chidlren decide if they need to update their matrices
        container?.updateMatrices();
        container?.render(camera);
        this.device?.endPass(frameBuffer);
    }
    resize(width, height) {
        this._width = width;
        this._height = height;
        const w = Math.floor(width * this._pixelRatio);
        const h = Math.floor(height * this._pixelRatio);
        this.w = w;
        this.h = h;
        this.canvas.width = w;
        this.canvas.height = h;
        this.device?.resize(w, h);
    }
    clearColor(r, g, b, alpha) {
        this.device?.clearColor(r, g, b, alpha);
    }
    clear(color, depth, stencil) {
        this.device?.clear(color, depth, stencil);
    }
}

class CubeTexture {
    constructor(gl, options) {
        options = Object.assign({}, {
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE,
            width: 1,
            height: 1,
            linear: true,
            mipmap: false,
            miplinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            urls: null
        }, options);
        this._uid = generateUUID(); //debug purpose
        this.gl = gl;
        this.width = options.width;
        this.height = options.height;
        this.format = options.format;
        this.type = options.type;
        var floatTextures = gl.getExtension('OES_texture_float');
        gl.getExtension('OES_texture_float_linear');
        if (!floatTextures) {
            throw ('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support');
        }
        this._texture = this.gl.createTexture();
        MemoryManager.trackTexture(this._texture);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this._texture);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width * this.height * 4)));
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
        // /**
        //  * add getter and setter to update texture_wrap when this.wrap changes
        //  */
        // Object.defineProperty(this, 'wrapS', {
        //   set: (value) => {
        //     this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture);
        //     this.gl.texParameteri( this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_S, value );
        //   }
        // });
        // Object.defineProperty(this, 'wrapT', {
        //   set: (value) => {
        //     this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture);
        //     this.gl.texParameteri( this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_T, value );
        //   }
        // });
        // //nPOT texture can't repeat
        // this.wrapS = options.wrapS;
        // this.wrapT = options.wrapT;
        //nPOT texture cannot mipmap
        // this.setFilter( options.linear, options.mipmap, options.mipmapLinear );
        if (options.urls !== null) {
            this.load(options.urls);
        }
    }
    load(urls) {
        var faces = [
            this.gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            this.gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            this.gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            this.gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            this.gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            this.gl.TEXTURE_CUBE_MAP_NEGATIVE_Z
        ];
        for (let i = 0; i < urls.length; i++) {
            let face = faces[i];
            let image = new Image();
            image.onload = () => {
                image.onload = null;
                // this.bindFaceImage(face, image);
                this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
                this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
                this.gl.texImage2D(face, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, image);
                this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
                this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
                this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
                this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
            };
            image.src = urls[i];
        }
    }
    bindFaceImage(face, image) {
        this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
        if (image._texture) {
            this.gl.texImage2D(face, 0, this.format, image.width, image.height, 0, this.format, this.type, image._texture);
        }
        else {
            this.gl.texImage2D(face, 0, this.format, image.width, image.height, 0, this.format, this.type, image);
        }
    }
    bindFaceFrameBuffer(face, frameBuffer) {
        this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, frameBuffer.fbo);
        this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, face, this._texture, 0);
        let status_code = this.gl.checkFramebufferStatus(this.gl.FRAMEBUFFER);
        if (status_code != this.gl.FRAMEBUFFER_COMPLETE) {
            if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT) {
                console.warn('GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT');
            }
            if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS) {
                console.warn('FRAMEBUFFER_INCOMPLETE_DIMENSIONS: Not all attached images have the same width and height.');
            }
            if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT) {
                console.warn('FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: No images are attached to the framebuffer.');
            }
        }
        // this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, null );
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
        frameBuffer.unbind();
    }
    bind(unit) {
        if (unit !== undefined) {
            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        }
        this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
    }
    delete() {
        this.gl.deleteTexture(this._texture);
        MemoryManager.untrackTexture(this._texture);
        this._texture = null;
        this.gl = null;
    }
}

// adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
function parse(buffer) {
    var RGBE_RETURN_FAILURE = -1, 
    /* default error routine.  change this to change error handling */
    rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function (rgbe_error_code, msg) {
        switch (rgbe_error_code) {
            case rgbe_read_error:
                console.error("RGBELoader Read Error: " + (msg || ''));
                break;
            case rgbe_write_error:
                console.error("RGBELoader Write Error: " + (msg || ''));
                break;
            case rgbe_format_error:
                console.error("RGBELoader Bad File Format: " + (msg || ''));
                break;
            default:
            case rgbe_memory_error: console.error("RGBELoader: Error: " + (msg || ''));
        }
        return RGBE_RETURN_FAILURE;
    }, 
    /* flags indicating which fields in an rgbe_header_info are valid */
    RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function (buffer, lineLimit, consume) {
        lineLimit = !lineLimit ? 1024 : lineLimit;
        var p = buffer.pos, i = -1, len = 0, s = '', chunkSize = 128, chunk = String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
        while ((0 > (i = chunk.indexOf(NEWLINE))) && (len < lineLimit) && (p < buffer.byteLength)) {
            s += chunk;
            len += chunk.length;
            p += chunkSize;
            chunk += String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
        }
        if (-1 < i) {
            /*for (i=l-1; i>=0; i--) {
                byteCode = m.charCodeAt(i);
                if (byteCode > 0x7f && byteCode <= 0x7ff) byteLen++;
                else if (byteCode > 0x7ff && byteCode <= 0xffff) byteLen += 2;
                if (byteCode >= 0xDC00 && byteCode <= 0xDFFF) i--; //trail surrogate
            }*/
            if (false !== consume)
                buffer.pos += len + i + 1;
            return s + chunk.slice(0, i);
        }
        return false;
    }, 
    /* minimal header reading.  modify if you want to parse more information */
    RGBE_ReadHeader = function (buffer) {
        var line, match, 
        // regexes to parse header info fields
        magic_token_re = /^#\?(\S+)$/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, 
        // RGBE format header struct
        header = {
            valid: 0,
            string: '',
            comments: '',
            programtype: 'RGBE',
            format: '',
            gamma: 1.0,
            exposure: 1.0,
            width: 0, height: 0 /* image dimensions, width/height */
        };
        if (buffer.pos >= buffer.byteLength || !(line = fgets(buffer))) {
            return rgbe_error(rgbe_read_error, "no header found");
        }
        /* if you want to require the magic token then uncomment the next line */
        if (!(match = line.match(magic_token_re))) {
            return rgbe_error(rgbe_format_error, "bad initial token");
        }
        header.valid |= RGBE_VALID_PROGRAMTYPE;
        header.programtype = match[1];
        header.string += line + "\n";
        while (true) {
            line = fgets(buffer);
            if (false === line)
                break;
            header.string += line + "\n";
            if ('#' === line.charAt(0)) {
                header.comments += line + "\n";
                continue; // comment line
            }
            if (match = line.match(gamma_re)) {
                header.gamma = parseFloat(match[1], 10);
            }
            if (match = line.match(exposure_re)) {
                header.exposure = parseFloat(match[1], 10);
            }
            if (match = line.match(format_re)) {
                header.valid |= RGBE_VALID_FORMAT;
                header.format = match[1]; //'32-bit_rle_rgbe';
            }
            if (match = line.match(dimensions_re)) {
                header.valid |= RGBE_VALID_DIMENSIONS;
                header.height = parseInt(match[1], 10);
                header.width = parseInt(match[2], 10);
            }
            if ((header.valid & RGBE_VALID_FORMAT) && (header.valid & RGBE_VALID_DIMENSIONS))
                break;
        }
        if (!(header.valid & RGBE_VALID_FORMAT)) {
            return rgbe_error(rgbe_format_error, "missing format specifier");
        }
        if (!(header.valid & RGBE_VALID_DIMENSIONS)) {
            return rgbe_error(rgbe_format_error, "missing image size specifier");
        }
        return header;
    }, RGBE_ReadPixels_RLE = function (buffer, w, h) {
        var data_rgba, offset, pos, count, byteValue, scanline_buffer, ptr, ptr_end, i, l, off, isEncodedRun, scanline_width = w, num_scanlines = h, rgbeStart;
        if (
        // run length encoding is not allowed so read flat
        ((scanline_width < 8) || (scanline_width > 0x7fff)) ||
            // this file is not run length encoded
            ((2 !== buffer[0]) || (2 !== buffer[1]) || (buffer[2] & 0x80))) {
            // return the flat buffer
            return new Uint8Array(buffer);
        }
        if (scanline_width !== ((buffer[2] << 8) | buffer[3])) {
            return rgbe_error(rgbe_format_error, "wrong scanline width");
        }
        data_rgba = new Uint8Array(4 * w * h);
        if (!data_rgba || !data_rgba.length) {
            return rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
        }
        offset = 0;
        pos = 0;
        ptr_end = 4 * scanline_width;
        rgbeStart = new Uint8Array(4);
        scanline_buffer = new Uint8Array(ptr_end);
        // read in each successive scanline
        while ((num_scanlines > 0) && (pos < buffer.byteLength)) {
            if (pos + 4 > buffer.byteLength) {
                return rgbe_error(rgbe_read_error);
            }
            rgbeStart[0] = buffer[pos++];
            rgbeStart[1] = buffer[pos++];
            rgbeStart[2] = buffer[pos++];
            rgbeStart[3] = buffer[pos++];
            if ((2 != rgbeStart[0]) || (2 != rgbeStart[1]) || (((rgbeStart[2] << 8) | rgbeStart[3]) != scanline_width)) {
                return rgbe_error(rgbe_format_error, "bad rgbe scanline format");
            }
            // read each of the four channels for the scanline into the buffer
            // first red, then green, then blue, then exponent
            ptr = 0;
            while ((ptr < ptr_end) && (pos < buffer.byteLength)) {
                count = buffer[pos++];
                isEncodedRun = count > 128;
                if (isEncodedRun)
                    count -= 128;
                if ((0 === count) || (ptr + count > ptr_end)) {
                    return rgbe_error(rgbe_format_error, "bad scanline data");
                }
                if (isEncodedRun) {
                    // a (encoded) run of the same value
                    byteValue = buffer[pos++];
                    for (i = 0; i < count; i++) {
                        scanline_buffer[ptr++] = byteValue;
                    }
                    //ptr += count;
                }
                else {
                    // a literal-run
                    scanline_buffer.set(buffer.subarray(pos, pos + count), ptr);
                    ptr += count;
                    pos += count;
                }
            }
            // now convert data from buffer into rgba
            // first red, then green, then blue, then exponent (alpha)
            l = scanline_width; //scanline_buffer.byteLength;
            for (i = 0; i < l; i++) {
                off = 0;
                data_rgba[offset] = scanline_buffer[i + off];
                off += scanline_width; //1;
                data_rgba[offset + 1] = scanline_buffer[i + off];
                off += scanline_width; //1;
                data_rgba[offset + 2] = scanline_buffer[i + off];
                off += scanline_width; //1;
                data_rgba[offset + 3] = scanline_buffer[i + off];
                offset += 4;
            }
            num_scanlines--;
        }
        return data_rgba;
    };
    var byteArray = new Uint8Array(buffer); byteArray.byteLength;
    byteArray.pos = 0;
    var rgbe_header_info = RGBE_ReadHeader(byteArray);
    if (RGBE_RETURN_FAILURE !== rgbe_header_info) {
        var w = rgbe_header_info.width, h = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h);
        if (RGBE_RETURN_FAILURE !== image_rgba_data) {
            return {
                width: w,
                height: h,
                data: image_rgba_data,
                header: rgbe_header_info.string,
                gamma: rgbe_header_info.gamma,
                exposure: rgbe_header_info.exposure,
                format: 'RGBA',
                type: 'UnsignedByteType'
            };
        }
    }
    return null;
}

function BinaryLoad() {
    // this is just a helper class to ease BinaryLoad calls
    var _this = this;
    this.xmlhttp = new XMLHttpRequest();
    this.get = function (url, callback) {
        _this.xmlhttp.onreadystatechange = function () {
            if (_this.xmlhttp.readyState === 4) {
                callback(_this.xmlhttp.response, _this.xmlhttp.status);
            }
        };
        _this.xmlhttp.open('GET', url, true);
        _this.xmlhttp.responseType = 'arraybuffer';
        _this.xmlhttp.send();
    };
}
function flipYRGBA(data, width, height) {
    const rowSize = width * 4;
    const temp = new Uint8Array(rowSize);
    for (let y = 0; y < Math.floor(height / 2); y++) {
        const top = y * rowSize;
        const bottom = (height - y - 1) * rowSize;
        temp.set(data.subarray(top, top + rowSize));
        data.copyWithin(top, bottom, bottom + rowSize);
        data.set(temp, bottom);
    }
    return data;
}
function RGBEByteToLinearRGBAFloat(source, sourceOffset, dest, destOffset) {
    const e = source[sourceOffset + 3];
    if (e > 0) {
        const scale = Math.pow(2.0, e - 128.0) / 255.0;
        dest[destOffset + 0] = source[sourceOffset + 0] * scale;
        dest[destOffset + 1] = source[sourceOffset + 1] * scale;
        dest[destOffset + 2] = source[sourceOffset + 2] * scale;
        dest[destOffset + 3] = 1.0;
    }
    else {
        dest[destOffset + 0] = 0.0;
        dest[destOffset + 1] = 0.0;
        dest[destOffset + 2] = 0.0;
        dest[destOffset + 3] = 1.0;
    }
}
class HDRTexture {
    constructor(gl, options) {
        options = Object.assign({}, {
            format: gl.RGBA,
            // type:   gl.UNSIGNED_BYTE,
            type: gl.FLOAT,
            width: 1,
            height: 1,
            linear: false,
            mipmap: false,
            miplinear: false,
            wrapS: gl.CLAMP_TO_EDGE,
            wrapT: gl.CLAMP_TO_EDGE,
            url: null,
            onReady: () => { }
        }, options);
        this.options = options;
        this._uid = generateUUID(); //debug purpose
        this.gl = gl;
        this.width = options.width;
        this.height = options.height;
        this.format = options.format;
        this.type = options.type;
        this.linear = options.linear;
        if (this.type == gl.FLOAT) {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_float_linear');
            //   if (!floatTextures){//} || (window.innerWidth < 768)) {
            //       // console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
            //       this.type = "HALF_FLOAT"
            //   }
        }
        if (this.type == "HALF_FLOAT") {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_half_float_linear');
            //   if (!halfFloatTexturesExt) {
            //     console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
            //     this.type = gl.UNSIGNED_BYTE;
            //   }
            //   else {
            //     this.type = halfFloatTexturesExt.HALF_FLOAT_OES;
            //     this.isHalfFloat = true;
            //   }
        }
        this._texture = this.gl.createTexture();
        MemoryManager.trackTexture(this._texture);
        gl.bindTexture(gl.TEXTURE_2D, this._texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter(!!this.linear, false, false));
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, getFilter(!!this.linear, false, false));
        // gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.width, this.height, 0, this.format, this.gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA16F, this.width, this.height, 0, gl.RGBA, gl.FLOAT, new Float32Array([0, 0, 0, 1]));
        gl.bindTexture(gl.TEXTURE_2D, null);
        if (this.options.url) {
            this.load(this.options.url);
        }
    }
    load(url) {
        new BinaryLoad().get(url, (data, status) => {
            if (status === 200) {
                // // var arrBuffer = toArrayBuffer(data);
                // var texData = RGBEParser(data); 
                // // if ( this.options.type === this.gl.FLOAT ) {
                // //   var numElements = ( texData.data.length / 4 ) * 3;
                // //   var floatdata = new Float32Array( numElements );
                // //   for ( var j = 0; j < numElements; j ++ ) {
                // //     RGBEByteToRGBFloat( texData.data, j * 4, floatdata, j * 3 );
                // //   }
                // //   texData.data = floatdata;
                // // } else if ( this.options.type === this.gl.HALF_FLOAT ) {
                // //   var numElements = ( texData.data.length / 4 ) * 3;
                // //   var halfdata = new Uint16Array( numElements );
                // //   for ( var j = 0; j < numElements; j ++ ) {
                // //     RGBEByteToRGBHalf( texData.data, j * 4, halfdata, j * 3 );
                // //   }
                // //   texData.data = halfdata;
                // // }
                // this.gl.bindTexture( this.gl.TEXTURE_2D, this._texture);
                // this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
                // this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
                // this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, getFilter( !!this.linear, false, false ) );
                // this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, getFilter( !!this.linear, false, false ) );
                // this.width  = texData.width
                // this.height = texData.height
                // this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.options.format, texData.width, texData.height, 0, this.options.format,  (this.options.type), texData.data);
                var texData = parse(data);
                // Flip texture vertically 
                flipYRGBA(texData.data, texData.width, texData.height);
                const numPixels = texData.width * texData.height;
                const linearData = new Float32Array(numPixels * 4);
                for (let i = 0; i < numPixels; i++) {
                    RGBEByteToLinearRGBAFloat(texData.data, i * 4, linearData, i * 4);
                }
                this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
                this.width = texData.width;
                this.height = texData.height;
                this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, texData.width, texData.height, 0, this.gl.RGBA, this.gl.FLOAT, linearData);
                this.gl.bindTexture(this.gl.TEXTURE_2D, null);
                this.options.onReady();
            }
            else {
                console.error('An error has occurred and the HDR "' + url + '" could not be downloaded.');
            }
        });
    }
    bind(unit) {
        if (!this.gl) {
            return;
        }
        //unit is sent by the Program and defined by the unfirom order in the shaders; 
        if (unit !== void 0) {
            this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
        }
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
    }
    delete() {
        if (this.gl) {
            this.gl.deleteTexture(this._texture);
            MemoryManager.untrackTexture(this._texture);
        }
        this._texture = null;
        this.gl = null;
    }
}

class Helper extends Container {
    update(options = {}) {
    }
}

class InstancedArrayBuffer extends ArrayBuffer$2 {
    constructor(gl, data, size, element, type, name) {
        super(gl, data, size, element, type, name);
        this.instanced = true;
    }
}

function getVertexKey(vertex) {
    return `${Math.floor(vertex[0] * 10000) / 10000},${Math.floor(vertex[1] * 10000) / 10000},${Math.floor(vertex[2] * 10000) / 10000}`;
}
class GeometryBuffer {
    constructor(gl, size) {
        if (!gl) {
            return;
        }
        this.gl = gl;
        this.attributes = {};
        this.length = size || 0;
        this.groups = []; // different materials
        // this.vertices = [];
        // this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
        // this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
        // this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
        // this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
    }
    setAttribute(attribName, data, size, stepMode = 'vertex') {
        if (attribName === 'index') {
            this.setIndices(data, size);
            return;
        }
        if (!this.attributes[attribName]) {
            this.addAttribute(attribName, data, size);
        }
        else {
            this.attributes[attribName].update(data, size);
        }
    }
    setIndices(array) {
        if (!(array instanceof Uint16Array || array instanceof Uint32Array)) {
            throw new Error(`[GeometryBuffer] array passed to 'setIndices()' must be of Uint16Array or Uint32Array type`);
        }
        this.indexBuffer = new ArrayBuffer$2(this.gl, array, 1, true);
        this.attributes['index'] = this.indexBuffer;
    }
    addAttribute(attribName, data, size) {
        if (attribName === 'index') {
            this.setIndices(data, size);
            return;
        }
        this.attributes[attribName] = new ArrayBuffer$2(this.gl, data, size, false, undefined, attribName);
    }
    addInstancedAttribute(attribName, data, size) {
        this.attributes[attribName] = new InstancedArrayBuffer(this.gl, data, size, false, undefined, attribName);
    }
    getBoundingBox() {
        if (!this.boudingBox) {
            this.computeBoudingBox();
        }
        return this.boudingBox;
    }
    // Legacy support for old typo in function name
    computeBoudingBox(origin) {
        return this.computeBoundingBox(origin);
    }
    computeBoundingBox(origin) {
        if (!this.attributes.position) {
            return;
        }
        let min = fromValues$5(Infinity, Infinity, Infinity);
        let max = fromValues$5(-Infinity, -Infinity, -Infinity);
        let positions = this.attributes.position.data;
        for (let i = 0; i < positions.length; i += 3) {
            min[0] = Math.min(min[0], positions[i + 0]);
            min[1] = Math.min(min[1], positions[i + 1]);
            min[2] = Math.min(min[2], positions[i + 2]);
            max[0] = Math.max(max[0], positions[i + 0]);
            max[1] = Math.max(max[1], positions[i + 1]);
            max[2] = Math.max(max[2], positions[i + 2]);
        }
        let boundingBoxCenter = create$5();
        boundingBoxCenter[0] = min[0] + (max[0] + min[0] * -1) * .5;
        boundingBoxCenter[1] = min[1] + (max[1] + min[1] * -1) * .5;
        boundingBoxCenter[2] = min[2] + (max[2] + min[2] * -1) * .5;
        let boudingBoxWidth = Math.abs(max[0] - boundingBoxCenter[0]) * 2;
        let boudingBoxHeight = Math.abs(max[1] - boundingBoxCenter[1]) * 2;
        let boudingBoxDepth = Math.abs(max[2] - boundingBoxCenter[2]) * 2;
        this.boundingBox = {
            center: boundingBoxCenter,
            width: boudingBoxWidth,
            height: boudingBoxHeight,
            depth: boudingBoxDepth,
            min: [min[0], min[1], min[2]],
            max: [max[0], max[1], max[2]],
            aabb: [
                min[0], min[1], min[2],
                max[0], max[1], max[2]
            ]
        };
        // Legacy: old bug used thie wrong synatx for 'boundingBox'
        this.boudingBox = this.boundingBox;
    }
    computeBoundingSphere() {
        if (!this.attributes.position) {
            return;
        }
        let minX = 100000;
        let minY = 100000;
        let minZ = 100000;
        let maxX = -100000;
        let maxY = -100000;
        let maxZ = -100000;
        let positions = this.attributes.position.data;
        for (let i = 0; i < positions.length; i += 3) {
            if (positions[i + 0] < minX)
                minX = positions[i + 0];
            if (positions[i + 0] > maxX)
                maxX = positions[i + 0];
            if (positions[i + 1] < minY)
                minY = positions[i + 1];
            if (positions[i + 1] > maxY)
                maxY = positions[i + 1];
            if (positions[i + 2] < minZ)
                minZ = positions[i + 2];
            if (positions[i + 2] > maxZ)
                maxZ = positions[i + 2];
        }
        let boundingSphereCenter = create$5();
        boundingSphereCenter[0] = minX + (maxX + minX * -1) * .5;
        boundingSphereCenter[1] = minY + (maxY + minY * -1) * .5;
        boundingSphereCenter[2] = minZ + (maxZ + minZ * -1) * .5;
        let boundingSphereRadius = 0;
        let p = create$5();
        for (let i = 0; i < positions.length; i += 3) {
            set$5(p, positions[i + 0], positions[i + 1], positions[i + 2]);
            subtract$4(p, p, boundingSphereCenter);
            boundingSphereRadius = Math.max(boundingSphereRadius, (length$3(p)));
        }
        this.boundingSphere = {
            center: boundingSphereCenter,
            radius: boundingSphereRadius,
        };
    }
    getBoundingSphere() {
        if (!this.boundingSphere) {
            this.computeBoundingSphere();
        }
        return this.boundingSphere;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    computeVertexNormals() {
        if (!this.attributes.position) {
            // console.warn('cannot compute vertex normals: missing `position` attribute on the geometry')
            return;
        }
        const positions = this.attributes.position.data;
        const verticesTriangles = new Map();
        let triIndex = 0;
        for (let i = 0; i < positions.length; i += 9) {
            const a = [positions[i + 0], positions[i + 1], positions[i + 2]];
            const b = [positions[i + 3], positions[i + 4], positions[i + 5]];
            const c = [positions[i + 6], positions[i + 7], positions[i + 8]];
            const aKey = getVertexKey(a);
            const bKey = getVertexKey(b);
            const cKey = getVertexKey(c);
            if (!verticesTriangles.has(aKey)) {
                verticesTriangles.set(aKey, new Set());
            }
            if (!verticesTriangles.has(bKey)) {
                verticesTriangles.set(bKey, new Set());
            }
            if (!verticesTriangles.has(cKey)) {
                verticesTriangles.set(cKey, new Set());
            }
            verticesTriangles.get(aKey).add(triIndex);
            verticesTriangles.get(bKey).add(triIndex);
            verticesTriangles.get(cKey).add(triIndex);
            triIndex++;
        }
        const verticesNormals = new Map();
        for (const [key, v1] of verticesTriangles) {
            const triIndices = Array.from(v1);
            const connectedNormals = [];
            for (let i = 0; i < triIndices.length; i++) {
                const triangleIndex = triIndices[i];
                let pA = [
                    positions[triangleIndex * 9 + 0],
                    positions[triangleIndex * 9 + 1],
                    positions[triangleIndex * 9 + 2]
                ];
                let pB = [
                    positions[triangleIndex * 9 + 3],
                    positions[triangleIndex * 9 + 4],
                    positions[triangleIndex * 9 + 5]
                ];
                let pC = [
                    positions[triangleIndex * 9 + 6],
                    positions[triangleIndex * 9 + 7],
                    positions[triangleIndex * 9 + 8]
                ];
                let cb = create$5();
                let ab = create$5();
                subtract$4(cb, pC, pB);
                subtract$4(ab, pA, pB);
                cross$1(cb, cb, ab);
                normalize$3(cb, cb);
                connectedNormals.push(cb);
            }
            let avNormal = [0, 0, 0];
            for (let j = 0; j < connectedNormals.length; j++) {
                avNormal[0] += connectedNormals[j][0];
                avNormal[1] += connectedNormals[j][1];
                avNormal[2] += connectedNormals[j][2];
            }
            if (connectedNormals.length > 0) {
                avNormal[0] /= connectedNormals.length;
                avNormal[1] /= connectedNormals.length;
                avNormal[2] /= connectedNormals.length;
            }
            let nA = create$5();
            copy$5(nA, avNormal);
            normalize$3(nA, nA);
            verticesNormals.set(key, nA);
        }
        const normals = [];
        for (let i = 0; i < positions.length; i += 3) {
            const v = [
                positions[i + 0],
                positions[i + 1],
                positions[i + 2]
            ];
            const vKey = getVertexKey(v);
            const normalSet = verticesNormals.get(vKey);
            const n = Array.from(normalSet);
            normals.push(n[0], n[1], n[2]);
        }
        if (this.attributes['normal']) {
            this.attributes['normal'].update(new Float32Array(this.attributes.position.data.length), 3);
        }
        else {
            this.addAttribute('normal', new Float32Array(this.attributes.position.data.length), 3);
        }
    }
    computeVertexNormals2() {
        if (!this.attributes.position) {
            return;
        }
        this.attributes.position.data;
        if (this.attributes['normal']) {
            this.attributes['normal'].update(new Float32Array(this.attributes.position.data.length), 3);
        }
        else {
            this.addAttribute('normal', new Float32Array(this.attributes.position.data.length), 3);
        }
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
}

class SphereGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 0.);
        options = Object.assign({}, {
            radius: 50,
            widthSegments: 8,
            heightSegments: 6,
            phiStart: 0,
            phiLength: Math.PI * 2,
            thetaStart: 0,
            thetaLength: Math.PI
        }, options);
        if (!gl) {
            console.warn('missing gl');
            return;
        }
        var radius = options.radius || 50;
        var widthSegments = Math.max(3, Math.floor(options.widthSegments) || 8);
        var heightSegments = Math.max(2, Math.floor(options.heightSegments) || 6);
        var phiStart = phiStart !== undefined ? options.phiStart : 0;
        var phiLength = phiLength !== undefined ? options.phiLength : Math.PI * 2;
        var thetaStart = thetaStart !== undefined ? options.thetaStart : 0;
        var thetaLength = thetaLength !== undefined ? options.thetaLength : Math.PI;
        var thetaEnd = thetaStart + thetaLength;
        var ix, iy;
        var index = 0;
        var grid = [];
        var vertex = create$5();
        var normal = create$5();
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        var colors = [];
        // generate vertices, normals and uvs
        for (iy = 0; iy <= heightSegments; iy++) {
            var verticesRow = [];
            var v = iy / heightSegments;
            for (ix = 0; ix <= widthSegments; ix++) {
                var u = ix / widthSegments;
                vertex[0] = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex[1] = radius * Math.cos(thetaStart + v * thetaLength);
                vertex[2] = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex[0], vertex[1], vertex[2]);
                set$5(normal, vertex[0], vertex[1], vertex[2]);
                normalize$3(normal, normal);
                normals.push(normal[0], normal[1], normal[2]);
                uvs.push(u, 1 - v);
                verticesRow.push(index++);
                colors.push(1, 1, 1);
            }
            grid.push(verticesRow);
        }
        // indices
        for (iy = 0; iy < heightSegments; iy++) {
            for (ix = 0; ix < widthSegments; ix++) {
                var a = grid[iy][ix + 1];
                var b = grid[iy][ix];
                var c = grid[iy + 1][ix];
                var d = grid[iy + 1][ix + 1];
                if (iy !== 0 || thetaStart > 0)
                    indices.push(a, b, d);
                if (iy !== heightSegments - 1 || thetaEnd < Math.PI)
                    indices.push(b, c, d);
            }
        }
        // build geometry
        this.length = vertices.length / 3;
        this.addAttribute('index', new Uint16Array(indices), 1);
        this.addAttribute('position', new Float32Array(vertices), 3);
        this.addAttribute('normal', new Float32Array(normals), 3);
        this.addAttribute('color', new Float32Array(colors), 3);
        this.addAttribute('uv', new Float32Array(uvs), 2, 'Sphere');
    }
}

class CylinderGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 0.);
        options = Object.assign({}, {
            radiusTop: 50,
            radiusBottom: 50,
            height: 100,
            radialSegments: 8,
            heightSegments: 1,
            openEnded: false,
            thetaStart: 0,
            thetaLength: Math.PI * 2
        }, options);
        if (!gl) {
            console.warn('missing gl');
            return;
        }
        var radiusTop = options.radiusTop, radiusBottom = options.radiusBottom, height = options.height, radialSegments = Math.max(3, Math.floor(options.radialSegments)), heightSegments = Math.max(1, Math.floor(options.heightSegments)), openEnded = options.openEnded, thetaStart = options.thetaStart, thetaLength = options.thetaLength;
        var index = 0, indexArray = [], vertices = [], normals = [], colors = [], uvs = [], indices = [];
        // Generate vertices, normals, and uvs
        for (var y = 0; y <= heightSegments; y++) {
            var verticesRow = [];
            var v = y / heightSegments;
            var radius = v * (radiusBottom - radiusTop) + radiusTop;
            for (var x = 0; x <= radialSegments; x++) {
                var u = x / radialSegments;
                var theta = thetaStart + u * thetaLength;
                var sinTheta = Math.sin(theta);
                var cosTheta = Math.cos(theta);
                var vertex = fromValues$5(radius * sinTheta, -v * height + height / 2, radius * cosTheta);
                var normal = fromValues$5(sinTheta, 0, cosTheta);
                normalize$3(normal, normal);
                vertices.push(vertex[0], vertex[1], vertex[2]);
                normals.push(normal[0], normal[1], normal[2]);
                colors.push(1, 1, 1);
                uvs.push(u, 1 - v);
                verticesRow.push(index++);
            }
            indexArray.push(verticesRow);
        }
        // Indices
        for (var i = 0; i < heightSegments; i++) {
            for (var j = 0; j < radialSegments; j++) {
                var a = indexArray[i][j];
                var b = indexArray[i + 1][j];
                var c = indexArray[i + 1][j + 1];
                var d = indexArray[i][j + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // Caps
        if (!openEnded) {
            // --- Top cap ---
            if (radiusTop > 0) {
                var centerIndexTop = index++;
                vertices.push(0, height / 2, 0);
                normals.push(0, 1, 0);
                colors.push(1, 1, 1);
                uvs.push(0.5, 0.5);
                for (var x = 0; x < radialSegments; x++) {
                    var i1 = indexArray[0][x];
                    var i2 = indexArray[0][x + 1];
                    indices.push(centerIndexTop, i1, i2); // triangle fan
                }
            }
            // --- Bottom cap ---
            if (radiusBottom > 0) {
                var centerIndexBottom = index++;
                vertices.push(0, -height / 2, 0);
                normals.push(0, -1, 0);
                colors.push(1, 1, 1);
                uvs.push(0.5, 0.5);
                var row = indexArray[heightSegments]; // bottom row
                for (var x = 0; x < radialSegments; x++) {
                    var i1 = row[x];
                    var i2 = row[x + 1];
                    indices.push(centerIndexBottom, i2, i1); // triangle fan
                }
            }
        }
        // Build geometry
        this.length = vertices.length / 3;
        this.setIndices(new Uint16Array(indices));
        this.setAttribute('position', new Float32Array(vertices), 3);
        this.setAttribute('normal', new Float32Array(normals), 3);
        this.setAttribute('color', new Float32Array(colors), 3);
        this.setAttribute('uv', new Float32Array(uvs), 2);
    }
}

class BoxGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 4.);
        options = Object.assign({}, {
            width: 1,
            height: 1,
            depth: 1,
            widthSegments: 1,
            heightSegments: 1,
            depthSegments: 1,
            skipDiagonals: false,
            useLightmapUVs: false,
            lightmapPadding: 0.01,
        }, options);
        // buffers
        var indices = [];
        var vertices = [];
        var normals = [];
        var uvs = [];
        var uv1s = [];
        var colors = [];
        var numberOfVertices = 0;
        var vertexCounter = 0;
        // function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY ) {
        // 	vertexCounter = 0;
        // 	var segmentWidth  = width / gridX;
        // 	var segmentHeight = height / gridY;
        // 	var widthHalf     = width / 2;
        // 	var heightHalf    = height / 2;
        // 	var depthHalf     = depth / 2;
        // 	var gridX1        = gridX + 1;
        // 	var gridY1        = gridY + 1;
        // 	var ix, iy;
        // 	var vector = vec3.create();
        // 	// generate vertices, normals and uvs
        // 	for ( iy = 0; iy < gridY1; iy ++ ) {
        // 		var y = iy * segmentHeight - heightHalf;
        // 		for ( ix = 0; ix < gridX1; ix ++ ) {
        // 			var x = ix * segmentWidth - widthHalf;
        // 			vector[ u ] = x * udir;
        // 			vector[ v ] = y * vdir;
        // 			vector[ w ] = depthHalf;
        // 			vertices.push( vector[0], vector[1], vector[2] );
        // 			vector[ u ] = 1.;
        // 			vector[ v ] = 1.;
        // 			vector[ w ] = 1.;
        // 			vector[ u ] = 0;
        // 			vector[ v ] = 0;
        // 			vector[ w ] = depth > 0 ? 1 : -1;
        // 			normals.push( vector[0], vector[1], vector[2] );
        // 			uvs.push( ix / gridX, 1 - ( iy / gridY ) );
        // 			colors.push( 1, 1, 1 );
        // 			vertexCounter += 1;
        // 		}
        // 	}
        // 	for ( iy = 0; iy < gridY; iy ++ ) {
        // 		for ( ix = 0; ix < gridX; ix ++ ) {
        // 			var a = numberOfVertices + ix + gridX1 * iy;
        // 			var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
        // 			var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
        // 			var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
        // 			if (options.skipDiagonals) {
        // 				// outer lines of faces only
        // 				indices.push(a, b);
        // 				indices.push(b, c);
        // 				indices.push(c, d);
        // 				indices.push(d, a);
        // 			}
        // 			else {
        // 				// faces
        // 				indices.push( a, b, d );
        // 				indices.push( b, c, d );
        // 			}
        // 		}
        // 	}
        // 	numberOfVertices += vertexCounter;
        // }
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, lightmapColumn, lightmapRow) {
            vertexCounter = 0;
            var segmentWidth = width / gridX;
            var segmentHeight = height / gridY;
            var widthHalf = width / 2;
            var heightHalf = height / 2;
            var depthHalf = depth / 2;
            var gridX1 = gridX + 1;
            var gridY1 = gridY + 1;
            var ix, iy;
            var vector = create$5();
            // Generate vertices, normals, uvs, and colors
            for (iy = 0; iy < gridY1; iy++) {
                var y = iy * segmentHeight - heightHalf;
                for (ix = 0; ix < gridX1; ix++) {
                    var x = ix * segmentWidth - widthHalf;
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    vertices.push(vector[0], vector[1], vector[2]);
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    normals.push(vector[0], vector[1], vector[2]);
                    var localU = ix / gridX;
                    var localV = 1 - (iy / gridY);
                    uvs.push(localU, localV);
                    if (options.useLightmapUVs) {
                        var atlasColumns = 3;
                        var atlasRows = 2;
                        var cellWidth = 1 / atlasColumns;
                        var cellHeight = 1 / atlasRows;
                        var padding = Math.max(0, Math.min(options.lightmapPadding, Math.min(cellWidth, cellHeight) * 0.5));
                        var lightmapMinU = lightmapColumn * cellWidth + padding;
                        var lightmapMinV = lightmapRow * cellHeight + padding;
                        var lightmapWidth = cellWidth - padding * 2;
                        var lightmapHeight = cellHeight - padding * 2;
                        uv1s.push(lightmapMinU + localU * lightmapWidth, lightmapMinV + localV * lightmapHeight);
                    }
                    colors.push(1, 1, 1);
                    vertexCounter++;
                }
            }
            // Define edges for the perimeter of each face in a consistent order
            for (iy = 0; iy < gridY; iy++) {
                for (ix = 0; ix < gridX; ix++) {
                    var a = numberOfVertices + ix + gridX1 * iy;
                    var b = numberOfVertices + ix + gridX1 * (iy + 1);
                    var c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                    var d = numberOfVertices + (ix + 1) + gridX1 * iy;
                    // // Add only perimeter edges explicitly
                    // indices.push(a, b); // Left edge
                    // indices.push(b, c); // Top edge
                    // indices.push(c, d); // Right edge
                    // indices.push(d, a); // Bottom edge
                    // // Optionally add diagonals if skipDiagonals is false
                    // if (!options.skipDiagonals) {
                    // 	indices.push(a, c); // First diagonal
                    // 	indices.push(b, d); // Second diagonal
                    // }
                    if (options.skipDiagonals) {
                        indices.push(a, b);
                        indices.push(b, c);
                        indices.push(c, d);
                        indices.push(d, a);
                    }
                    else {
                        indices.push(a, b, d);
                        indices.push(b, c, d);
                    }
                }
            }
            numberOfVertices += vertexCounter;
        }
        buildPlane(2, 1, 0, -1, -1, options.depth, options.height, options.width, Math.floor(options.depthSegments), Math.floor(options.heightSegments), 0, 0); // Front face
        buildPlane(2, 1, 0, 1, -1, options.depth, options.height, -options.width, Math.floor(options.depthSegments), Math.floor(options.heightSegments), 1, 0); // Back face
        buildPlane(0, 2, 1, 1, 1, options.width, options.depth, options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments), 2, 0); // Top face
        buildPlane(0, 2, 1, 1, -1, options.width, options.depth, -options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments), 0, 1); // Bottom face
        buildPlane(0, 1, 2, 1, -1, options.width, options.height, options.depth, Math.floor(options.widthSegments), Math.floor(options.heightSegments), 1, 1); // Right face
        buildPlane(0, 1, 2, -1, -1, options.width, options.height, -options.depth, Math.floor(options.widthSegments), Math.floor(options.heightSegments), 2, 1); // Left face
        // build geometry
        this.length = numberOfVertices;
        this.addAttribute('index', new Uint16Array(indices), 1);
        this.addAttribute('position', new Float32Array(vertices), 3);
        this.addAttribute('normal', new Float32Array(normals), 3);
        this.addAttribute('uv', new Float32Array(uvs), 2);
        this.addAttribute('color', new Float32Array(colors), 3);
        if (options.useLightmapUVs) {
            this.addAttribute('uv1', new Float32Array(uv1s), 2);
        }
        this.indices = indices;
        this.vertices = vertices;
        this.normals = normals;
        this.uvs = uvs;
        this.colors = colors;
        if (options.useLightmapUVs) {
            this.uv1s = uv1s;
        }
        this.computeBoudingBox();
    }
}

class SpotLightHelper extends Helper {
    constructor(gl, light) {
        super();
        this.gl = gl;
        this.light = light;
        this.selected = false;
        {
            const iconMesh = new Mesh();
            iconMesh.id = 'RectLightIconMesh';
            iconMesh.name = 'icon';
            iconMesh.geometry = new BoxGeometryBuffer(gl, {
                width: 1,
                height: 1,
                depth: 0.01,
            });
            iconMesh.material = new UIMaterial(gl, {
                depthTest: true,
                uniforms: {
                    uAlpha: 1,
                    uColor: [1, 1, 0],
                    useDepthTest: true,
                }
            });
            iconMesh.__is_ui__ = true;
            iconMesh.doubleSided = true;
            iconMesh.visible = true;
            iconMesh.clickTarget = light;
            this.add(iconMesh);
            this.iconMesh = iconMesh;
        }
        {
            const radiusBottom = Math.tan(light.angle) * light.distance;
            const geometry = new CylinderGeometryBuffer(this.gl, {
                radiusTop: 0,
                radiusBottom,
                height: light.distance,
                skipDiagonals: true,
                radialSegments: 32,
            });
            const helper = new Mesh();
            helper.geometry = geometry;
            helper.material = new UIMaterial(this.gl, {
                depthTest: false,
                wireframe: true,
                uniforms: {
                    uAlpha: 1,
                    uColor: [0, 1, 1],
                    useDepthTest: 1,
                }
            });
            helper.geometry = geometry;
            helper.position = [0, 0, light.distance / -2];
            helper.rotation = [Math.PI / 2, 0, 0];
            helper.static = false;
            helper.__is_ui__ = true;
            helper.doubleSided = true;
            helper.visible = false;
            helper.name = 'SpotLightHelper_Cylinder';
            helper.clickTarget = light;
            this.outlineMesh = helper;
            this.add(helper);
        }
    }
    setSelected(selected) {
        this.selected = selected;
        if (this.outlineMesh) {
            if (this.selected) {
                this.outlineMesh.visible = true;
            }
            else {
                this.outlineMesh.visible = false;
            }
        }
    }
    updateHelperScreenScale(camera) {
        if (!camera) {
            return;
        }
        const c = [
            camera.worldMatrix[12],
            camera.worldMatrix[13],
            camera.worldMatrix[14]
        ];
        const w = [
            this.iconMesh.worldMatrix[12],
            this.iconMesh.worldMatrix[13],
            this.iconMesh.worldMatrix[14]
        ];
        const s = distance$2(c, w) * 0.03;
        if (Math.abs((this.iconMesh._helperScale || 1) - s) > 0.00001) {
            this.iconMesh._helperScale = s;
            set$5(this.iconMesh.scale, s, s, s);
            this.iconMesh.updateMatrices();
        }
    }
    updateIconBillboard(camera) {
        const m = this.iconMesh.worldMatrix;
        const c = camera.worldMatrix;
        const s = this.iconMesh._helperScale || 1;
        m[0] = c[0] * s;
        m[1] = c[1] * s;
        m[2] = c[2] * s;
        m[4] = c[4] * s;
        m[5] = c[5] * s;
        m[6] = c[6] * s;
        m[8] = c[8] * s;
        m[9] = c[9] * s;
        m[10] = c[10] * s;
    }
    update(options = {}) {
        if (options.camera) {
            this.updateHelperScreenScale(options.camera);
            this.updateIconBillboard(options.camera);
        }
    }
}

class DirectionalLightHelper extends Helper {
    constructor(gl, light) {
        super();
        this.gl = gl;
        this.selected = false;
        const lightHelper = new Mesh();
        lightHelper.geometry = new BoxGeometryBuffer(this.gl, { width: 1, height: 1, depth: 1 });
        for (let i = 0; i < lightHelper.geometry.attributes.position.data.length / 3; i++) {
            lightHelper.geometry.attributes.position.data[i * 3 + 2] -= 0.5;
        }
        lightHelper.geometry.attributes.position.update(lightHelper.geometry.attributes.position.data, 3);
        lightHelper.material = new UIMaterial(this.gl, {
            depthTest: false,
            wireframe: true,
            uniforms: {
                uAlpha: 1,
                uColor: [0, 1, 1],
            }
        });
        lightHelper.scale[0] = Math.abs(light.shadowMapCamera.left - light.shadowMapCamera.right);
        lightHelper.scale[1] = Math.abs(light.shadowMapCamera.top - light.shadowMapCamera.bottom);
        lightHelper.scale[2] = (light.shadowMapCamera.far - light.shadowMapCamera.near);
        lightHelper.position = light.position || [0, 0, 0];
        lightHelper.rotation = light.rotation || [0, 0, 0];
        lightHelper.lookAt = light.lookAt || null;
        lightHelper.doubleSided = true;
        lightHelper.__is_ui__ = true;
        lightHelper.doubleSided = true;
        lightHelper.visible = true;
        lightHelper.__ui_visible__ = true;
        lightHelper.clickTarget = light;
    }
    setSelected(selected) {
        this.selected = selected;
    }
}

class RectLightHelper extends Helper {
    constructor(gl, light) {
        super();
        this.gl = gl;
        this.selected = false;
        const outlineMesh = new Mesh();
        outlineMesh.id = 'RectLightOutlineMesh';
        outlineMesh.name = 'icon';
        outlineMesh.geometry = new BoxGeometryBuffer(this.gl, {
            skipDiagonals: true,
            width: 1,
            height: 1,
            heightSegments: 1,
            widthSegments: 1,
        });
        outlineMesh.material = new UIMaterial(this.gl, {
            depthTest: false,
            wireframe: true,
            uniforms: {
                uAlpha: 1,
                uColor: [1, 1, 0],
                useDepthTest: 1,
            }
        });
        outlineMesh.scale = [light.width, light.height, 1];
        outlineMesh.__is_ui__ = true;
        outlineMesh.doubleSided = true;
        outlineMesh.visible = false;
        this.add(outlineMesh);
        this.outlineMesh = outlineMesh;
        // const iconTexture = Texture.fromUrl(gl, iconBase64);
        const iconMesh = new Mesh();
        iconMesh.id = 'RectLightIconMesh';
        iconMesh.name = 'icon';
        iconMesh.geometry = new BoxGeometryBuffer(gl, {
            width: 1,
            height: 1,
            depth: 0.01,
        });
        iconMesh.material = new UIMaterial(gl, {
            depthTest: true,
            uniforms: {
                uAlpha: 1,
                uColor: [1, 1, 0],
                // useMap: iconTexture,
                useDepthTest: true,
            }
        });
        iconMesh.__is_ui__ = true;
        iconMesh.doubleSided = true;
        iconMesh.visible = true;
        iconMesh.clickTarget = light;
        this.add(iconMesh);
        this.iconMesh = iconMesh;
    }
    setSelected(selected) {
        this.selected = selected;
        if (this.outlineMesh) {
            if (this.selected) {
                this.outlineMesh.visible = true;
            }
            else {
                this.outlineMesh.visible = false;
            }
        }
    }
    updateHelperScreenScale(camera) {
        if (!camera) {
            return;
        }
        const c = [
            camera.worldMatrix[12],
            camera.worldMatrix[13],
            camera.worldMatrix[14]
        ];
        const w = [
            this.iconMesh.worldMatrix[12],
            this.iconMesh.worldMatrix[13],
            this.iconMesh.worldMatrix[14]
        ];
        const s = distance$2(c, w) * 0.03;
        if (Math.abs((this.iconMesh._helperScale || 1) - s) > 0.00001) {
            this.iconMesh._helperScale = s;
            set$5(this.iconMesh.scale, s, s, s);
            this.iconMesh.updateMatrices();
        }
    }
    updateIconBillboard(camera) {
        const m = this.iconMesh.worldMatrix;
        const c = camera.worldMatrix;
        const s = this.iconMesh._helperScale || 1;
        m[0] = c[0] * s;
        m[1] = c[1] * s;
        m[2] = c[2] * s;
        m[4] = c[4] * s;
        m[5] = c[5] * s;
        m[6] = c[6] * s;
        m[8] = c[8] * s;
        m[9] = c[9] * s;
        m[10] = c[10] * s;
    }
    update(options = {}) {
        if (options.camera) {
            this.updateHelperScreenScale(options.camera);
            this.updateIconBillboard(options.camera);
        }
    }
}

class PointLightHelper extends Helper {
    constructor(gl, light) {
        super();
        this.gl = gl;
        this.light = light;
        this.selected = false;
        {
            const iconMesh = new Mesh();
            iconMesh.id = 'PointLightHelper_Icon';
            iconMesh.name = 'icon';
            iconMesh.geometry = new BoxGeometryBuffer(gl, {
                width: 1,
                height: 1,
                depth: 0.01,
            });
            iconMesh.material = new UIMaterial(gl, {
                depthTest: true,
                uniforms: {
                    uAlpha: 1,
                    uColor: [1, 1, 0],
                    useDepthTest: true,
                }
            });
            iconMesh.__is_ui__ = true;
            iconMesh.doubleSided = true;
            iconMesh.visible = true;
            iconMesh.clickTarget = light;
            this.add(iconMesh);
            this.iconMesh = iconMesh;
        }
        {
            Math.tan(light.angle) * light.distance;
            const geometry = new SphereGeometryBuffer(this.gl, {
                radius: 1,
            });
            const helper = new Mesh();
            helper.geometry = geometry;
            helper.material = new UIMaterial(this.gl, {
                depthTest: false,
                wireframe: true,
                uniforms: {
                    uAlpha: 1,
                    uColor: [0, 1, 1],
                    useDepthTest: true,
                }
            });
            helper.geometry = geometry;
            helper.position = [0, 0, 0];
            helper.scale = [light.distance, light.distance, light.distance];
            helper.static = false;
            helper.__is_ui__ = true;
            helper.doubleSided = true;
            helper.visible = false;
            helper.name = 'PointLightHelper_Radius';
            helper.clickTarget = light;
            this.cylinderHelper = helper;
            this.add(helper);
        }
    }
    setSelected(selected) {
        this.selected = selected;
        if (this.outlineMesh) {
            if (this.selected) {
                this.outlineMesh.visible = true;
            }
            else {
                this.outlineMesh.visible = false;
            }
        }
    }
    updateHelperScreenScale(camera) {
        if (!camera) {
            return;
        }
        const c = [
            camera.worldMatrix[12],
            camera.worldMatrix[13],
            camera.worldMatrix[14]
        ];
        const w = [
            this.iconMesh.worldMatrix[12],
            this.iconMesh.worldMatrix[13],
            this.iconMesh.worldMatrix[14]
        ];
        const s = distance$2(c, w) * 0.03;
        if (Math.abs((this.iconMesh._helperScale || 1) - s) > 0.00001) {
            this.iconMesh._helperScale = s;
            set$5(this.iconMesh.scale, s, s, s);
            this.iconMesh.updateMatrices();
        }
    }
    updateIconBillboard(camera) {
        const m = this.iconMesh.worldMatrix;
        const c = camera.worldMatrix;
        const s = this.iconMesh._helperScale || 1;
        m[0] = c[0] * s;
        m[1] = c[1] * s;
        m[2] = c[2] * s;
        m[4] = c[4] * s;
        m[5] = c[5] * s;
        m[6] = c[6] * s;
        m[8] = c[8] * s;
        m[9] = c[9] * s;
        m[10] = c[10] * s;
    }
    update(options = {}) {
        if (options.camera) {
            this.updateHelperScreenScale(options.camera);
            this.updateIconBillboard(options.camera);
        }
    }
}

class PlaneGeometryBuffer$1 extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 4.);
        options = Object.assign({}, {
            width: 1000,
            height: 1000,
            widthSegments: 1,
            heightSegments: 1,
            debug: false,
        }, options);
        if (!gl) {
            return;
        }
        this.width = options.width;
        this.height = options.height;
        this.widthSegments = options.widthSegments;
        this.heightSegments = options.heightSegments;
        this._build();
        this.addAttribute('index', new Uint16Array(this.indices), 1);
        this.addAttribute('position', new Float32Array(this.vertices), 3);
        this.addAttribute('normal', new Float32Array(this.normals), 3);
        this.addAttribute('uv', new Float32Array(this.uvs), 2);
        this.addAttribute('color', new Float32Array(this.colors), 3);
    }
    update() {
        this._build();
        this.attributes['index'].update(new Uint16Array(this.indices), 1);
        this.attributes['position'].update(new Float32Array(this.vertices), 3);
        this.attributes['normal'].update(new Float32Array(this.normals), 3);
        this.attributes['uv'].update(new Float32Array(this.uvs), 2);
        this.attributes['color'].update(new Float32Array(this.colors), 3);
        this.computeBoudingBox();
    }
    _build() {
        // buffers
        this.indices = [];
        this.vertices = [];
        this.normals = [];
        this.uvs = [];
        this.colors = [];
        var width_half = this.width * 0.5;
        var height_half = this.height * 0.5;
        var gridX = this.widthSegments >> 0;
        var gridY = this.heightSegments >> 0;
        var gridX1 = gridX + 1;
        var gridY1 = gridY + 1;
        var segment_width = this.width / gridX;
        var segment_height = this.height / gridY;
        var ix, iy;
        // generate vertices, normals and uvs
        for (iy = 0; iy < gridY1; iy++) {
            var y = iy * segment_height - height_half;
            for (ix = 0; ix < gridX1; ix++) {
                var x = ix * segment_width - width_half;
                this.vertices.push(x, -y, 0);
                this.normals.push(0, 0, 1);
                this.uvs.push(ix / gridX, 1 - (iy / gridY));
                this.colors.push(1, 1, 1);
            }
        }
        // indices
        for (iy = 0; iy < gridY; iy++) {
            for (ix = 0; ix < gridX; ix++) {
                var a = ix + gridX1 * iy;
                var b = ix + gridX1 * (iy + 1);
                var c = (ix + 1) + gridX1 * (iy + 1);
                var d = (ix + 1) + gridX1 * iy;
                // faces
                this.indices.push(a, b, d);
                this.indices.push(b, c, d);
            }
        }
        this.length = this.vertices.length / 3;
    }
}

function hexToRgb(hex) {
    var c;
    c = hex.substring(1).split('');
    if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return [((c >> 16) & 255) / 255, ((c >> 8) & 255) / 255, (c & 255) / 255];
}

function nestedEach(obj, callback, lvl) {
    if (!obj)
        return;
    lvl = lvl || 0;
    callback(obj, lvl);
    obj.visible && obj.children && obj.children.forEach((child) => {
        nestedEach(child, callback, lvl + 1);
    });
}

class TransformHelper extends Container {
    constructor(gl) {
        super();
        this.gl = gl;
        this.id = 'UIObjectTransformer';
        this.name = 'UIObjectTransformer';
        this.visible = true;
        this.static = false;
        const sphereGeometry = new SphereGeometryBuffer(this.gl, {
            radius: 1,
            heightSegments: 10,
            widthSegments: 10,
        });
        const squareGeometry = new PlaneGeometryBuffer$1(this.gl, {
            width: 1,
            height: 1,
        });
        const coneGeometry = new CylinderGeometryBuffer(this.gl, {
            radiusTop: 0,
            radiusBottom: 0.5,
            height: 2,
            radialSegments: 10,
            heightSegments: 1,
            openEnded: true,
        });
        const barGeometry = new CylinderGeometryBuffer(this.gl, {
            radiusTop: 0.1,
            radiusBottom: 0.1,
            height: 10,
            radialSegments: 10,
            heightSegments: 1,
            openEnded: true,
        });
        const material = new UIMaterial(this.gl, {
            depthTest: false,
            uniforms: {
                uAlpha: 1,
                uColor: [1, 1, 1],
            }
        });
        new UIMaterial(this.gl, {
            depthTest: false,
            wireframe: true,
            uniforms: {
                uAlpha: 1,
                uColor: [1, 1, 1],
            }
        });
        this.controlsHelper = new Container();
        const meshes = [
            // center(all directions)
            { name: 'center', transform: 'translate', axis: [1, 0, 0], axisName: 'XYZ', color: hexToRgb('#ffffff'), alpha: 0.5, position: [0, 0, 0], scale: [0.1, 0.1, 0.1], rotation: [0, 0, 0], geo: sphereGeometry },
            // cones
            { name: 'positive-x-cone', transform: 'translate', axis: [1, 0, 0], axisName: 'X', color: hexToRgb('#f32f42'), alpha: 1.0, position: [1, 0, 0], scale: [0.1, 0.1, 0.1], rotation: [0, 0, Math.PI / -2], geo: coneGeometry },
            { name: 'positive-y-cone', transform: 'translate', axis: [0, 1, 0], axisName: 'Y', color: hexToRgb('#a4e428'), alpha: 1.0, position: [0, 1, 0], scale: [0.1, 0.1, 0.1], rotation: [0, 0, 0], geo: coneGeometry },
            { name: 'positive-z-cone', transform: 'translate', axis: [0, 0, 1], axisName: 'Z', color: hexToRgb('#3c8eea'), alpha: 1.0, position: [0, 0, 1], scale: [0.1, 0.1, 0.1], rotation: [Math.PI / 2, 0, 0], geo: coneGeometry },
            // bars
            { name: 'positive-x-bar', transform: 'translate', axis: [1, 0, 0], axisName: 'X', color: hexToRgb('#f32f42'), alpha: 1.0, position: [0.5, 0, 0], scale: [0.1, 0.1, 0.1], rotation: [0, 0, Math.PI / -2], geo: barGeometry },
            { name: 'positive-y-bar', transform: 'translate', axis: [0, 1, 0], axisName: 'Y', color: hexToRgb('#a4e428'), alpha: 1.0, position: [0, 0.5, 0], scale: [0.1, 0.1, 0.1], rotation: [0, 0, 0], geo: barGeometry },
            { name: 'positive-z-bar', transform: 'translate', axis: [0, 0, 1], axisName: 'Z', color: hexToRgb('#3c8eea'), alpha: 1.0, position: [0, 0, 0.5], scale: [0.1, 0.1, 0.1], rotation: [Math.PI / 2, 0, 0], geo: barGeometry },
            // spheres
            { name: 'negative-x', transform: 'translate', axis: [1, 0, 0], axisName: 'X', color: hexToRgb('#f32f42'), alpha: 0.25, position: [-1, 0, 0], scale: [0.05, 0.05, 0.05], rotation: [0, 0, 0], geo: sphereGeometry },
            { name: 'negative-y', transform: 'translate', axis: [0, 1, 0], axisName: 'Y', color: hexToRgb('#a4e428'), alpha: 0.25, position: [0, -1, 0], scale: [0.05, 0.05, 0.05], rotation: [0, 0, 0], geo: sphereGeometry },
            { name: 'negative-z', transform: 'translate', axis: [0, 0, 1], axisName: 'Z', color: hexToRgb('#3c8eea'), alpha: 0.25, position: [0, 0, -1], scale: [0.05, 0.05, 0.05], rotation: [0, 0, 0], geo: sphereGeometry },
            // squares
            { name: 'positive-xy', transform: 'translate', axis: [1, 1, 0], axisName: 'XY', color: hexToRgb('#3c8eea'), alpha: 0.5, position: [0.2 / 2, 0.2 / 2, 0], scale: [0.2, 0.2, 0.2], rotation: [0, 0, 0], geo: squareGeometry },
            { name: 'positive-yz', transform: 'translate', axis: [0, 1, 1], axisName: 'YZ', color: hexToRgb('#a4e428'), alpha: 0.5, position: [0, 0.2 / 2, 0.2 / 2], scale: [0.2, 0.2, 0.2], rotation: [0, Math.PI / 2, 0], geo: squareGeometry },
            { name: 'positive-xz', transform: 'translate', axis: [1, 0, 1], axisName: 'XZ', color: hexToRgb('#f32f42'), alpha: 0.5, position: [0.2 / 2, 0, 0.2 / 2], scale: [0.2, 0.2, 0.2], rotation: [Math.PI / 2, 0, 0], geo: squareGeometry },
        ];
        meshes.forEach(meshInfos => {
            let m = new Mesh();
            m.id = 'objectTransformHelper_' + meshInfos.name;
            m.name = 'objectTransformHelper_' + meshInfos.name;
            m.material = material;
            m.geometry = meshInfos.geo;
            m.uniforms.uColor = [meshInfos.color[0], meshInfos.color[1], meshInfos.color[2]];
            m.uniforms.uAlpha = meshInfos.alpha;
            m.static = false;
            m.__is_ui__ = true;
            m.__is_transform_helper__ = true;
            m.__transform_infos__ = meshInfos;
            m.doubleSided = true;
            copy$5(m.position, meshInfos.position);
            copy$5(m.rotation, meshInfos.rotation);
            copy$5(m.scale, meshInfos.scale);
            this.controlsHelper.add(m);
        });
        // this.AABBHelper          = new Mesh();
        // this.AABBHelper.id       = 'objectAABBHelper';
        // this.AABBHelper.name     = 'objectAABBHelper';
        // this.AABBHelper.material = wireframeMaterial
        // this.AABBHelper.geometry = new BoxGeometryBuffer(this.gl, { 
        //     width:  1,
        //     height: 1,
        //     depth:  1,
        //     skipDiagonals: true, // dont draw diagonals with wireframe(LINE_STRIPS)
        // });
        // this.AABBHelper.uniforms.uColor = [1,1,1];
        // this.AABBHelper.uniforms.uAlpha = 1;
        // this.AABBHelper.static          = false;
        // this.AABBHelper.__is_ui__       = true;
        // this.AABBHelper.doubleSided     = true;
        // this.AABBHelper.visible         = true;
        // this.AABBHelper.pointerEvents   = false;
        // this.add(this.AABBHelper);
        this.add(this.controlsHelper);
    }
    update(selectedObject, camera) {
        if (!selectedObject) {
            return;
        }
        let worldCenter;
        if (selectedObject.getBoundingBox) {
            // Get the WOLRD bouding box of the selected object
            let boundingBox = {
                min: [Infinity, Infinity, Infinity],
                max: [-Infinity, -Infinity, -Infinity],
            };
            boundingBox = selectedObject?.getBoundingBox();
            // custom bouding box from obj descendant primitives
            // boundingBox = getBoundingBox(selectedObject);
            worldCenter = [
                boundingBox.min[0] + (boundingBox.max[0] - boundingBox.min[0]) * 0.5,
                boundingBox.min[1] + (boundingBox.max[1] - boundingBox.min[1]) * 0.5,
                boundingBox.min[2] + (boundingBox.max[2] - boundingBox.min[2]) * 0.5
            ];
        }
        else {
            worldCenter = [
                selectedObject.worldMatrix[12],
                selectedObject.worldMatrix[13],
                selectedObject.worldMatrix[14]
            ];
        }
        // position the transform helper at the WORLD center of the selectedObject
        copy$5(this.position, worldCenter);
        this.updateMatrices();
        // Scale controls based on distance to camera to keep constant screen size
        const w = [this.worldMatrix[12], this.worldMatrix[13], this.worldMatrix[14]];
        const c = [camera.worldMatrix[12], camera.worldMatrix[13], camera.worldMatrix[14]];
        const s = distance$2(c, w) * 0.1;
        set$5(this.controlsHelper.scale, s, s, s);
        this.controlsHelper.updateMatrices();
        // scale the AABB helper(AABB here, not OBB)
        // vec3.copy(this.AABBHelper.scale, worldScale);
        // this.AABBHelper.updateMatrices();
        return;
    }
}

function setUniform(uniforms, u, value) {
    if (uniforms[u])
        uniforms[u].value = value;
}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
/**
 * 2x2 Matrix
 * @module mat2
 */
/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */
function create() {
    let out = new ARRAY_TYPE(4);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {mat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */
function clone(a) {
    let out = new ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */
function identity(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
/**
 * Create a new mat2 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out A new 2x2 matrix
 */
function fromValues(m00, m01, m10, m11) {
    let out = new ARRAY_TYPE(4);
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
/**
 * Set the components of a mat2 to the given values
 *
 * @param {mat2} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out
 */
function set(out, m00, m01, m10, m11) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function transpose(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache
    // some values
    if (out === a) {
        let a1 = a[1];
        out[1] = a[2];
        out[2] = a1;
    }
    else {
        out[0] = a[0];
        out[1] = a[2];
        out[2] = a[1];
        out[3] = a[3];
    }
    return out;
}
/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function invert(out, a) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    // Calculate the determinant
    let det = a0 * a3 - a2 * a1;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = a3 * det;
    out[1] = -a1 * det;
    out[2] = -a2 * det;
    out[3] = a0 * det;
    return out;
}
/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function adjoint(out, a) {
    // Caching this value is nessecary if out == a
    let a0 = a[0];
    out[0] = a[3];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a0;
    return out;
}
/**
 * Calculates the determinant of a mat2
 *
 * @param {mat2} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant(a) {
    return a[0] * a[3] - a[2] * a[1];
}
/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function multiply(out, a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    return out;
}
/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
function rotate(out, a, rad) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
}
/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/
function scale(out, a, v) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.rotate(dest, dest, rad);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
function fromRotation(out, rad) {
    let s = Math.sin(rad);
    let c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.scale(dest, dest, vec);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat2} out
 */
function fromScaling(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    return out;
}
/**
 * Returns a string representation of a mat2
 *
 * @param {mat2} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str(a) {
    return 'mat2(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}
/**
 * Returns Frobenius norm of a mat2
 *
 * @param {mat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob(a) {
    return (Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2)));
}
/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {mat2} L the lower triangular matrix
 * @param {mat2} D the diagonal matrix
 * @param {mat2} U the upper triangular matrix
 * @param {mat2} a the input matrix to factorize
 */
function LDU(L, D, U, a) {
    L[2] = a[2] / a[0];
    U[0] = a[0];
    U[1] = a[1];
    U[3] = a[3] - L[2] * U[1];
    return [L, D, U];
}
/**
 * Adds two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function add(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function subtract(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals(a, b) {
    let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
        Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
        Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
        Math.abs(a3 - b3) <= EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)));
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2} out
 */
function multiplyScalar(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
/**
 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2} out the receiving vector
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2} out
 */
function multiplyScalarAndAdd(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    return out;
}
/**
 * Alias for {@link mat2.multiply}
 * @function
 */
const mul = multiply;
/**
 * Alias for {@link mat2.subtract}
 * @function
 */
const sub = subtract;

var mat2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  create: create,
  clone: clone,
  copy: copy,
  identity: identity,
  fromValues: fromValues,
  set: set,
  transpose: transpose,
  invert: invert,
  adjoint: adjoint,
  determinant: determinant,
  multiply: multiply,
  rotate: rotate,
  scale: scale,
  fromRotation: fromRotation,
  fromScaling: fromScaling,
  str: str,
  frob: frob,
  LDU: LDU,
  add: add,
  subtract: subtract,
  exactEquals: exactEquals,
  equals: equals,
  multiplyScalar: multiplyScalar,
  multiplyScalarAndAdd: multiplyScalarAndAdd,
  mul: mul,
  sub: sub
});

class TriangleGeometryBuffer extends GeometryBuffer {
    constructor(gl) {
        super(gl, 3.);
        this.addAttribute('position', new Float32Array([
            -1.0, -1.0, 0.0,
            0.0, 1.0, 0.0,
            1.0, -1.0, 0.0
        ]), 3);
        this.addAttribute('uv', new Float32Array([
            0.0, 0.0,
            0.5, 1.0,
            1.0, 0.0,
        ]), 2, 'triangle');
        this.addAttribute('color', new Float32Array([
            1.0, 1.0, 1.0,
            1.0, 1.0, 1.0,
            1.0, 1.0, 1.0
        ]), 3);
    }
}

class PlaneGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 4.);
        options = Object.assign({}, {
            width: 1000,
            height: 1000,
            widthSegments: 1,
            heightSegments: 1,
            debug: false,
        }, options);
        if (!gl) {
            return;
        }
        this.width = options.width;
        this.height = options.height;
        this.widthSegments = options.widthSegments;
        this.heightSegments = options.heightSegments;
        this._build();
        this.addAttribute('index', new Uint16Array(this.indices), 1);
        this.addAttribute('position', new Float32Array(this.vertices), 3);
        this.addAttribute('normal', new Float32Array(this.normals), 3);
        this.addAttribute('uv', new Float32Array(this.uvs), 2);
        this.addAttribute('color', new Float32Array(this.colors), 3);
    }
    update() {
        this._build();
        this.attributes['index'].update(new Uint16Array(this.indices), 1);
        this.attributes['position'].update(new Float32Array(this.vertices), 3);
        this.attributes['normal'].update(new Float32Array(this.normals), 3);
        this.attributes['uv'].update(new Float32Array(this.uvs), 2);
        this.attributes['color'].update(new Float32Array(this.colors), 3);
        this.computeBoudingBox();
    }
    _build() {
        this.indices = [];
        this.vertices = [];
        this.normals = [];
        this.uvs = [];
        this.colors = [];
        const width_half = this.width * 0.5;
        const height_half = this.height * 0.5;
        const gridX = this.widthSegments >> 0;
        const gridY = this.heightSegments >> 0;
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = this.width / gridX;
        const segment_height = this.height / gridY;
        let ix, iy;
        // generate vertices, normals, uvs
        for (iy = 0; iy < gridY1; iy++) {
            const y = iy * segment_height - height_half;
            for (ix = 0; ix < gridX1; ix++) {
                const x = ix * segment_width - width_half;
                this.vertices.push(x, -y, 0);
                this.normals.push(0, 0, 1);
                this.uvs.push(ix / gridX, 1 - (iy / gridY));
                this.colors.push(1, 1, 1);
            }
        }
        // generate line indices for horizontal and vertical lines (no diagonals)
        for (iy = 0; iy < gridY1; iy++) {
            for (ix = 0; ix < gridX1; ix++) {
                const current = ix + gridX1 * iy;
                // horizontal line to the right
                if (ix < gridX) {
                    const right = (ix + 1) + gridX1 * iy;
                    this.indices.push(current, right);
                }
                // vertical line downwards
                if (iy < gridY) {
                    const below = ix + gridX1 * (iy + 1);
                    this.indices.push(current, below);
                }
            }
        }
        this.length = this.vertices.length / 3;
    }
}

class CircleGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 0.);
        if (!gl) {
            return;
        }
        options = Object.assign({}, {
            radius: 1,
            segments: 40,
            lineWidth: 1,
            thetaStart: 0,
            thetaLength: Math.PI * 2
        }, options);
        var radius = options.radius;
        var vertices = [];
        var normals = [];
        var uvs = [];
        var colors = [];
        var indices = [];
        var colors = [];
        var i, s;
        var vertex = create$5();
        var uv = create$1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        colors.push(1, 1, 1);
        uvs.push(0.5, 0.5);
        for (s = 0, i = 3; s <= options.segments; s++, i += 3) {
            var segment = Math.PI / -2 + options.thetaStart + s / options.segments * options.thetaLength;
            // vertex
            vertex[0] = radius * Math.cos(segment);
            vertex[1] = radius * Math.sin(segment);
            vertices.push(vertex[0], vertex[1], vertex[2]);
            // normal
            normals.push(0, 0, 1);
            //colors
            colors.push(1, 1, 1);
            // uvs
            uv[0] = (vertices[i] / radius + 1) / 2;
            uv[1] = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv[0], uv[1]);
        }
        // indices
        for (i = 1; i <= options.segments; i++) {
            indices.push(i, i + 1, 0);
        }
        // build geometry
        this.length = vertices.length / 3;
        this.addAttribute('index', new Uint16Array(indices), 1);
        this.addAttribute('position', new Float32Array(vertices), 3);
        this.addAttribute('normal', new Float32Array(normals), 3);
        this.addAttribute('color', new Float32Array(colors), 3);
        this.addAttribute('uv', new Float32Array(uvs), 2);
    }
}

/*
Copyright (c) 2013 Aaron Boman and aaronboman.com
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
var OBJ = {};
/**
 * The main Mesh class. The constructor will parse through the OBJ file data
 * and collect the vertex, vertex normal, texture, and face information. This
 * information can then be used later on when creating your VBOs. See
 * OBJ.initMeshBuffers for an example of how to use the newly created Mesh
 *
 * @class Mesh
 * @constructor
 *
 * @param {String} objectData a string representation of an OBJ file with newlines preserved.
 */
OBJ.Mesh = function (objectData) {
    /*
     The OBJ file format does a sort of compression when saving a model in a
     program like Blender. There are at least 3 sections (4 including textures)
     within the file. Each line in a section begins with the same string:
       * 'v': indicates vertex section
       * 'vn': indicates vertex normal section
       * 'f': indicates the faces section
       * 'vt': indicates vertex texture section (if textures were used on the model)
     Each of the above sections (except for the faces section) is a list/set of
     unique vertices.
  
     Each line of the faces section contains a list of
     (vertex, [texture], normal) groups
     Some examples:
         // the texture index is optional, both formats are possible for models
         // without a texture applied
         f 1/25 18/46 12/31
         f 1//25 18//46 12//31
  
         // A 3 vertex face with texture indices
         f 16/92/11 14/101/22 1/69/1
  
         // A 4 vertex face
         f 16/92/11 40/109/40 38/114/38 14/101/22
  
     The first two lines are examples of a 3 vertex face without a texture applied.
     The second is an example of a 3 vertex face with a texture applied.
     The third is an example of a 4 vertex face. Note: a face can contain N
     number of vertices.
  
     Each number that appears in one of the groups is a 1-based index
     corresponding to an item from the other sections (meaning that indexing
     starts at one and *not* zero).
  
     For example:
         `f 16/92/11` is saying to
           - take the 16th element from the [v] vertex array
           - take the 92nd element from the [vt] texture array
           - take the 11th element from the [vn] normal array
         and together they make a unique vertex.
     Using all 3+ unique Vertices from the face line will produce a polygon.
  
     Now, you could just go through the OBJ file and create a new vertex for
     each face line and WebGL will draw what appears to be the same model.
     However, vertices will be overlapped and duplicated all over the place.
  
     Consider a cube in 3D space centered about the origin and each side is
     2 units long. The front face (with the positive Z-axis pointing towards
     you) would have a Top Right vertex (looking orthogonal to its normal)
     mapped at (1,1,1) The right face would have a Top Left vertex (looking
     orthogonal to its normal) at (1,1,1) and the top face would have a Bottom
     Right vertex (looking orthogonal to its normal) at (1,1,1). Each face
     has a vertex at the same coordinates, however, three distinct vertices
     will be drawn at the same spot.
  
     To solve the issue of duplicate Vertices (the `(vertex, [texture], normal)`
     groups), while iterating through the face lines, when a group is encountered
     the whole group string ('16/92/11') is checked to see if it exists in the
     packed.hashindices object, and if it doesn't, the indices it specifies
     are used to look up each attribute in the corresponding attribute arrays
     already created. The values are then copied to the corresponding unpacked
     array (flattened to play nice with WebGL's ELEMENT_ARRAY_BUFFER indexing),
     the group string is added to the hashindices set and the current unpacked
     index is used as this hashindices value so that the group of elements can
     be reused. The unpacked index is incremented. If the group string already
     exists in the hashindices object, its corresponding value is the index of
     that group and is appended to the unpacked indices array.
     */
    var verts = [], vertNormals = [], textures = [], unpacked = {};
    // unpacking stuff
    unpacked.verts = [];
    unpacked.norms = [];
    unpacked.textures = [];
    unpacked.hashindices = {};
    unpacked.indices = [];
    unpacked.index = 0;
    // array of lines separated by the newline
    var lines = objectData.split('\n');
    var VERTEX_RE = /^v\s/;
    var NORMAL_RE = /^vn\s/;
    var TEXTURE_RE = /^vt\s/;
    var FACE_RE = /^f\s/;
    var WHITESPACE_RE = /\s+/;
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        var elements = line.split(WHITESPACE_RE);
        elements.shift();
        if (VERTEX_RE.test(line)) {
            // if this is a vertex
            verts.push.apply(verts, elements);
        }
        else if (NORMAL_RE.test(line)) {
            // if this is a vertex normal
            vertNormals.push.apply(vertNormals, elements);
        }
        else if (TEXTURE_RE.test(line)) {
            // if this is a texture
            textures.push.apply(textures, elements);
        }
        else if (FACE_RE.test(line)) {
            // if this is a face
            /*
            split this face into an array of vertex groups
            for example:
               f 16/92/11 14/101/22 1/69/1
            becomes:
              ['16/92/11', '14/101/22', '1/69/1'];
            */
            var quad = false;
            for (var j = 0, eleLen = elements.length; j < eleLen; j++) {
                // Triangulating quads
                // quad: 'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2 v3/t3/vn3/'
                // corresponding triangles:
                //      'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2'
                //      'f v2/t2/vn2 v3/t3/vn3 v0/t0/vn0'
                if (j === 3 && !quad) {
                    // add v2/t2/vn2 in again before continuing to 3
                    j = 2;
                    quad = true;
                }
                if (elements[j] in unpacked.hashindices) {
                    unpacked.indices.push(unpacked.hashindices[elements[j]]);
                }
                else {
                    //if no slah found in elemnt, it uses another syntax for faces:
                    if (!/\//.test(elements[j])) {
                        unpacked.indices.push(elements[j]);
                    }
                    else {
                        /*
                        Each element of the face line array is a vertex which has its
                        attributes delimited by a forward slash. This will separate
                        each attribute into another array:
                            '19/92/11'
                        becomes:
                            vertex = ['19', '92', '11'];
                        where
                            vertex[0] is the vertex index
                            vertex[1] is the texture index
                            vertex[2] is the normal index
                         Think of faces having Vertices which are comprised of the
                         attributes location (v), texture (vt), and normal (vn).
                         */
                        var vertex = elements[j].split('/');
                        /*
                         The verts, textures, and vertNormals arrays each contain a
                         flattend array of coordinates.
        
                         Because it gets confusing by referring to vertex and then
                         vertex (both are different in my descriptions) I will explain
                         what's going on using the vertexNormals array:
        
                         vertex[2] will contain the one-based index of the vertexNormals
                         section (vn). One is subtracted from this index number to play
                         nice with javascript's zero-based array indexing.
        
                         Because vertexNormal is a flattened array of x, y, z values,
                         simple pointer arithmetic is used to skip to the start of the
                         vertexNormal, then the offset is added to get the correct
                         component: +0 is x, +1 is y, +2 is z.
        
                         This same process is repeated for verts and textures.
                         */
                        // vertex position
                        unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 0]);
                        unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 1]);
                        unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 2]);
                        // vertex textures
                        if (textures.length) {
                            unpacked.textures.push(+textures[(vertex[1] - 1) * 2 + 0]);
                            unpacked.textures.push(+textures[(vertex[1] - 1) * 2 + 1]);
                        }
                        // vertex normals
                        unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 0]);
                        unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 1]);
                        unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 2]);
                        // add the newly created vertex to the list of indices
                        unpacked.hashindices[elements[j]] = unpacked.index;
                        unpacked.indices.push(unpacked.index);
                        // increment the counter
                        unpacked.index += 1;
                    }
                }
                if (j === 3 && quad) {
                    // add v0/t0/vn0 onto the second triangle
                    unpacked.indices.push(unpacked.hashindices[elements[0]]);
                }
            }
        }
    }
    this.vertices = unpacked.verts;
    this.vertexNormals = unpacked.norms;
    this.textures = unpacked.textures;
    this.indices = unpacked.indices;
};
var Ajax$1 = function () {
    // this is just a helper class to ease ajax calls
    var _this = this;
    this.xmlhttp = new XMLHttpRequest();
    this.get = function (url, callback) {
        _this.xmlhttp.onreadystatechange = function () {
            if (_this.xmlhttp.readyState === 4) {
                callback(_this.xmlhttp.responseText, _this.xmlhttp.status);
            }
        };
        _this.xmlhttp.open('GET', url, true);
        _this.xmlhttp.send();
    };
};
/**
 * Takes in an object of `mesh_name`, `'/url/to/OBJ/file'` pairs and a callback
 * function. Each OBJ file will be ajaxed in and automatically converted to
 * an OBJ.Mesh. When all files have successfully downloaded the callback
 * function provided will be called and passed in an object containing
 * the newly created meshes.
 *
 * **Note:** In order to use this function as a way to download meshes, a
 * webserver of some sort must be used.
 *
 * @param {Object} nameAndURLs an object where the key is the name of the mesh and the value is the url to that mesh's OBJ file
 *
 * @param {Function} completionCallback should contain a function that will take one parameter: an object array where the keys will be the unique object name and the value will be a Mesh object
 *
 * @param {Object} meshes In case other meshes are loaded separately or if a previously declared variable is desired to be used, pass in a (possibly empty) json object of the pattern: { '<mesh_name>': OBJ.Mesh }
 *
 */
OBJ.downloadMeshes = function (nameAndURLs, completionCallback, meshes) {
    // the total number of meshes. this is used to implement "blocking"
    var semaphore = Object.keys(nameAndURLs).length;
    // if error is true, an alert will given
    var error = false;
    // this is used to check if all meshes have been downloaded
    // if meshes is supplied, then it will be populated, otherwise
    // a new object is created. this will be passed into the completionCallback
    if (meshes === undefined)
        meshes = {};
    // loop over the mesh_name,url key,value pairs
    for (var mesh_name in nameAndURLs) {
        if (nameAndURLs.hasOwnProperty(mesh_name)) {
            new Ajax$1().get(nameAndURLs[mesh_name], (function (name) {
                return function (data, status) {
                    if (status === 200) {
                        meshes[name] = new OBJ.Mesh(data);
                    }
                    else {
                        error = true;
                        console.error('An error has occurred and the mesh "' +
                            nameAndURLs + '" could not be downloaded.');
                    }
                    // the request has finished, decrement the counter
                    semaphore--;
                    if (semaphore === 0) {
                        if (error) {
                            // if an error has occurred, the user is notified here and the
                            // callback is not called
                            console.error('An error has occurred and one or meshes has not been ' +
                                'downloaded. The execution of the script has terminated.');
                            throw '';
                        }
                        // there haven't been any errors in retrieving the meshes
                        // call the callback
                        completionCallback(meshes);
                    }
                };
            })(mesh_name));
        }
    }
};
var _buildBuffer = function (gl, type, data, itemSize) {
    var buffer = gl.createBuffer();
    var arrayView = type === gl.ARRAY_BUFFER ? Float32Array : Uint16Array;
    gl.bindBuffer(type, buffer);
    gl.bufferData(type, new arrayView(data), gl.STATIC_DRAW);
    buffer.itemSize = itemSize;
    buffer.numItems = data.length / itemSize;
    return buffer;
};
/**
 * Takes in the WebGL context and a Mesh, then creates and appends the buffers
 * to the mesh object as attributes.
 *
 * @param {WebGLRenderingContext} gl the `canvas.getContext('webgl')` context instance
 * @param {Mesh} mesh a single `OBJ.Mesh` instance
 *
 * The newly created mesh attributes are:
 *
 * Attrbute | Description
 * :--- | ---
 * **normalBuffer**       |contains the model&#39;s Vertex Normals
 * normalBuffer.itemSize  |set to 3 items
 * normalBuffer.numItems  |the total number of vertex normals
 * |
 * **textureBuffer**      |contains the model&#39;s Texture Coordinates
 * textureBuffer.itemSize |set to 2 items
 * textureBuffer.numItems |the number of texture coordinates
 * |
 * **vertexBuffer**       |contains the model&#39;s Vertex Position Coordinates (does not include w)
 * vertexBuffer.itemSize  |set to 3 items
 * vertexBuffer.numItems  |the total number of vertices
 * |
 * **indexBuffer**        |contains the indices of the faces
 * indexBuffer.itemSize   |is set to 1
 * indexBuffer.numItems   |the total number of indices
 *
 * A simple example (a lot of steps are missing, so don't copy and paste):
 *
 *     var gl   = canvas.getContext('webgl'),
 *         mesh = OBJ.Mesh(obj_file_data);
 *     // compile the shaders and create a shader program
 *     var shaderProgram = gl.createProgram();
 *     // compilation stuff here
 *     ...
 *     // make sure you have vertex, vertex normal, and texture coordinate
 *     // attributes located i  shaders and attach them to the shader program
 *     shaderProgram.vertexPositionAttribute = gl.getAttribLocation(shaderProgram, "aVertexPosition");
 *     gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);
 *
 *     shaderProgram.vertexNormalAttribute = gl.getAttribLocation(shaderProgram, "aVertexNormal");
 *     gl.enableVertexAttribArray(shaderProgram.vertexNormalAttribute);
 *
 *     shaderProgram.textureCoordAttribute = gl.getAttribLocation(shaderProgram, "aTextureCoord");
 *     gl.enableVertexAttribArray(shaderProgram.textureCoordAttribute);
 *
 *     // create and initialize the vertex, vertex normal, and texture coordinate buffers
 *     // and save on to the mesh object
 *     OBJ.initMeshBuffers(gl, mesh);
 *
 *     // now to render the mesh
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.vertexBuffer);
 *     gl.vertexAttribPointer(shaderProgram.vertexPositionAttribute, mesh.vertexBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.textureBuffer);
 *     gl.vertexAttribPointer(shaderProgram.textureCoordAttribute, mesh.textureBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.normalBuffer);
 *     gl.vertexAttribPointer(shaderProgram.vertexNormalAttribute, mesh.normalBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, model.mesh.indexBuffer);
 *     gl.drawElements(gl.TRIANGLES, model.mesh.indexBuffer.numItems, gl.UNSIGNED_SHORT, 0);
 */
OBJ.initMeshBuffers = function (gl, mesh) {
    mesh.normalBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.vertexNormals, 3);
    mesh.textureBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.textures, 2);
    mesh.vertexBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.vertices, 3);
    mesh.indexBuffer = _buildBuffer(gl, gl.ELEMENT_ARRAY_BUFFER, mesh.indices, 1);
};
OBJ.deleteMeshBuffers = function (gl, mesh) {
    gl.deleteBuffer(mesh.normalBuffer);
    gl.deleteBuffer(mesh.textureBuffer);
    gl.deleteBuffer(mesh.vertexBuffer);
    gl.deleteBuffer(mesh.indexBuffer);
};

class ObjGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 4.);
        this.gl = gl;
        options = Object.assign({}, {
            src: null,
            data: null,
            onLoaded: () => { }
        }, options);
        this.options = options;
        // buffers
        this.indices = [];
        this.vertices = [];
        this.normals = [];
        this.uvs = [];
        // build geometry
        this.length = 0;
        this.addAttribute('index', new Uint16Array(this.indices), 1);
        this.addAttribute('position', new Float32Array(this.vertices), 3);
        this.addAttribute('normal', new Float32Array(this.normals), 3);
        this.addAttribute('uv', new Float32Array(this.uvs), 2);
        this.onObjLoaded = this.onObjLoaded.bind(this);
        this.computeBoudingBox();
        if (options.lod) {
            OBJ.downloadMeshes(options.lod, this.onObjLoaded);
        }
        else if (options.data) {
            this.onObjLoaded([new OBJ.Mesh(options.data)]);
        }
        else {
            OBJ.downloadMeshes([options.src], this.onObjLoaded);
        }
    }
    onObjLoaded(meshes) {
        this.attributes = {};
        this.indices = meshes[0].indices;
        this.vertices = meshes[0].vertices;
        this.normals = meshes[0].vertexNormals;
        this.uvs = meshes[0].textures;
        let needsUvs, needsNormals;
        if (this.uvs.length == 0) {
            needsUvs = true;
        }
        if (this.normals.length == 0) {
            needsNormals = true;
        }
        for (let i = 0; i < this.vertices.length / 3; i++) {
            if (needsUvs) {
                this.uvs.push(0, 0);
            }
            if (needsNormals) {
                this.normals.push(0, 1, 0);
            }
        }
        this.attributes['index'] = new ArrayBuffer$2(this.gl, new Uint16Array(this.indices), 1, true);
        this.attributes['position'] = new ArrayBuffer$2(this.gl, new Float32Array(this.vertices), 3, false);
        this.attributes['normal'] = new ArrayBuffer$2(this.gl, new Float32Array(this.normals), 3, false);
        this.attributes['uv'] = new ArrayBuffer$2(this.gl, new Float32Array(this.uvs), 2, false);
        // this.computeBoundingSphere();
        this.computeBoudingBox('OBJ');
        this.options?.onLoaded();
    }
}

class Ajax {
    constructor() {
        this.xmlhttp = new XMLHttpRequest();
        this.get = (url, callback) => {
            this.xmlhttp.onreadystatechange = () => {
                if (this.xmlhttp.readyState === 4) {
                    callback(this.xmlhttp.responseText, this.xmlhttp.status);
                }
            };
            this.xmlhttp.open('GET', url, true);
            this.xmlhttp.send();
        };
    }
}
class JSONGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 4.);
        this.gl = gl;
        options = Object.assign({}, {
            src: null,
            onLoaded: () => { }
        }, options);
        this.options = options;
        // buffers
        this.indices = [];
        this.vertices = [];
        this.normals = [];
        this.uvs = [];
        // build geometry
        this.length = 0;
        this.addAttribute('index', new Uint16Array(this.indices), 1);
        this.addAttribute('position', new Float32Array(this.vertices), 3);
        this.addAttribute('normal', new Float32Array(this.normals), 3);
        this.addAttribute('uv', new Float32Array(this.uvs), 2);
        this.computeBoudingBox();
        new Ajax().get(options.src, (data, status) => {
            if (status !== 200) {
                console.error('An error has occurred while download JSON: ' + this.props.src);
                throw '';
            }
            else {
                this._onDataLoaded(JSON.parse(data));
            }
        });
    }
    _onDataLoaded(meshes) {
        this.attributes = {};
        this.indices = meshes.indices;
        this.vertices = meshes.vertices;
        this.normals = meshes.vertexNormals;
        this.uvs = meshes.textures;
        let needsUvs, needsNormals;
        if (this.uvs.length == 0) {
            needsUvs = true;
        }
        if (this.normals.length == 0) {
            needsNormals = true;
        }
        for (let i = 0; i < this.vertices.length / 3; i++) {
            if (needsUvs) {
                this.uvs.push(0, 0);
            }
            if (needsNormals) {
                this.normals.push(0, 1, 0);
            }
        }
        this.attributes['index'] = new ArrayBuffer$2(this.gl, new Uint16Array(this.indices), 1, true);
        this.attributes['position'] = new ArrayBuffer$2(this.gl, new Float32Array(this.vertices), 3, false);
        this.attributes['normal'] = new ArrayBuffer$2(this.gl, new Float32Array(this.normals), 3, false);
        this.attributes['uv'] = new ArrayBuffer$2(this.gl, new Float32Array(this.uvs), 2, false);
        // this.computeBoundingSphere();
        this.computeBoudingBox();
        this.options.onLoaded();
    }
}

class CapsuleGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 0.);
        options = Object.assign({}, {
            radius: 50,
            // Same convention as THREE.CapsuleGeometry:
            // height is the height of the middle cylinder section.
            height: 100,
            radialSegments: 32,
            capSegments: 8,
            heightSegments: 1,
            // 'solid' = triangles
            // 'wire'  = clean helper lines, no triangle diagonals
            mode: 'solid',
            // Optional aliases.
            wireframe: false,
            skipDiagonals: false,
            // Wire/helper only:
            // 'lines'     = gl.LINES
            // 'lineStrip' = one continuous gl.LINE_STRIP path
            wirePrimitive: 'lines',
            // Wire/helper only:
            // Number of horizontal rings between the two cap-base rings.
            ringCount: 0,
            // Wire/helper only:
            // 1 = one full capsule outline
            // 2 = two perpendicular capsule outlines
            // 4 = four capsule outlines
            silhouetteCount: 2,
            // Wire/helper only:
            showCapRings: true
        }, options);
        if (!gl) {
            console.warn('missing gl');
            return;
        }
        var radius = Math.max(0, options.radius);
        var height = Math.max(0, options.height);
        var radialSegments = Math.max(3, Math.floor(options.radialSegments));
        var capSegments = Math.max(1, Math.floor(options.capSegments));
        var heightSegments = Math.max(1, Math.floor(options.heightSegments));
        var ringCount = Math.max(0, Math.floor(options.ringCount));
        var silhouetteCount = Math.max(1, Math.floor(options.silhouetteCount));
        var mode = options.mode;
        if (options.wireframe || options.skipDiagonals) {
            mode = 'wire';
        }
        var wirePrimitive = options.wirePrimitive;
        var useLineStrip = mode === 'wire' && wirePrimitive === 'lineStrip';
        var vertices = [];
        var normals = [];
        var colors = [];
        var uvs = [];
        var indices = [];
        var index = 0;
        var halfHeight = height / 2;
        this.mode = mode;
        this.wirePrimitive = wirePrimitive;
        this.primitiveType = mode === 'wire'
            ? (useLineStrip ? gl.LINE_STRIP : gl.LINES)
            : gl.TRIANGLES;
        function normalizeUFromTheta(theta) {
            var twoPI = Math.PI * 2;
            return ((theta % twoPI) + twoPI) % twoPI / twoPI;
        }
        function pushVertex(x, y, z, nx, ny, nz, u, v) {
            var normal = fromValues$5(nx, ny, nz);
            if (normal[0] === 0 && normal[1] === 0 && normal[2] === 0) {
                normal[1] = 1;
            }
            normalize$3(normal, normal);
            vertices.push(x, y, z);
            normals.push(normal[0], normal[1], normal[2]);
            colors.push(1, 1, 1);
            uvs.push(u, v);
            return index++;
        }
        function getProfileAtVerticalIndex(iy, numVerticalSegments) {
            var profileY = 0;
            var profileRadius = 0;
            var normalYComponent = 0;
            if (iy <= capSegments) {
                // Bottom cap
                var bottomProgress = iy / capSegments;
                var bottomAngle = bottomProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(bottomAngle);
                profileRadius = radius * Math.sin(bottomAngle);
                normalYComponent = -radius * Math.cos(bottomAngle);
            }
            else if (iy <= capSegments + heightSegments) {
                // Cylinder body
                var middleProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + middleProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
            }
            else {
                // Top cap
                var topProgress = (iy - capSegments - heightSegments) / capSegments;
                var topAngle = topProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(topAngle);
                profileRadius = radius * Math.cos(topAngle);
                normalYComponent = radius * Math.sin(topAngle);
            }
            return {
                y: profileY,
                radius: profileRadius,
                normalY: normalYComponent,
                v: iy / numVerticalSegments
            };
        }
        function addProfileVertex(profile, theta, u) {
            var sinTheta = Math.sin(theta);
            var cosTheta = Math.cos(theta);
            var x = -profile.radius * cosTheta;
            var y = profile.y;
            var z = profile.radius * sinTheta;
            return pushVertex(x, y, z, -profile.radius * cosTheta, profile.normalY, profile.radius * sinTheta, u, profile.v);
        }
        // ---------------------------------------------------------------------
        // SOLID MODE
        // ---------------------------------------------------------------------
        if (mode === 'solid') {
            var solidRows = [];
            var numVerticalSegments = capSegments * 2 + heightSegments;
            for (var iy = 0; iy <= numVerticalSegments; iy++) {
                var row = [];
                var profile = getProfileAtVerticalIndex(iy, numVerticalSegments);
                for (var ix = 0; ix <= radialSegments; ix++) {
                    var u = ix / radialSegments;
                    var theta = u * Math.PI * 2;
                    row.push(addProfileVertex(profile, theta, u));
                }
                solidRows.push(row);
            }
            for (var y = 1; y <= numVerticalSegments; y++) {
                var prevRow = solidRows[y - 1];
                var currRow = solidRows[y];
                for (var x = 0; x < radialSegments; x++) {
                    var i1 = prevRow[x];
                    var i2 = prevRow[x + 1];
                    var i3 = currRow[x];
                    var i4 = currRow[x + 1];
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // ---------------------------------------------------------------------
        // WIRE / HELPER MODE
        // ---------------------------------------------------------------------
        else {
            var totalCapsuleHeight = height + radius * 2;
            function capsuleV(y) {
                return 1 - ((y + totalCapsuleHeight / 2) / totalCapsuleHeight);
            }
            function addLine(a, b) {
                indices.push(a, b);
            }
            function addRingVertex(y, ringRadius, normalY, theta) {
                var u = normalizeUFromTheta(theta);
                var sinTheta = Math.sin(theta);
                var cosTheta = Math.cos(theta);
                var x = -ringRadius * cosTheta;
                var z = ringRadius * sinTheta;
                return pushVertex(x, y, z, -ringRadius * cosTheta, normalY, ringRadius * sinTheta, u, capsuleV(y));
            }
            function addProfileVertexAtTheta(iy, theta, numVerticalSegments) {
                var profile = getProfileAtVerticalIndex(iy, numVerticalSegments);
                return addProfileVertex(profile, theta, normalizeUFromTheta(theta));
            }
            function addRingLines(y, ringRadius, normalY) {
                var row = [];
                for (var ix = 0; ix <= radialSegments; ix++) {
                    var theta = (ix / radialSegments) * Math.PI * 2;
                    row.push(addRingVertex(y, ringRadius, normalY, theta));
                }
                for (var i = 0; i < radialSegments; i++) {
                    addLine(row[i], row[i + 1]);
                }
                return row;
            }
            function addMeridianLines(theta) {
                var previous = null;
                var numVerticalSegments = capSegments * 2 + heightSegments;
                for (var iy = 0; iy <= numVerticalSegments; iy++) {
                    var current = addProfileVertexAtTheta(iy, theta, numVerticalSegments);
                    if (previous !== null) {
                        addLine(previous, current);
                    }
                    previous = current;
                }
            }
            function addFullSilhouetteLines(theta) {
                addMeridianLines(theta);
                addMeridianLines(theta + Math.PI);
            }
            function shouldDrawRingAtVerticalIndex(iy, numVerticalSegments) {
                if (!options.showCapRings) {
                    return false;
                }
                // Cap-base rings.
                if (iy === capSegments || iy === capSegments + heightSegments) {
                    return true;
                }
                // Optional rings inside the cylinder.
                // This only triggers if heightSegments has enough subdivisions.
                if (ringCount > 0 && iy > capSegments && iy < capSegments + heightSegments) {
                    var cylinderStep = iy - capSegments;
                    var t = cylinderStep / heightSegments;
                    var wantedStep = t * (ringCount + 1);
                    var nearest = Math.round(wantedStep);
                    return nearest >= 1 &&
                        nearest <= ringCount &&
                        Math.abs(wantedStep - nearest) < 0.00001;
                }
                return false;
            }
            // -----------------------------------------------------------------
            // gl.LINES path
            // -----------------------------------------------------------------
            if (!useLineStrip) {
                if (options.showCapRings) {
                    addRingLines(-halfHeight, radius, 0);
                    addRingLines(halfHeight, radius, 0);
                }
                for (var r = 1; r <= ringCount; r++) {
                    var t = r / (ringCount + 1);
                    var ringY = -halfHeight + t * height;
                    addRingLines(ringY, radius, 0);
                }
                for (var silhouette = 0; silhouette < silhouetteCount; silhouette++) {
                    var silhouetteTheta = (silhouette / silhouetteCount) * Math.PI;
                    addFullSilhouetteLines(silhouetteTheta);
                }
            }
            // -----------------------------------------------------------------
            // Single gl.LINE_STRIP path
            // -----------------------------------------------------------------
            else {
                var lineStripVerticalSegments = capSegments * 2 + heightSegments;
                function addStripRingFromPoint(y, ringRadius, normalY, startTheta) {
                    // The strip is already at the start point on the ring.
                    // Walk around the full circle and return to the same point.
                    for (var ix = 1; ix <= radialSegments; ix++) {
                        var theta = startTheta + (ix / radialSegments) * Math.PI * 2;
                        indices.push(addRingVertex(y, ringRadius, normalY, theta));
                    }
                }
                function addStripMeridianPoint(iy, theta) {
                    indices.push(addProfileVertexAtTheta(iy, theta, lineStripVerticalSegments));
                }
                function addStripRingsIfNeededAt(iy, theta) {
                    if (!shouldDrawRingAtVerticalIndex(iy)) {
                        return;
                    }
                    var profile = getProfileAtVerticalIndex(iy, lineStripVerticalSegments);
                    // Current point is already on the ring.
                    // Draw the full ring and return to that same point.
                    addStripRingFromPoint(profile.y, profile.radius, profile.normalY, theta);
                }
                // First silhouette carries the rings.
                var firstTheta = 0;
                var oppositeTheta = firstTheta + Math.PI;
                // Start at top pole.
                addStripMeridianPoint(lineStripVerticalSegments, firstTheta);
                // Go from top pole down to bottom pole.
                for (var iyDown = lineStripVerticalSegments - 1; iyDown >= 0; iyDown--) {
                    addStripMeridianPoint(iyDown, firstTheta);
                    addStripRingsIfNeededAt(iyDown, firstTheta);
                }
                // Go back up on the opposite side.
                // At bottom pole, both sides share the same position.
                for (var iyUp = 1; iyUp <= lineStripVerticalSegments; iyUp++) {
                    addStripMeridianPoint(iyUp, oppositeTheta);
                }
                // Extra silhouettes.
                // Each starts and ends at the top pole, so the bridge is invisible.
                for (var extraSilhouette = 1; extraSilhouette < silhouetteCount; extraSilhouette++) {
                    var thetaA = (extraSilhouette / silhouetteCount) * Math.PI;
                    var thetaB = thetaA + Math.PI;
                    // Same top pole position, different theta.
                    addStripMeridianPoint(lineStripVerticalSegments, thetaA);
                    for (var down = lineStripVerticalSegments - 1; down >= 0; down--) {
                        addStripMeridianPoint(down, thetaA);
                    }
                    // Same bottom pole position, switch to opposite side.
                    addStripMeridianPoint(0, thetaB);
                    for (var up = 1; up <= lineStripVerticalSegments; up++) {
                        addStripMeridianPoint(up, thetaB);
                    }
                }
            }
        }
        this.length = vertices.length / 3;
        this.indexCount = indices.length;
        this.setIndices(new Uint16Array(indices));
        this.setAttribute('position', new Float32Array(vertices), 3);
        this.setAttribute('normal', new Float32Array(normals), 3);
        this.setAttribute('color', new Float32Array(colors), 3);
        this.setAttribute('uv', new Float32Array(uvs), 2);
    }
}

class ConeGeometryBuffer extends GeometryBuffer {
    constructor(gl, options = {}) {
        super(gl, 0.);
        options = Object.assign({
            radialSegments: 32,
            openEnded: false,
            thetaStart: 0,
            thetaLength: Math.PI * 2
        }, options);
        if (!gl) {
            console.warn('missing gl');
            return;
        }
        const radialSegments = Math.max(3, Math.floor(options.radialSegments));
        const thetaStart = options.thetaStart;
        const thetaLength = options.thetaLength;
        const openEnded = options.openEnded;
        const vertices = [];
        const normals = [];
        const colors = [];
        const uvs = [];
        const indices = [];
        // apex ring, duplicated per segment for UV/seam compatibility
        const apexRow = [];
        const baseRow = [];
        let index = 0;
        for (let x = 0; x <= radialSegments; x++) {
            const u = x / radialSegments;
            const theta = thetaStart + u * thetaLength;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // apex at local origin
            vertices.push(0, 0, 0);
            // side normal for unit cone: radius = 1, height = 1
            // Approx normal direction: [h * sin, r, h * cos] => [sin, 1, cos]
            let nx = sinTheta;
            let ny = 1;
            let nz = cosTheta;
            const invLen = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
            nx *= invLen;
            ny *= invLen;
            nz *= invLen;
            normals.push(nx, ny, nz);
            colors.push(1, 1, 1);
            uvs.push(u, 1);
            apexRow.push(index++);
            // base at y = -1, radius = 1
            vertices.push(sinTheta, cosTheta, -1);
            normals.push(nx, ny, nz);
            colors.push(1, 1, 1);
            uvs.push(u, 0);
            baseRow.push(index++);
        }
        // side triangles
        // for (let x = 0; x < radialSegments; x++) {
        //     const a = apexRow[x];
        //     const b = baseRow[x];
        //     const c = baseRow[x + 1];
        //     const d = apexRow[x + 1];
        //     indices.push(a, b, d);
        //     indices.push(b, c, d);
        // }
        // side triangles
        for (let x = 0; x < radialSegments; x++) {
            const a = apexRow[x];
            const b = baseRow[x];
            const c = baseRow[x + 1];
            const d = apexRow[x + 1];
            indices.push(a, d, b);
            indices.push(b, d, c);
        }
        // bottom cap
        if (!openEnded) {
            const centerIndex = index++;
            vertices.push(0, 0, -1);
            normals.push(0, 0, -1);
            colors.push(1, 1, 1);
            uvs.push(0.5, 0.5);
            // for (let x = 0; x < radialSegments; x++) {
            //     const i1 = baseRow[x];
            //     const i2 = baseRow[x + 1];
            //     indices.push(centerIndex, i2, i1);
            // }
            for (let x = 0; x < radialSegments; x++) {
                const i1 = baseRow[x];
                const i2 = baseRow[x + 1];
                indices.push(centerIndex, i1, i2);
            }
        }
        this.length = vertices.length / 3;
        this.setIndices(new Uint16Array(indices));
        this.setAttribute('position', new Float32Array(vertices), 3);
        this.setAttribute('normal', new Float32Array(normals), 3);
        this.setAttribute('color', new Float32Array(colors), 3);
        this.setAttribute('uv', new Float32Array(uvs), 2);
    }
}

class Composer {
    constructor(renderer) {
        this.renderer = renderer;
        this.passes = [];
        this.camera = new Camera({
            left: -1 / 2,
            right: 1 / 2,
            top: 1 / 2,
            bottom: -1 / 2,
            near: 1,
            far: 4000.0,
            type: 'ortho',
            orbitControl: false,
            lookAt: [0, 0, 100],
            position: [0, 0, -100]
        });
        this.camera.updateMatrices();
        this.camera.updateProjectionMatrix();
        this.bufferScene = new Scene();
        this.bufferPlane = new Mesh();
        this.bufferPlane.geometry = new BoxGeometryBuffer(renderer.gl, { width: 1, height: 1, depth: 1 });
        this.bufferScene.add(this.bufferPlane);
        this.frameBufferWrite = new FrameBuffer(renderer.gl, {
            width: 1,
            height: 1,
            type: renderer.gl.HALF_FLOAT,
            linear: true,
        });
        this.frameBufferRead = new FrameBuffer(renderer.gl, {
            width: 1,
            height: 1,
            type: renderer.gl.HALF_FLOAT,
            linear: true,
        });
        this.uniforms = {};
    }
    setUniform(key, value) {
        this.uniforms[key] = value;
    }
    addPass(pass) {
        this.passes.push(pass);
    }
    resize(w, h) {
        this.camera.left = -w / 2;
        this.camera.right = w / 2;
        this.camera.top = h / 2;
        this.camera.bottom = -h / 2;
        this.camera.updateMatrices();
        this.camera.updateProjectionMatrix();
        this.bufferPlane.scale[0] = w;
        this.bufferPlane.scale[1] = h;
        this.resolution = [w, h];
        this.passes?.forEach(pass => {
            pass?.resize(w, h);
        });
        this.frameBufferRead?.resize(w, h);
        this.frameBufferWrite?.resize(w, h);
    }
    setScene(scene) {
        this.scene = scene;
        this.scene.WITH_POST_PROCESS = 1;
    }
    render(input, output) {
        let hasRenderedAnyPass = false;
        this.passes?.forEach((pass, passIndex) => {
            if (pass.material) {
                for (let k in this.uniforms) {
                    pass.material?.setUniform(k, this.uniforms[k]);
                }
                if (this.scene) {
                    for (let u in this.scene.uniforms) {
                        pass.material?.setUniform(u, this.scene.uniforms[u]);
                    }
                    for (let d in this.scene.defines) {
                        pass.material?.setDefine(d, this.scene.defines[d]);
                    }
                }
            }
            const isLastPass = passIndex == this.passes.length - 1;
            if (pass.enabled) {
                pass?.render(!hasRenderedAnyPass ? input : this.frameBufferRead, isLastPass ? output : this.frameBufferWrite);
                if (!isLastPass) {
                    let tmp = this.frameBufferRead;
                    this.frameBufferRead = this.frameBufferWrite;
                    this.frameBufferWrite = tmp;
                }
                hasRenderedAnyPass = true;
            }
        });
    }
}

class Pass {
    constructor(renderer) {
        this.renderer = renderer;
        this.camera = new Camera({
            left: -1 / 2,
            right: 1 / 2,
            top: 1 / 2,
            bottom: -1 / 2,
            near: 1,
            far: 4000.0,
            type: 'ortho',
            orbitControl: false,
            lookAt: [0, 0, 100],
            position: [0, 0, -100]
        });
        this.camera.updateMatrices();
        this.camera.updateProjectionMatrix();
        this.scene = new Scene();
        this.plane = new Mesh();
        this.plane.geometry = new BoxGeometryBuffer(renderer.gl, { width: 1, height: 1, depth: 1 });
        this.scene.add(this.plane);
        this.enabled = true;
    }
    resize(w, h) {
        this.camera.left = -w / 2;
        this.camera.right = w / 2;
        this.camera.top = h / 2;
        this.camera.bottom = -h / 2;
        this.camera.updateMatrices();
        this.camera.updateProjectionMatrix();
        this.plane.scale[0] = w;
        this.plane.scale[1] = h;
        this.resolution = [w, h];
    }
    render(output) {
        this.plane.material = this.material;
        this.renderer.render(this.scene, this.camera, output);
    }
}

const settings = {
    exposure: 1,
    useGammaCorrection: true,
    useExposure: false,
    useToneMapping: false,
    toneMappingExposure: 1.4,
    toneMappingMethod: 14,
};
class OutputRenderPass extends Pass {
    constructor(renderer, options) {
        super(renderer);
        this.material = new Program$1(this.renderer.gl, {
            vertexShader: /*glsl*/ `
                #version 300 es
                precision highp float;
                precision highp int;
                in vec2 uv;
                in vec3 position;
                uniform mat4 uPMatrix;
                uniform mat4 uMVMatrix;
                out vec2 vUv;
                void main(void) {
                    vUv = uv;
                    gl_Position = uPMatrix * uMVMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: /*glsl*/ `
                #version 300 es
                precision highp float;
                in vec2 vUv;
                out vec4 fragColor;
                uniform sampler2D tInput;

                uniform int useExposure;
                uniform float uExposure;

                uniform int useGammaCorrection;

                uniform int useToneMapping;
                uniform float uToneMappingExposure;
                //  Baking Lab by MJP and David Neubelt
                //  http://mynameismjp.wordpress.com/
                //  All code licensed under the MIT license
                // The code in this file was originally written by Stephen Hill (@self_shadow), who deserves all
                // credit for coming up with this fit and implementing it. Buy him a beer next time you see him. :)
                vec3 RRTAndODTFit(vec3 v) {
                    vec3 a = v * (v + 0.0245786) - 0.000090537;
                    vec3 b = v * (0.983729 * v + 0.4329510) + 0.238081;
                    return a / b;
                }
                vec3 ACESFitted(vec3 color) {
                    mat3 ACESInputMat = mat3(
                        0.59719, 0.07600, 0.02840,
                        0.35458, 0.90834, 0.13383,
                        0.04823, 0.01566, 0.83777
                    );
                    mat3 ACESOutputMat = mat3 (
                        1.60475, -0.10208, -0.00327,
                        -0.53108, 1.10813, -0.07276,
                        -0.07367, -0.00605, 1.07602
                    );
                    color = ACESInputMat * color;
                    color = RRTAndODTFit(color);
                    color = ACESOutputMat * color;
                    color = clamp(color, 0., 1.);
                    return color;
                }
                
                void main() {
                    
                    fragColor = texture( tInput, vUv );

                    if (useExposure == 1) {
                        fragColor.rgb *= uExposure;
                    }

                    if (useToneMapping == 1) {
                        fragColor.rgb = ACESFitted( fragColor.rgb) * uToneMappingExposure;
                    }

                    if (useGammaCorrection == 1) {
                        fragColor.rgb  = pow( fragColor.rgb , vec3(1.0 / 2.2)) ;  
                    }

                }
            `,
        });
        this.useExposure = settings.useExposure;
        this.exposure = settings.exposure;
        this.useGammaCorrection = settings.useGammaCorrection;
        this.useToneMapping = settings.useToneMapping;
        this.toneMappingExposure = settings.toneMappingExposure;
        this.toneMappingMethod = settings.toneMappingMethod;
    }
    render(input, output) {
        this.renderer.clearColor(0, 0, 0, 1);
        this.renderer.clear();
        this.material.setUniform('tInput', input);
        this.material.setUniform('useExposure', this.useExposure ? 1 : 0);
        this.material.setUniform('uExposure', this.exposure);
        this.material.setUniform('useToneMapping', this.useToneMapping);
        this.material.setUniform('uToneMappingMethod', this.toneMappingMethod);
        this.material.setUniform('uToneMappingExposure', this.toneMappingExposure);
        this.material.setUniform('useGammaCorrection', this.useGammaCorrection ? 1 : 0);
        super.render(output);
    }
}

/*
 * GPU compressed-texture capability detection and target-format selection.
 *
 * Every texture in this engine currently uploads through WebGLTexture.bindImage()
 * as gl.RGBA, so an RGBA8 texture costs width*height*4 bytes in VRAM plus a third
 * again for the mip chain, regardless of how small its WebP download was. Measured
 * on the AIRoom scene: 959 live textures, 1051 MB, 0% compressed.
 *
 * GPU-native block compression fixes that at the only place it matters — the
 * allocation. BC7 and BC1 are 4:1 and 8:1 against RGBA8 and stay compressed in
 * memory, so the same 1051 MB lands at roughly 260 MB.
 *
 * This module answers two questions and nothing else:
 *   1. which block formats can this device actually sample (detect)
 *   2. which one should a given texture use (chooseFormat)
 *
 * It deliberately does no transcoding and no uploading. The KTX2/Basis transcoder
 * and the compressedTexImage2D upload path are separate pieces; see
 * TEXTURE-PIPELINE.md in the AIRoom project for how they fit together.
 */
/*
 * How a texture is used, which is what decides its format. This matters more than
 * it looks: encoding a normal map the same way as an albedo map produces visible
 * artifacts, because ETC1S-style encoders decorrelate RGB in a way that destroys
 * the independence of the X and Y channels a normal map needs.
 */
const TextureUsage = {
    COLOR: 'color',
    NORMAL: 'normal',
    MASK: 'mask',
    HDR: 'hdr', // radiance, lightmaps, probe cubemaps
};
/*
 * Detect once per GL context. Extension objects carry the format enums, and the
 * enums are only valid on the context that produced them, so the result is cached
 * against the context rather than globally.
 */
const cache = new WeakMap();
function detectTextureFormats(gl) {
    if (!gl) {
        return null;
    }
    if (cache.has(gl)) {
        return cache.get(gl);
    }
    const get = name => gl.getExtension(name);
    const s3tc = get('WEBGL_compressed_texture_s3tc');
    const s3tcSRGB = get('WEBGL_compressed_texture_s3tc_srgb');
    const bptc = get('EXT_texture_compression_bptc');
    const rgtc = get('EXT_texture_compression_rgtc');
    const astc = get('WEBGL_compressed_texture_astc');
    const etc = get('WEBGL_compressed_texture_etc');
    const pvrtc = get('WEBGL_compressed_texture_pvrtc');
    const support = {
        // Desktop: BC. bptc is BC6H/BC7, rgtc is BC4/BC5, s3tc is BC1/BC2/BC3.
        bc7: !!bptc,
        bc6h: !!bptc,
        bc5: !!rgtc,
        bc4: !!rgtc,
        bc1: !!s3tc,
        bc3: !!s3tc,
        bc1SRGB: !!s3tcSRGB,
        // Mobile.
        astc: !!astc,
        etc2: !!etc,
        pvrtc: !!pvrtc,
        any: !!(bptc || rgtc || s3tc || astc || etc || pvrtc),
        enums: {
            BC1: s3tc?.COMPRESSED_RGB_S3TC_DXT1_EXT,
            BC1_A: s3tc?.COMPRESSED_RGBA_S3TC_DXT1_EXT,
            BC3: s3tc?.COMPRESSED_RGBA_S3TC_DXT5_EXT,
            BC1_SRGB: s3tcSRGB?.COMPRESSED_SRGB_S3TC_DXT1_EXT,
            BC3_SRGB: s3tcSRGB?.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT,
            BC4: rgtc?.COMPRESSED_RED_RGTC1_EXT,
            BC5: rgtc?.COMPRESSED_RED_GREEN_RGTC2_EXT,
            BC6H: bptc?.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
            BC7: bptc?.COMPRESSED_RGBA_BPTC_UNORM_EXT,
            BC7_SRGB: bptc?.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT,
            ASTC_4x4: astc?.COMPRESSED_RGBA_ASTC_4x4_KHR,
            ASTC_4x4_SRGB: astc?.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
            ASTC_6x6: astc?.COMPRESSED_RGBA_ASTC_6x6_KHR,
            ETC2_RGB: etc?.COMPRESSED_RGB8_ETC2,
            ETC2_RGBA: etc?.COMPRESSED_RGBA8_ETC2_EAC,
            ETC2_RG: etc?.COMPRESSED_RG11_EAC,
        },
    };
    cache.set(gl, support);
    return support;
}
/*
 * Bits per pixel of a block format, for VRAM accounting. BC1/ETC2-RGB and the
 * 8x8-block ASTC modes are 4 bpp; BC3/BC5/BC7/ASTC-4x4/ETC2-RGBA are 8 bpp.
 * Uncompressed RGBA8 is 32 bpp, which is the number these are competing with.
 */
const BITS_PER_PIXEL = {
    BC1: 4, BC1_A: 4, BC1_SRGB: 4,
    BC3: 8, BC3_SRGB: 8, BC4: 4, BC5: 8, BC6H: 8, BC7: 8, BC7_SRGB: 8,
    ASTC_4x4: 8, ASTC_4x4_SRGB: 8, ASTC_6x6: 3.56,
    ETC2_RGB: 4, ETC2_RGBA: 8, ETC2_RG: 8,
    RGBA8: 32,
};
function bitsPerPixel(formatName) {
    return BITS_PER_PIXEL[formatName] ?? 32;
}
/*
 * Estimate VRAM for a texture, including the mip chain (which adds ~1/3) and cube
 * faces. Block formats round dimensions up to the block size, which matters for
 * small mips — a 1x1 mip of a BC format still costs a whole 4x4 block.
 */
function estimateTextureBytes({ width, height, formatName = 'RGBA8', mipmaps = true, faces = 1 }) {
    const bpp = bitsPerPixel(formatName);
    const blockAligned = bpp < 32;
    let bytes = 0;
    let w = width, h = height;
    do {
        const aw = blockAligned ? Math.max(4, Math.ceil(w / 4) * 4) : w;
        const ah = blockAligned ? Math.max(4, Math.ceil(h / 4) * 4) : h;
        bytes += (aw * ah * bpp) / 8;
        w = Math.max(1, w >> 1);
        h = Math.max(1, h >> 1);
    } while (mipmaps && (w > 1 || h > 1));
    return bytes * faces;
}
/*
 * Pick a target format for a texture given how it is used.
 *
 * Ordering rationale, desktop first:
 *  - COLOR  prefers BC7 for quality, falls back to BC3 when alpha is meaningful
 *           and BC1 when it is not. BC1 is 8:1 and perfectly adequate for the
 *           opaque albedo that dominates this scene.
 *  - NORMAL prefers BC5, which stores two independent channels at 8 bpp and
 *           reconstructs Z in the shader. This is the case where using a colour
 *           format produces obvious artifacts.
 *  - MASK   prefers BC7 when several packed channels must survive independently,
 *           BC4 when it is genuinely single-channel.
 *  - HDR    prefers BC6H. There is no BC6H equivalent on mobile, so mobile keeps
 *           whatever encoding the source uses (RGBM here) rather than pretending.
 *
 * Returns null when nothing suitable exists, which callers must treat as "upload
 * uncompressed" rather than as an error — a device without block compression must
 * still render.
 */
function chooseFormat(support, usage, { hasAlpha = false, srgb = false, singleChannel = false } = {}) {
    if (!support?.any) {
        return null;
    }
    const e = support.enums;
    const pick = (name, format) => (format != null ? { name, format } : null);
    switch (usage) {
        case TextureUsage.NORMAL:
            return pick('BC5', e.BC5)
                ?? pick('ASTC_4x4', e.ASTC_4x4)
                ?? pick('ETC2_RG', e.ETC2_RG)
                ?? pick('BC3', e.BC3)
                ?? null;
        case TextureUsage.MASK:
            if (singleChannel) {
                const bc4 = pick('BC4', e.BC4);
                if (bc4) {
                    return bc4;
                }
            }
            return pick('BC7', e.BC7)
                ?? pick('ASTC_4x4', e.ASTC_4x4)
                ?? pick('ETC2_RGBA', e.ETC2_RGBA)
                ?? pick('BC3', e.BC3)
                ?? null;
        case TextureUsage.HDR:
            return pick('BC6H', e.BC6H) ?? null;
        case TextureUsage.COLOR:
        default:
            if (srgb) {
                const srgbPick = pick('BC7_SRGB', e.BC7_SRGB)
                    ?? pick('ASTC_4x4_SRGB', e.ASTC_4x4_SRGB)
                    ?? (hasAlpha ? pick('BC3_SRGB', e.BC3_SRGB) : pick('BC1_SRGB', e.BC1_SRGB));
                if (srgbPick) {
                    return srgbPick;
                }
            }
            return pick('BC7', e.BC7)
                ?? pick('ASTC_4x4', e.ASTC_4x4)
                ?? (hasAlpha
                    ? (pick('BC3', e.BC3) ?? pick('ETC2_RGBA', e.ETC2_RGBA))
                    : (pick('BC1', e.BC1) ?? pick('ETC2_RGB', e.ETC2_RGB)))
                ?? null;
    }
}
/*
 * Which Basis transcode target corresponds to a chosen format. The transcoder is
 * told what the GPU wants, not what the file contains — a single UASTC or ETC1S
 * file transcodes to whichever of these the device supports, which is the whole
 * point of shipping KTX2 rather than per-platform texture sets.
 *
 * Names match the basis_universal transcoder's cTFxxx enum suffixes.
 */
function basisTargetFor(formatName) {
    switch (formatName) {
        case 'BC7':
        case 'BC7_SRGB': return 'BC7_RGBA';
        case 'BC3':
        case 'BC3_SRGB': return 'BC3_RGBA';
        case 'BC1':
        case 'BC1_A':
        case 'BC1_SRGB': return 'BC1_RGB';
        case 'BC5': return 'BC5_RG';
        case 'BC4': return 'BC4_R';
        case 'ASTC_4x4':
        case 'ASTC_4x4_SRGB': return 'ASTC_4x4_RGBA';
        case 'ETC2_RGBA': return 'ETC2_RGBA';
        case 'ETC2_RGB': return 'ETC1_RGB';
        default: return 'RGBA32'; // uncompressed fallback
    }
}
/*
 * Human-readable capability line, for the perf overlay and for diagnosing "why is
 * this device not using compressed textures".
 */
function describeTextureSupport(support) {
    if (!support) {
        return 'no GL context';
    }
    if (!support.any) {
        return 'none (textures will upload as RGBA8)';
    }
    const have = [];
    if (support.bc7)
        have.push('BC7');
    if (support.bc6h)
        have.push('BC6H');
    if (support.bc5)
        have.push('BC5');
    if (support.bc1)
        have.push('BC1/BC3');
    if (support.astc)
        have.push('ASTC');
    if (support.etc2)
        have.push('ETC2');
    if (support.pvrtc)
        have.push('PVRTC');
    return have.join(', ');
}

/**
 * Core
*/
console.log(`%c Beam %c v${"2.3.3"} `, "color: #fff; background: #ff0036; padding:5px 0;", "color: #000; background: #f7f7f5; padding:5px 0;");

export { AmbientLight, ArrayBuffer$2 as ArrayBuffer, BaseObject, BoxGeometryBuffer, Camera, CapsuleGeometryBuffer, CircleGeometryBuffer, Composer, ConeGeometryBuffer, Constants, Container, CubeTexture, CylinderGeometryBuffer, DepthTexture, DirectionalLight, DirectionalLightHelper, FrameBuffer, Frustum, GeometryBuffer, GraphicsDevice, PlaneGeometryBuffer as GridGeometryBuffer, HDRTexture, Helper, JSONGeometryBuffer, Light, Material, MemoryManager, Mesh, ObjGeometryBuffer, Object3d, OutputRenderPass, Pass, PlaneGeometryBuffer$1 as PlaneGeometryBuffer, PointLight, PointLightHelper, Program$1 as Program, Quaternion, parse as RGBEParser, RectLight, RectLightHelper, Renderer, Scene, SphereGeometryBuffer, SpotLight, SpotLightHelper, Supercompression, Texture, TextureUsage, TransformHelper, TriangleGeometryBuffer, UIMaterial, Vector3, applyMat4, basisTargetFor, beginFrame, beginPass, bitsPerPixel, blockBytes, chooseFormat, describeTextureSupport, detectTextureFormats, estimateTextureBytes, generateUUID, getFrameGeneration, getPassGeneration, getProperties, hexToRgb, mat2, mat3, mat4, nestedEach, parseKTX2, property, quat, setUniform, vec2, vec3, vec4, webglInternalFormat };
